var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import chevronRight from "./assets/chevron-right.svg";
import vision from "./assets/vision.svg";
import searchIcon from "./assets/search.svg";
import iconSearchEmpty from "./assets/icon-search-empty.png";
import closeIcon from "./assets/close.svg";
import infoIcon from "./assets/circle-info-icon.svg";
import walletImage from "./assets/wallet-landing_wallet.svg";
import cardLeagueIcon from "./assets/card-league-icon.png";
import documentIcon from "./assets/document-icon.png";
import pencilIcon from "./assets/pencil-icon.png";
import rightArrow from "./assets/right-arrow.png";
import caretUp from "./assets/caret-up.svg";
import caretDown from "./assets/caret-down.svg";
import calendar from "./assets/calendar.svg";
import accident from "./assets/accident.svg";
import criticalIllness from "./assets/critical_illness.svg";
import dental from "./assets/dental.svg";
import drug from "./assets/drug.svg";
import home from "./assets/home.svg";
import life from "./assets/life.svg";
import longTermDisability from "./assets/long_term_disability.svg";
import medical from "./assets/medical.svg";
import pet from "./assets/pet.svg";
import placeholder from "./assets/placeholder.svg";
import rewards from "./assets/rewards.svg";
import shortTermDisability from "./assets/short_term_disability.svg";
import spendingAccounts from "./assets/spending_accounts.svg";
import creditCard from "./assets/credit_card.svg";
import wellnessAccounts from "./assets/wellness_accounts.svg";
import clockIconBlurple from "./assets/clock-blurple.svg";
import clockIconWhite from "./assets/clock-white.svg";
import orderNewCardSuccess from "./assets/order-new-card-success.svg";
import orderNewCardError from "./assets/order-new-card-error.svg";
import leaveOrExitWarning from "./assets/leaveOrExitWarning.svg";
var WALLET_ASSETS = {
  CHEVRON_RIGHT: chevronRight,
  VISION: vision,
  SEARCH_ICON: searchIcon,
  ICON_SEARCH_EMPTY: iconSearchEmpty,
  CLOSE_ICON: closeIcon,
  INFO_ICON: infoIcon,
  WALLET_IMAGE: walletImage,
  CARD_LEAGUE_ICON: cardLeagueIcon,
  DOCUMENT_ICON: documentIcon,
  PENCIL_ICON: pencilIcon,
  RIGHT_ARROW: rightArrow,
  CARET_UP: caretUp,
  CARET_DOWN: caretDown,
  CALENDAR: calendar,
  ACCIDENT: accident,
  CRITICAL_ILLNESS: criticalIllness,
  DENTAL: dental,
  DRUG: drug,
  HOME: home,
  LIFE: life,
  LONG_TERM_DISABILITY: longTermDisability,
  MEDICAL: medical,
  PET: pet,
  PLACEHOLDER: placeholder,
  REWARDS: rewards,
  SHORT_TERM_DISABILITY: shortTermDisability,
  SPENDING_ACCOUNTS: spendingAccounts,
  CREDIT_CARD: creditCard,
  WELLNESS_ACCOUNTS: wellnessAccounts,
  CLOCK_ICON_BLURPLE: clockIconBlurple,
  CLOCK_ICON_WHITE: clockIconWhite,
  CLAIMS_ENTRY: dental,
  ORDER_NEW_CARD_SUCCESS: orderNewCardSuccess,
  ORDER_NEW_CARD_ERROR: orderNewCardError,
  LEAVE_OR_EXIT_WARNING: leaveOrExitWarning
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(WALLET_ASSETS);
};

// src/hooks/queries/use-wallet-query.hook.ts
import { useQuery } from "@tanstack/react-query";
import {
  getWallet,
  GET_WALLET_MESSAGE_TYPE
} from "@leagueplatform/wallet-api";
function useWalletQuery(userId, options) {
  return useQuery(
    [GET_WALLET_MESSAGE_TYPE, userId],
    () => getWallet(userId),
    options
  );
}

// src/components/wallet-card/wallet-card.component.tsx
import React24, { useRef as useRef3 } from "react";
import { Box as Box14, Image as Image4 } from "@leagueplatform/genesis-commons";
import { StackLayout as StackLayout10 } from "@leagueplatform/web-common-components";

// src/components/member-selector-context/member-selector-context.tsx
import { useGetUserProfile } from "@leagueplatform/web-common";
import * as React from "react";
var MemberSelectorContext = React.createContext([void 0, () => {
}]);
function MemberSelectorProvider({
  children
}) {
  const selectedMemberState = React.useState(
    void 0
  );
  return /* @__PURE__ */ React.createElement(MemberSelectorContext.Provider, { value: selectedMemberState }, children);
}
function useSelectedMember() {
  const [value, setValue] = React.useContext(MemberSelectorContext);
  const setUser = React.useCallback(
    (user) => {
      setValue(user);
    },
    [setValue]
  );
  useGetUserProfile({
    enabled: !value,
    onSuccess: (userData) => {
      var _a, _b;
      if (!value) {
        setValue({
          id: void 0,
          name: `${(_a = userData.userProfile) == null ? void 0 : _a.firstName} ${(_b = userData.userProfile) == null ? void 0 : _b.lastName}`
        });
      }
    }
  });
  return [value, setUser];
}

// src/hooks/use-wallet-params.hook.ts
import { useParamsLegacy as useParams } from "@leagueplatform/routing";
function useWalletParams() {
  return useParams();
}

// src/pages/wallet-detail/utils/select-card-html.util.ts
import DOMPurify from "dompurify";
var LEAGUE_STATIC_URL_REGEX = /https:\/\/app\.league\.com\/static/g;
var updateCardHtmlUrls = (html) => {
  if (!html) {
    console.error("HTML is required");
    return void 0;
  }
  return html.replace(LEAGUE_STATIC_URL_REGEX, "/static");
};
var formatCardHtmlFace = (htmlString) => {
  if (!htmlString) {
    return void 0;
  }
  return {
    description: "",
    src: DOMPurify.sanitize(htmlString, {
      FORCE_BODY: true,
      ALLOWED_ATTR: ["class", "style", "role"]
    }),
    type: "html"
  };
};
var selectCardHtml = (data) => {
  var _a, _b, _c, _d;
  const dependentCardHtml = (_a = data.rendered_template) == null ? void 0 : _a.front;
  const primaryMemberCardHtml = (_b = data.card_images) == null ? void 0 : _b.front.src;
  const primaryMemberBackCardHtml = (_d = (_c = data.card_images) == null ? void 0 : _c.back) == null ? void 0 : _d.src;
  const validHtml = primaryMemberCardHtml != null ? primaryMemberCardHtml : dependentCardHtml;
  const front = formatCardHtmlFace(updateCardHtmlUrls(validHtml != null ? validHtml : ""));
  const back = formatCardHtmlFace(
    updateCardHtmlUrls(primaryMemberBackCardHtml != null ? primaryMemberBackCardHtml : "")
  );
  if (!front) {
    return null;
  }
  return {
    front,
    back
  };
};

// src/pages/wallet-detail/hooks/queries/use-wallet-detail-query.hook.ts
import { useQuery as useQuery2 } from "@tanstack/react-query";
import {
  GET_WALLET_MESSAGE_TYPE as GET_WALLET_MESSAGE_TYPE2,
  getWalletBenefitCard
} from "@leagueplatform/wallet-api";
var STALE_TIME = 1e3 * 60 * 5;
function useWalletDetailQuery(userId, benefitId, dependentId, options) {
  return useQuery2(
    [GET_WALLET_MESSAGE_TYPE2, userId, benefitId, dependentId],
    () => getWalletBenefitCard(userId, benefitId, dependentId),
    __spreadValues({
      staleTime: STALE_TIME
    }, options)
  );
}

// src/pages/wallet-detail/hooks/use-wallet-card-query.hook.ts
function useWalletCardQuery(userId, benefitId, dependentId, options) {
  return useWalletDetailQuery(userId, benefitId, dependentId, __spreadValues({
    select: (data) => {
      var _a;
      if ((data == null ? void 0 : data.card_images) && ((_a = data.card_images) == null ? void 0 : _a.front.type) !== "html") {
        return data.card_images;
      }
      return selectCardHtml(data);
    }
  }, options));
}

// src/components/wallet-card/hooks/use-wallet-card.hook.ts
function useWalletCard(cardHtml) {
  const { userId, benefitId } = useWalletParams();
  const [memberId] = useSelectedMember();
  const { data: walletCard, isInitialLoading: isLoading } = useWalletCardQuery(
    userId,
    benefitId,
    memberId == null ? void 0 : memberId.id,
    {
      enabled: !cardHtml
    }
  );
  let cardFront = walletCard == null ? void 0 : walletCard.front;
  if (cardHtml) {
    cardFront = { src: cardHtml, type: "html", description: "" };
  }
  const isImageCard = (walletCard == null ? void 0 : walletCard.front.type) === "url" || (walletCard == null ? void 0 : walletCard.front.type) === "base64";
  const cardFaces = [cardFront, walletCard == null ? void 0 : walletCard.back].filter((face) => !!face);
  return {
    isLoading,
    isImageCard,
    cardFaces
  };
}

// src/components/wallet-card/components/card.component.tsx
import { Box, styled } from "@leagueplatform/genesis-core";
var Card = styled(Box, {
  ".card.styled": {
    cursor: "default",
    color: "$onSurfaceTextPrimary",
    fontSize: "$bodyTwo",
    borderRadius: 18,
    borderColor: "$onSurfaceBorderSubdued",
    boxShadow: "$card",
    padding: "$one",
    height: "auto",
    minHeight: "168px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "$half",
    ".row": {
      fontFamily: "$headingOne",
      padding: 0,
      position: "relative"
    },
    ".details": {
      position: "initial",
      display: "flex",
      flexWrap: "wrap",
      gap: "$half"
    },
    ".cardholder": {
      position: "initial"
    },
    ".description": {
      position: "initial"
    },
    h1: {
      marginBottom: 0,
      color: "inherit",
      fontWeight: "medium",
      fontSize: "$bodyTwo"
    },
    // TODO: WALLET-1937
    //     Remove h1 style when title is
    //     returned from backend as h2
    //     h2 style added in preparation of this
    h2: {
      marginBottom: 0,
      color: "inherit",
      fontWeight: "medium",
      fontSize: "$bodyTwo"
    },
    ".light": {
      color: "$onSurfaceTextSubdued"
    },
    ".medium": {
      color: "inherit"
    },
    ".col": {
      marginInlineEnd: "half",
      flexShrink: "1",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      ".label": {
        color: "$onSurfaceTextSubdued",
        fontSize: "10px",
        whiteSpace: "normal"
      },
      ".value, .name": {
        lineHeight: "normal",
        fontSize: "$caption",
        color: "inherit"
      },
      ".name": {
        fontWeight: "medium",
        lineHeight: "normal",
        fontSize: "$caption",
        color: "inherit"
      }
    },
    ".dark": {
      fontSize: "$caption",
      color: "inherit"
    },
    ".balance .value": {
      lineHeight: "52px"
    },
    ".title": {
      position: "initial",
      width: "100%",
      color: "inherit",
      div: {
        fontSize: "$caption"
      }
    },
    ".disclaimer": {
      fontSize: "10px",
      color: "$onSurfaceTextSubdued",
      position: "initial"
    },
    ".effective-dates": {
      position: "initial",
      maxWidth: "80%"
    },
    ".effective-dates p": {
      fontSize: "10px",
      color: "$onSurfaceTextSubdued"
    },
    ".logos": {
      width: "20%",
      insetInlineEnd: "6%",
      padding: 0,
      position: "absolute"
    },
    ".logo": {
      marginTop: "3%",
      height: "10%"
    }
  }
});

// src/components/wallet-card/components/card-actions.component.tsx
import * as React23 from "react";
import { useIntl as useIntl14 } from "@leagueplatform/locales";
import { Box as Box13, Button as Button7, Popover, styled as styled5 } from "@leagueplatform/genesis-core";
import { StackLayout as StackLayout9 } from "@leagueplatform/web-common-components";

// src/pages/wallet-detail/hooks/use-wallet-detail-analytics.hook.ts
import {
  trackAnalyticsEvent,
  SCREEN_NAMES,
  PRODUCT_AREA,
  usePageViewAnalytics
} from "@leagueplatform/analytics";
var useWalletBenefitAnalyticsData = () => {
  const { userId, benefitId } = useWalletParams();
  const { data: benefitData } = useWalletDetailQuery(
    userId,
    benefitId,
    void 0,
    {
      select: ({
        benefit_source: benefitSource,
        full_name: fullName,
        id,
        product_type: productType,
        vendor_id: vendorId
      }) => ({
        benefit_id: id,
        benefit_name: fullName,
        benefit_product_type: productType,
        benefit_source: benefitSource,
        product_area: PRODUCT_AREA.WALLET,
        screen_name: SCREEN_NAMES.BENEFIT_PAGE,
        vendor_id: vendorId
      })
    }
  );
  return benefitData;
};
var useWalletDetailAnalytics = (partialParams) => {
  const benefitData = useWalletBenefitAnalyticsData();
  return (eventName, props) => {
    trackAnalyticsEvent(eventName, __spreadValues(__spreadValues(__spreadValues({}, benefitData), partialParams), props));
  };
};
var useWalletDetailScreenLoaded = (screenName) => {
  const benefitData = useWalletBenefitAnalyticsData();
  usePageViewAnalytics(__spreadProps(__spreadValues({}, benefitData), { screen_name: screenName }));
};

// src/components/wallet-card/components/card-actions.component.tsx
import { EVENT_NAME as EVENT_NAME5 } from "@leagueplatform/analytics";

// src/components/wallet-card/hooks/use-card-actions.hook.ts
import * as React2 from "react";

// src/utils/action-links.util.ts
import { SYSTEM_TYPES } from "@leagueplatform/wallet-api";

// src/utils/utils.js
import html2canvas from "html2canvas";
var CLAIM_URL = "/member/submit-claim?requested_benefit_type=";

// src/utils/action-links.util.ts
var isSubmitClaimAction = (action) => {
  var _a;
  return (_a = action.url) == null ? void 0 : _a.includes(CLAIM_URL);
};
var isSaveCardAction = (action) => action.system_type === "save_card";
var isBenefitDocumentAction = (action) => action.system_type === "benefit_document" && action.type === "open-url";
var isPhoneNumberAction = (action) => action.system_type === SYSTEM_TYPES.CallPhone;
var isExternalLinkAction = (action) => {
  var _a;
  return (_a = action == null ? void 0 : action.url) == null ? void 0 : _a.toLowerCase().startsWith("http");
};
var isEmailLinkAction = (action) => {
  var _a;
  return (_a = action == null ? void 0 : action.url) == null ? void 0 : _a.toLowerCase().includes("mailto:");
};
var isUnavailableAction = (action) => action.unavailable_action !== void 0;
var isGenericContentModal = (action) => action.system_type === "modal_content";
var isClaimsAction = (action) => {
  var _a;
  return (_a = action.url) == null ? void 0 : _a.toLocaleLowerCase().includes("claims-authorization");
};
var isPrintCardAction = (action) => action.system_type === "print_card";
var isOrderNewCardAction = (action) => action.system_type === "order_card";

// src/components/wallet-card/hooks/use-card-actions.hook.ts
var useCardActions = ({ cardRef }) => {
  const { userId, benefitId } = useWalletParams();
  const [memberId] = useSelectedMember();
  const { data: cardActions = [] } = useWalletDetailQuery(
    userId,
    benefitId,
    memberId == null ? void 0 : memberId.id,
    {
      select: (data) => {
        var _a;
        return (_a = data.card_images) == null ? void 0 : _a.actions;
      }
    }
  );
  const actions = React2.useMemo(
    () => cardActions.map((action) => {
      const _a = action, { nav_icon } = _a, strippedAction = __objRest(_a, ["nav_icon"]);
      if (isSaveCardAction(action)) {
        return __spreadProps(__spreadValues({}, strippedAction), { cardRef });
      }
      if (isPrintCardAction(action)) {
        return __spreadProps(__spreadValues({}, strippedAction), { cardRef });
      }
      return strippedAction;
    }),
    [cardActions, cardRef]
  );
  return { actions };
};

// src/components/wallet-card/components/card-action.component.tsx
import * as React22 from "react";
import { Button as Button6 } from "@leagueplatform/genesis-core";

// src/hooks/use-action-link.hook.ts
import { useMemo as useMemo7, useCallback as useCallback5 } from "react";
import { EVENT_NAME as EVENT_NAME4 } from "@leagueplatform/analytics";

// src/components/action-sub-links/action-sub-links.component.tsx
import React21, { useRef as useRef2, useState as useState3 } from "react";
import { useIntl as useIntl13 } from "@leagueplatform/locales";
import { LinkLegacy as LinkDOM } from "@leagueplatform/routing";
import { ACTION_IDS, TAB_IDS } from "@leagueplatform/wallet-api";
import {
  Link as GenesisLink,
  Image as Image3,
  VisuallyHidden as VisuallyHidden2,
  SubtitleOne
} from "@leagueplatform/genesis-commons";
import {
  TextAction,
  Icon as Icon4,
  Box as Box12,
  Modal as Modal2,
  HeadingBar,
  Button as Button5
} from "@leagueplatform/genesis-core";
import { formatPhoneNumber } from "@leagueplatform/web-common";
import slugify from "slugify";
import { getContentUrl } from "@leagueplatform/league-content-api";
import {
  LEAGUE_MODULE_NAMES,
  useConfigProperty,
  getModulePath
} from "@leagueplatform/core";

// src/components/generic-content-modal/generic-content-modal.component.tsx
import * as React3 from "react";
import { Image as Image2 } from "@leagueplatform/genesis-commons";
import {
  Button,
  HeadingText,
  Modal,
  ParagraphText
} from "@leagueplatform/genesis-core";
import { HtmlToReact } from "@leagueplatform/web-common";
import { useIntl } from "@leagueplatform/locales";
var GenericContentModal = ({
  title,
  description,
  imageSrc,
  buttonText,
  phoneNumber
}) => {
  const { formatMessage } = useIntl();
  const modalTitle = title && (title == null ? void 0 : title.length) > 0 ? title : void 0;
  const modalDescription = description && (description == null ? void 0 : description.length) > 0 ? description : void 0;
  return /* @__PURE__ */ React3.createElement(
    Modal.Content,
    {
      showCloseButton: true,
      css: {
        ".GDS-modal": {
          maxHeight: "60vh",
          margin: "0 auto",
          textAlign: "center"
        },
        ".GDS-modal-content * + *": {
          marginTop: "$one"
        }
      }
    },
    imageSrc && /* @__PURE__ */ React3.createElement(Image2, { src: imageSrc, alt: "", width: "auto" }),
    /* @__PURE__ */ React3.createElement(Modal.Title, null, modalTitle && /* @__PURE__ */ React3.createElement(
      HeadingText,
      {
        size: "xl",
        level: "2",
        css: { marginBottom: "$oneAndHalf" }
      },
      modalTitle
    )),
    /* @__PURE__ */ React3.createElement(HtmlToReact, { htmlString: modalDescription }),
    phoneNumber && /* @__PURE__ */ React3.createElement(ParagraphText, null, /* @__PURE__ */ React3.createElement("strong", null, formatMessage({ id: "PLEASE_CALL" }, { phoneNumber }))),
    /* @__PURE__ */ React3.createElement(Modal.Close, null, /* @__PURE__ */ React3.createElement(
      Button,
      {
        priority: "primary",
        width: "fillContainer",
        css: { marginTop: "$four" }
      },
      buttonText || formatMessage({ id: "CLOSE" })
    ))
  );
};

// src/components/action-sub-links/action-sub-links.component.tsx
import { useReactToPrint } from "react-to-print";

// src/pages/wallet-detail/components/order-new-card/order-new-card.component.tsx
import {
  Box as Box11,
  HeadingText as HeadingText9,
  StackLayout as StackLayout8,
  styled as styled4
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl12 } from "@leagueplatform/locales";
import {
  useForm,
  ReactHookFormProvider as FormProvider
} from "@leagueplatform/web-common";
import * as React20 from "react";
import { EVENT_NAME as EVENT_NAME3, PRODUCT_AREA as PRODUCT_AREA2 } from "@leagueplatform/analytics";

// src/pages/wallet-detail/components/order-new-card/components/select-members-step.component.tsx
import * as React4 from "react";
import {
  HeadingText as HeadingText2,
  ParagraphText as ParagraphText2,
  Checkbox,
  Fieldset
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import {
  LoadingIndicator,
  StackLayout
} from "@leagueplatform/web-common-components";
import { useFormContext } from "@leagueplatform/web-common";

// src/pages/wallet-detail/components/order-new-card/hooks/use-select-members-step.hook.ts
import { useGetUserProfile as useGetUserProfile2 } from "@leagueplatform/web-common";
var selectMemberOptions = (userId, data) => {
  var _a, _b;
  const primaryUserOption = {
    label: `${data.member_first_name} ${data.member_last_name}`,
    value: userId
  };
  const dependentOptions = (_b = (_a = data.dependents) == null ? void 0 : _a.sort((a, b) => a.first_name.localeCompare(b.first_name)).map((dependent) => ({
    label: `${dependent.first_name} ${dependent.last_name}`,
    value: dependent.dependent_id
  }))) != null ? _b : [];
  return [primaryUserOption, ...dependentOptions];
};
var useSelectMembersStep = () => {
  const { benefitId } = useWalletParams();
  const { data: userProfile } = useGetUserProfile2();
  const { data: memberOptions = [], isLoading } = useWalletDetailQuery(
    userProfile == null ? void 0 : userProfile.userId,
    benefitId,
    void 0,
    {
      select: (data) => selectMemberOptions((userProfile == null ? void 0 : userProfile.userId) || "", data)
    }
  );
  return { memberOptions, isLoading };
};

// src/pages/wallet-detail/components/order-new-card/constants/form-inputs.constants.ts
var orderNewCardFormInputNames = {
  addressLine1: "addressLine1",
  addressLine2: "addressLine2",
  city: "city",
  state: "state",
  postal: "postal",
  isDefault: "isDefault",
  memberList: "memberList"
};

// src/pages/wallet-detail/components/order-new-card/components/select-members-step.component.tsx
var MEMBER_HINT_ID = "select-member-hint";
var { memberList } = orderNewCardFormInputNames;
var SelectMembersStep = () => {
  var _a;
  const { memberOptions: members, isLoading } = useSelectMembersStep();
  const { register, formState } = useFormContext();
  const { formatMessage } = useIntl2();
  useWalletDetailScreenLoaded(
    "order a new card" /* ORDER_NEW_CARD_SELECT_MEMBER_STEP */
  );
  const errorMessage = (_a = formState.errors.memberList) == null ? void 0 : _a.message;
  if (isLoading) {
    return /* @__PURE__ */ React4.createElement(LoadingIndicator, { inline: true });
  }
  return /* @__PURE__ */ React4.createElement(
    Fieldset,
    {
      hint: /* @__PURE__ */ React4.createElement(ParagraphText2, null, formatMessage({ id: "ORDER_NEW_CARD_MEMBER_SELECT_HELP_TEXT" })),
      id: MEMBER_HINT_ID,
      inputStatus: errorMessage ? "error" : void 0,
      legend: /* @__PURE__ */ React4.createElement(HeadingText2, { size: "lg", level: "3" }, formatMessage({ id: "ORDER_NEW_CARD_MEMBER_SELECT_HEADING" })),
      required: true,
      statusMessage: errorMessage
    },
    /* @__PURE__ */ React4.createElement(StackLayout, { space: "$one", css: { marginTop: "$one" } }, members.map((member) => /* @__PURE__ */ React4.createElement(
      Checkbox,
      __spreadValues({
        key: member.value,
        id: member.value,
        label: member.label,
        value: member.value
      }, register(memberList, {
        required: formatMessage({
          id: "WALLET_ORDER_NEW_CARD_SELECT_MEMBER_ERROR"
        })
      }))
    )))
  );
};

// src/pages/wallet-detail/components/order-new-card/components/new-address-step.component.tsx
import * as React5 from "react";
import {
  Fieldset as Fieldset2,
  HeadingText as HeadingText3,
  InputLabel,
  ParagraphText as ParagraphText3,
  TextInput,
  Select,
  InputStatusMessage,
  styled as styled2,
  StackLayout as StackLayout2,
  Box as Box2
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import {
  PROVINCE_STATE_OPTIONS,
  useFormContext as useFormContext2
} from "@leagueplatform/web-common";

// src/pages/wallet-detail/components/order-new-card/utils/validate-valid-characters.util.ts
var VALID_CHARACTERS_REGEX = /^(\w|\s|-)*$/i;
var validateIsValidCharacters = (value) => VALID_CHARACTERS_REGEX.test(value) === true;

// src/pages/wallet-detail/components/order-new-card/components/new-address-step.component.tsx
var NEW_ADDRESS_HINT_ID = "new-address-hint";
var CITY_VALIDATION_REGEX = /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/;
var ZIP_CODE_VALIDATION_REGEX = /^[0-9]{5}$/;
var transformedStateOptions = PROVINCE_STATE_OPTIONS.US.map(
  ({ value, text }) => ({
    label: text,
    value
  })
);
var StyledInputLabel = styled2(InputLabel, {
  marginBottom: "$half"
});
var { addressLine1, addressLine2, city, postal, state } = orderNewCardFormInputNames;
var NewAddressStep = () => {
  var _a, _b, _c, _d, _e;
  const { formatMessage, $tmap } = useIntl3();
  const { register, formState } = useFormContext2();
  useWalletDetailScreenLoaded(
    "order a new card enter new address" /* ORDER_NEW_CARD_NEW_ADDRESS_STEP */
  );
  const requiredFieldError = (id) => formatMessage(
    { id: "REQUIRED_FIELD" },
    {
      field: $tmap({
        ["address-line-1-input" /* ADDRESS_LINE_1 */]: "ADDRESS_LINE_1",
        ["address-line-2-input" /* ADDRESS_LINE_2 */]: "ADDRESS_LINE_2",
        ["city-input" /* CITY */]: "CITY",
        ["state-input" /* STATE */]: "STATE",
        ["postal-input" /* POSTAL */]: "ZIP_CODE"
      })(id)
    }
  );
  const addressLine1Error = (_a = formState.errors[addressLine1]) == null ? void 0 : _a.message;
  const addressLine1ErrorId = `${"address-line-1-input" /* ADDRESS_LINE_1 */}-errorMessage`;
  const addressLine2Error = (_b = formState.errors[addressLine2]) == null ? void 0 : _b.message;
  const addressLine2ErrorId = `${"address-line-2-input" /* ADDRESS_LINE_2 */}-errorMessage`;
  const cityError = (_c = formState.errors[city]) == null ? void 0 : _c.message;
  const cityErrorId = `${"city-input" /* CITY */}-errorMessage`;
  const stateError = (_d = formState.errors[state]) == null ? void 0 : _d.message;
  const stateErrorId = `${"state-input" /* STATE */}-errorMessage`;
  const postalError = (_e = formState.errors[postal]) == null ? void 0 : _e.message;
  const postalErrorId = `${"postal-input" /* POSTAL */}-errorMessage`;
  const validate = {
    isValidCharacters: (value) => validateIsValidCharacters(value) || formatMessage({ id: "WALLET_INVALID_CHARACTER_ERROR_MESSAGE" })
  };
  return /* @__PURE__ */ React5.createElement(
    Fieldset2,
    {
      id: NEW_ADDRESS_HINT_ID,
      css: {
        ".GDS-fieldset-legend": {
          display: "block"
        }
      },
      legend: /* @__PURE__ */ React5.createElement(HeadingText3, { size: "lg", level: "3" }, formatMessage({ id: "CHOOSE_NEW_ADDRESS" })),
      hint: /* @__PURE__ */ React5.createElement(ParagraphText3, null, formatMessage({ id: "CHOOSE_NEW_ADDRESS_DESC" }))
    },
    /* @__PURE__ */ React5.createElement(StackLayout2, { spacing: "$oneAndHalf", horizontalAlignment: "stretch" }, /* @__PURE__ */ React5.createElement(Box2, null, /* @__PURE__ */ React5.createElement(StyledInputLabel, { htmlFor: "address-line-1-input" /* ADDRESS_LINE_1 */, required: true }, formatMessage({ id: "ADDRESS_LINE_1" })), /* @__PURE__ */ React5.createElement(
      TextInput,
      __spreadValues({
        id: "address-line-1-input" /* ADDRESS_LINE_1 */,
        maxLength: 55,
        autoComplete: "address-line1",
        inputStatus: addressLine1Error ? "error" : void 0,
        "aria-describedby": addressLine1Error ? addressLine1ErrorId : void 0
      }, register(addressLine1, {
        required: requiredFieldError("address-line-1-input" /* ADDRESS_LINE_1 */),
        validate
      }))
    ), addressLine1Error && /* @__PURE__ */ React5.createElement(InputStatusMessage, { inputStatus: "error", id: addressLine1ErrorId }, addressLine1Error)), /* @__PURE__ */ React5.createElement(Box2, null, /* @__PURE__ */ React5.createElement(StyledInputLabel, { htmlFor: "address-line-2-input" /* ADDRESS_LINE_2 */ }, formatMessage({ id: "ADDRESS_LINE_2" })), /* @__PURE__ */ React5.createElement(
      TextInput,
      __spreadValues({
        id: "address-line-2-input" /* ADDRESS_LINE_2 */,
        maxLength: 55,
        autoComplete: "address-line2",
        inputStatus: addressLine2Error ? "error" : void 0,
        "aria-describedby": addressLine2Error ? addressLine2ErrorId : void 0
      }, register(orderNewCardFormInputNames.addressLine2, {
        maxLength: {
          value: 55,
          message: formatMessage(
            { id: "UNIQUE_IDENTIFIER_MAX_LENGTH_ERROR" },
            { length: 55 }
          )
        },
        validate
      }))
    ), addressLine2Error && /* @__PURE__ */ React5.createElement(InputStatusMessage, { inputStatus: "error", id: addressLine2ErrorId }, addressLine2Error)), /* @__PURE__ */ React5.createElement(Box2, null, /* @__PURE__ */ React5.createElement(StyledInputLabel, { htmlFor: "city-input" /* CITY */, required: true }, formatMessage({ id: "CITY" })), /* @__PURE__ */ React5.createElement(
      TextInput,
      __spreadValues({
        id: "city-input" /* CITY */,
        maxLength: 30,
        autoComplete: "address-level2",
        "aria-describedby": cityError ? cityErrorId : void 0,
        inputStatus: cityError ? "error" : void 0
      }, register(city, {
        required: requiredFieldError("city-input" /* CITY */),
        maxLength: 30,
        pattern: {
          value: CITY_VALIDATION_REGEX,
          message: formatMessage({
            id: "WALLET_ORDER_NEW_CARD_NO_CITY_NUMBERS_ERROR"
          })
        },
        validate
      }))
    ), cityError && /* @__PURE__ */ React5.createElement(InputStatusMessage, { inputStatus: "error", id: cityErrorId }, cityError)), /* @__PURE__ */ React5.createElement(Box2, null, /* @__PURE__ */ React5.createElement(StyledInputLabel, { htmlFor: "state-input" /* STATE */, required: true }, formatMessage({ id: "STATE" })), /* @__PURE__ */ React5.createElement(
      Select,
      __spreadValues({
        id: "state-input" /* STATE */,
        options: transformedStateOptions,
        placeholder: formatMessage({ id: "SELECT_STATE" }),
        autoComplete: "address-level1",
        "aria-describedby": stateError ? stateErrorId : void 0,
        inputStatus: stateError ? "error" : void 0
      }, register(state, {
        required: requiredFieldError("state-input" /* STATE */),
        validate
      }))
    ), stateError && /* @__PURE__ */ React5.createElement(InputStatusMessage, { inputStatus: "error", id: stateErrorId }, stateError)), /* @__PURE__ */ React5.createElement(Box2, null, /* @__PURE__ */ React5.createElement(StyledInputLabel, { htmlFor: "postal-input" /* POSTAL */, required: true }, formatMessage({ id: "ZIP_CODE" })), /* @__PURE__ */ React5.createElement(
      TextInput,
      __spreadValues({
        id: "postal-input" /* POSTAL */,
        autoComplete: "postal-code",
        pattern: "[0-9]*",
        maxLength: 5,
        "aria-describedby": postalError ? postalErrorId : void 0,
        inputStatus: postalError ? "error" : void 0
      }, register(postal, {
        required: requiredFieldError("postal-input" /* POSTAL */),
        maxLength: 5,
        pattern: {
          value: ZIP_CODE_VALIDATION_REGEX,
          message: formatMessage({ id: "INVALID_ZIP_CODE_NO_FORMAT" })
        },
        validate
      }))
    ), postalError && /* @__PURE__ */ React5.createElement(InputStatusMessage, { inputStatus: "error", id: postalErrorId }, postalError)))
  );
};

// src/pages/wallet-detail/components/order-new-card/components/select-address-step.component.tsx
import { Fieldset as Fieldset3, HeadingText as HeadingText5, Radio } from "@leagueplatform/genesis-core";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
import { StackLayout as StackLayout3 } from "@leagueplatform/web-common-components";
import { useFormContext as useFormContext5 } from "@leagueplatform/web-common";
import * as React9 from "react";

// src/pages/wallet-detail/components/order-new-card/hooks/use-select-address-step.hook.ts
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import * as React7 from "react";
import { useFormContext as useFormContext3 } from "@leagueplatform/web-common";

// src/pages/wallet-detail/components/order-new-card/utils/format-address.util.ts
var formatAddress = (address1, city2, postal2, state2, address2) => `${address1} ${address2 || ""} ${city2}, ${state2} ${postal2}`;

// src/pages/wallet-detail/components/order-new-card/hooks/use-get-user-default-address.hook.ts
import * as React6 from "react";
import { useGetUserProfile as useGetUserProfile3 } from "@leagueplatform/web-common";
var useGetUserDefaultAddress = () => {
  var _a;
  const { data: user } = useGetUserProfile3();
  const { address1, address2, city: city2, postal: postal2, state: state2 } = React6.useMemo(
    () => {
      var _a2, _b;
      return (_b = (_a2 = user == null ? void 0 : user.userProfile) == null ? void 0 : _a2.locations) == null ? void 0 : _b.find((location) => location.isDefault);
    },
    [(_a = user == null ? void 0 : user.userProfile) == null ? void 0 : _a.locations]
  ) || {};
  return { address1, address2, city: city2, postal: postal2, state: state2 };
};

// src/pages/wallet-detail/components/order-new-card/utils/check-is-default-address.ts
var checkIsDefaultAddress = (isDefaultAddress2) => {
  if (isDefaultAddress2 === "false")
    return false;
  if (isDefaultAddress2 === "true")
    return true;
  return isDefaultAddress2;
};

// src/pages/wallet-detail/components/order-new-card/hooks/use-select-address-step.hook.ts
var {
  addressLine1: addressLine12,
  addressLine2: addressLine22,
  city: cityInput,
  state: stateInput,
  postal: postalInput,
  isDefault
} = orderNewCardFormInputNames;
var useSelectAddressStep = () => {
  const { formatMessage } = useIntl4();
  const { getValues, setValue } = useFormContext3();
  const { address1, address2, city: city2, postal: postal2, state: state2 } = useGetUserDefaultAddress();
  const isDefaultAddress2 = checkIsDefaultAddress(getValues(isDefault));
  React7.useEffect(() => {
    if (isDefaultAddress2 === null || void 0)
      return;
    if (isDefaultAddress2) {
      setValue(addressLine12, address1);
      setValue(addressLine22, address2);
      setValue(cityInput, city2);
      setValue(stateInput, state2);
      setValue(postalInput, postal2);
    } else {
      setValue(addressLine12, void 0);
      setValue(addressLine22, void 0);
      setValue(cityInput, void 0);
      setValue(stateInput, void 0);
      setValue(postalInput, void 0);
    }
  }, [address1, address2, city2, isDefaultAddress2, postal2, setValue, state2]);
  const options = React7.useMemo(
    () => [
      {
        label: formatMessage({ id: "DEFAULT_ADDRESS" }),
        hint: formatAddress(address1, city2, postal2, state2, address2),
        isDefault: true
      },
      {
        label: formatMessage({ id: "CHOOSE_NEW_ADDRESS" }),
        hint: formatMessage({ id: "CHOOSE_NEW_ADDRESS_HINT" }),
        isDefault: false
      }
    ],
    [address1, address2, city2, formatMessage, postal2, state2]
  );
  return { options };
};

// src/pages/wallet-detail/components/order-new-card/components/member-selection-card.component.tsx
import {
  Box as Box3,
  Icon,
  ParagraphText as ParagraphText4,
  HeadingText as HeadingText4,
  StackItem
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import * as React8 from "react";
import { useFormContext as useFormContext4 } from "@leagueplatform/web-common";
var { memberList: memberList2 } = orderNewCardFormInputNames;
var MemberCard = ({ headingLevel }) => {
  const { formatMessage } = useIntl5();
  const { getValues } = useFormContext4();
  const selectedMembers = getValues(memberList2);
  const members = useSelectMembersStep().memberOptions.filter(
    (member) => selectedMembers.includes(member.value)
  );
  return /* @__PURE__ */ React8.createElement(
    StackItem,
    {
      css: {
        flexDirection: "row",
        margin: "$oneAndHalf 0"
      }
    },
    /* @__PURE__ */ React8.createElement(
      Box3,
      {
        css: {
          backgroundColor: "$surfaceBackgroundSecondary",
          padding: "$threeQuarters",
          borderRadius: "$circle",
          height: "fit-content",
          marginInlineEnd: "$one",
          alignSelf: "center",
          flexGrow: "0"
        }
      },
      /* @__PURE__ */ React8.createElement(Icon, { icon: "descriptivePaymentCard", tint: "$onSurfaceIconPrimary" })
    ),
    /* @__PURE__ */ React8.createElement(Box3, null, /* @__PURE__ */ React8.createElement(HeadingText4, { level: `${headingLevel}`, size: "md" }, formatMessage({ id: "MEDICAL_ID_CARD" })), /* @__PURE__ */ React8.createElement("ul", null, members.map(({ label }, i) => /* @__PURE__ */ React8.createElement("li", { key: `member-${label.replace(" ", "-")}` }, /* @__PURE__ */ React8.createElement(ParagraphText4, null, i === members.length - 1 ? `${label}` : `${label},`)))))
  );
};

// src/pages/wallet-detail/components/order-new-card/components/select-address-step.component.tsx
var ADDRESS_HINT_ID = "select-address-hint";
var { isDefault: isDefault2 } = orderNewCardFormInputNames;
var SelectAddressStep = () => {
  var _a;
  const { formatMessage } = useIntl6();
  const { options } = useSelectAddressStep();
  const { register, formState } = useFormContext5();
  useWalletDetailScreenLoaded(
    "order a new card enter delivery address" /* ORDER_NEW_CARD_SELECT_ADDRESS_STEP */
  );
  const errorMessage = (_a = formState.errors[isDefault2]) == null ? void 0 : _a.message;
  return /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(MemberCard, { headingLevel: 4 }), /* @__PURE__ */ React9.createElement(
    Fieldset3,
    {
      inputStatus: errorMessage ? "error" : void 0,
      id: ADDRESS_HINT_ID,
      legend: /* @__PURE__ */ React9.createElement(HeadingText5, { size: "lg", level: "3" }, formatMessage({ id: "ORDER_NEW_CARD_ADDRESS_SELECT_HEADING" })),
      required: true,
      statusMessage: errorMessage
    },
    /* @__PURE__ */ React9.createElement(StackLayout3, { space: "$one", css: { marginTop: "$one" } }, options.map((option, i) => /* @__PURE__ */ React9.createElement(
      Radio,
      __spreadValues({
        css: {
          borderRadius: "$medium",
          border: "$onSurfaceBorderDefault thin solid"
        },
        hint: option.hint,
        id: `address-option-${i}`,
        key: `address-is-default-${option.isDefault}`,
        label: option.label,
        layout: "row",
        value: `${option.isDefault}`
      }, register(isDefault2, {
        required: formatMessage({
          id: "WALLET_ORDER_NEW_CARD_SELECT_ADDRESS_OPTION_ERROR"
        })
      }))
    )))
  ));
};

// src/pages/wallet-detail/components/order-new-card/components/confirmation-screen.component.tsx
import {
  Box as Box4,
  HeadingText as HeadingText6,
  Icon as Icon2,
  ParagraphText as ParagraphText5,
  StackItem as StackItem2,
  StackLayout as StackLayout4
} from "@leagueplatform/genesis-core";
import { useFormContext as useFormContext6 } from "@leagueplatform/web-common";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import * as React10 from "react";
var AddressCard = ({ deliveryAddress }) => {
  const { formatMessage } = useIntl7();
  const { address1, address2, city: city2, state: state2, postal: postal2, isDefault: isDefault3 } = deliveryAddress;
  const isDefaultAddressBoolean = isDefault3 === "true";
  return /* @__PURE__ */ React10.createElement(StackItem2, { css: { flexDirection: "row", marginTop: "$oneAndHalf" } }, /* @__PURE__ */ React10.createElement(
    Box4,
    {
      css: {
        backgroundColor: "$surfaceBackgroundSecondary",
        padding: "$threeQuarters",
        borderRadius: "$circle",
        height: "fit-content",
        margin: "auto",
        marginInlineEnd: "$one"
      }
    },
    /* @__PURE__ */ React10.createElement(Icon2, { icon: "descriptiveMail", tint: "$onSurfaceIconPrimary" })
  ), /* @__PURE__ */ React10.createElement(Box4, null, /* @__PURE__ */ React10.createElement(HeadingText6, { level: "4", size: "md" }, isDefaultAddressBoolean ? formatMessage({ id: "DEFAULT_ADDRESS" }) : formatMessage({ id: "NEW_ADDRESS" })), /* @__PURE__ */ React10.createElement(Box4, null, /* @__PURE__ */ React10.createElement(
    ParagraphText5,
    {
      as: "span",
      css: { marginBlockEnd: "0 !important", display: "block" }
    },
    `${address1} ${address2 || ""}`
  ), /* @__PURE__ */ React10.createElement(
    ParagraphText5,
    {
      as: "span",
      css: { display: "block" }
    },
    `${city2}, ${state2}, ${postal2}`
  ))));
};
var {
  addressLine1: addressLine1Input,
  addressLine2: addressLine2Input,
  city: cityInput2,
  state: stateInput2,
  postal: postalInput2,
  isDefault: isDefaultAddress
} = orderNewCardFormInputNames;
var ConfirmationScreen = () => {
  const { formatMessage } = useIntl7();
  const { getValues } = useFormContext6();
  useWalletDetailScreenLoaded(
    "order a new card confirmation screen" /* ORDER_NEW_CARD_CONFIRMATION_STEP */
  );
  const [address1, address2, city2, state2, postal2, isDefault3] = getValues([
    addressLine1Input,
    addressLine2Input,
    cityInput2,
    stateInput2,
    postalInput2,
    isDefaultAddress
  ]);
  const deliveryAddress = {
    address1,
    address2,
    city: city2,
    state: state2,
    postal: postal2,
    isDefault: isDefault3
  };
  return /* @__PURE__ */ React10.createElement(StackLayout4, null, /* @__PURE__ */ React10.createElement(HeadingText6, { size: "lg", level: "3" }, formatMessage({ id: "CONFIRM_DETAILS" })), /* @__PURE__ */ React10.createElement(MemberCard, { headingLevel: 4 }), /* @__PURE__ */ React10.createElement(AddressCard, { deliveryAddress }));
};

// src/pages/wallet-detail/components/order-new-card/hooks/queries/use-submit-order-new-card-mutation.hook.ts
import * as React11 from "react";
import { useMutation } from "@tanstack/react-query";
import {
  postIdCards
} from "@leagueplatform/wallet-api";
var useSubmitOrderNewCardMutation = () => {
  const {
    address1 = "",
    address2 = "",
    city: defaultCity = "",
    postal: postalCode = "",
    state: defaultState = ""
  } = useGetUserDefaultAddress();
  const { benefitId = "" } = useWalletParams();
  const defaultAddress = React11.useMemo(
    () => ({
      streetAddressLine1: address1,
      streetAddressLine2: address2,
      city: defaultCity,
      postalCode,
      province: defaultState
    }),
    [address1, address2, defaultCity, postalCode, defaultState]
  );
  return useMutation((data) => {
    const {
      addressLine1: addressLine13,
      addressLine2: addressLine23,
      postal: postal2,
      state: state2,
      city: city2,
      memberList: memberListData,
      isDefault: isDefault3
    } = data;
    const newAddress = {
      streetAddressLine1: addressLine13,
      streetAddressLine2: addressLine23,
      city: city2,
      postalCode: postal2,
      province: state2
    };
    const isSingleMember = !Array.isArray(memberListData);
    const memberList3 = isSingleMember ? [memberListData] : memberListData;
    const isDefaultAddress2 = isDefault3 === "true";
    const address = isDefaultAddress2 ? defaultAddress : newAddress;
    const submitData = {
      benefitId,
      address,
      memberList: memberList3
    };
    return postIdCards({ data: submitData });
  });
};

// src/pages/wallet-detail/components/order-new-card/components/multi-step-footer/order-new-card-footer.component.tsx
import React15 from "react";
import { useIntl as useIntl9 } from "@leagueplatform/locales";
import {
  BodyOneSecondary,
  genesisStyled as genesisStyled2,
  Box as Box6,
  css as css2
} from "@leagueplatform/genesis-commons";
import { VisuallyHidden } from "@leagueplatform/genesis-core";

// src/pages/wallet-detail/components/order-new-card/components/multi-step-footer/multi-step-footer-buttons.component.tsx
import React13 from "react";
import { QuietButton as QuietButton2 } from "@leagueplatform/genesis-commons";
import { Button as Button2, Icon as Icon3 } from "@leagueplatform/genesis-core";
import { ViewTransitionController } from "@leagueplatform/health-journey-common";
import { useIntl as useIntl8 } from "@leagueplatform/locales";

// src/pages/wallet-detail/components/order-new-card/components/multi-step-footer/circle-button.component.tsx
import React12 from "react";
import {
  css,
  Flex,
  PrimaryButton,
  QuietButton
} from "@leagueplatform/genesis-commons";
var CircleButton = ({
  css: cssOverrides,
  as = PrimaryButton,
  disabled,
  children,
  onClick,
  type,
  label
}) => /* @__PURE__ */ React12.createElement(
  Flex,
  {
    alignItems: "center",
    as: type === "submit" ? QuietButton : as,
    "aria-label": label,
    disabled,
    borderRadius: "circle",
    color: "interactive.action.primary",
    justifyContent: "center",
    opacity: 1,
    size: "three",
    transition: "background 0.15s ease-out, color 0.15s ease-out",
    type: type || null,
    css: css(__spreadProps(__spreadValues({}, cssOverrides), {
      "&:before": {
        borderRadius: "50%"
      }
    })),
    onClick
  },
  children
);

// src/pages/wallet-detail/components/order-new-card/constants/multi-step-footer-constants.ts
var ACTIVITY_CONTENT_BASE_WIDTH = 484;
var EASING = Object.freeze({
  IN_OUT_QUAD: `cubic-bezier(0.45, 0, 0.55, 1)`
});
var baseDurationMs = 150;
var TRANSITION_DURATION_MS = Object.freeze({
  SHORT: baseDurationMs,
  MEDIUM: baseDurationMs * 2,
  LONG: baseDurationMs * 3,
  XLONG: baseDurationMs * 4
});
var { MEDIUM, XLONG } = TRANSITION_DURATION_MS;
var { IN_OUT_QUAD } = EASING;
var TRANSITIONS = Object.freeze({
  PAGE: `${XLONG}ms ${IN_OUT_QUAD}`,
  HALF_PAGE: `${MEDIUM}ms ${IN_OUT_QUAD}`
});
var MultiStepFooterAreas = /* @__PURE__ */ ((MultiStepFooterAreas2) => {
  MultiStepFooterAreas2["Top"] = "top";
  MultiStepFooterAreas2["Start"] = "start";
  MultiStepFooterAreas2["Center"] = "center";
  MultiStepFooterAreas2["End"] = "end";
  MultiStepFooterAreas2["Bottom"] = "bottom";
  return MultiStepFooterAreas2;
})(MultiStepFooterAreas || {});

// src/pages/wallet-detail/components/order-new-card/components/multi-step-footer/multi-step-footer-buttons.component.tsx
var { SHORT } = TRANSITION_DURATION_MS;
var ButtonTransition = ({
  views,
  handleActiveView,
  css: css16
}) => /* @__PURE__ */ React13.createElement(
  ViewTransitionController,
  {
    views,
    handleActiveView,
    css: css16,
    duration: SHORT,
    transitionType: "fade"
  }
);
var CircleIcon = ({
  icon,
  onClick,
  disabled,
  css: css16,
  type,
  label
}) => /* @__PURE__ */ React13.createElement(
  CircleButton,
  {
    as: QuietButton2,
    onClick,
    disabled,
    css: css16,
    type,
    label
  },
  /* @__PURE__ */ React13.createElement(Icon3, { icon, css: { display: "block" } })
);
var SubmitButton = (_a) => {
  var _b = _a, {
    onClick,
    disabled,
    buttonText
  } = _b, props = __objRest(_b, [
    "onClick",
    "disabled",
    "buttonText"
  ]);
  return /* @__PURE__ */ React13.createElement(
    Button2,
    __spreadValues({
      priority: "primary",
      onClick,
      disabled,
      css: {
        paddingY: "$threeQuarters",
        textTransform: "uppercase",
        textWrap: "nowrap"
      }
    }, props),
    buttonText
  );
};
var PrevButton = ({ currentPage, onClick, css: css16, disabled }) => {
  const { formatMessage } = useIntl8();
  const buttons = {
    ["ArrowBack" /* ArrowBack */]: {
      view: CircleIcon,
      props: {
        icon: "interfaceArrowBack",
        disabled,
        onClick,
        label: formatMessage({ id: "BENEFITS_ORDER_NEW_CARD_PREVIOUS_LABEL" }),
        type: "button"
      }
    }
  };
  const handleActiveButton = () => {
    if (currentPage)
      return "ArrowBack" /* ArrowBack */;
    return "";
  };
  return /* @__PURE__ */ React13.createElement(
    ButtonTransition,
    {
      views: buttons,
      handleActiveView: handleActiveButton,
      css: css16
    }
  );
};
var NextButton = ({
  currentPage,
  totalPages,
  disabled,
  onClick,
  css: css16,
  isLoading,
  onSubmit
}) => {
  const commonProps = { onClick, disabled };
  const { formatMessage } = useIntl8();
  const buttons = {
    ["ArrowForward" /* ArrowForward */]: {
      view: CircleIcon,
      props: __spreadValues({
        icon: "interfaceArrowForward",
        label: formatMessage({
          id: "BENEFITS_ORDER_NEW_CARD_NEXT_LABEL"
        }),
        type: "button"
      }, commonProps)
    },
    ["Check" /* Check */]: {
      view: SubmitButton,
      props: __spreadValues({
        type: "submit",
        onSubmit,
        buttonText: formatMessage({ id: "ORDER_CARD" }),
        loading: isLoading
      }, commonProps)
    },
    ["Spinner" /* Loading */]: {
      view: SubmitButton,
      props: __spreadValues({
        buttonText: formatMessage({ id: "ORDER_CARD" })
      }, commonProps)
    }
  };
  const isLastPage = currentPage === totalPages - 1;
  const handleActiveButton = () => {
    if (isLastPage)
      return "Check" /* Check */;
    if (isLoading)
      return "Spinner" /* Loading */;
    return "ArrowForward" /* ArrowForward */;
  };
  return /* @__PURE__ */ React13.createElement(
    ButtonTransition,
    {
      views: buttons,
      handleActiveView: handleActiveButton,
      css: css16
    }
  );
};

// src/pages/wallet-detail/components/order-new-card/components/multi-step-footer/multi-step-page-progress.component.tsx
import React14 from "react";
import {
  Flex as Flex2,
  Box as Box5,
  genesisStyled
} from "@leagueplatform/genesis-commons";
var PageIndicator = genesisStyled(Box5)`
  position: relative;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.interactive.action.disabled};
  border-radius: ${({ theme }) => theme.radii.medium}px;
  border: none;
  height: ${({ theme }) => theme.sizes.quarter}px;
  width: 100%;
  &:not(&:first-of-type){
    margin-inline-start: ${({ theme }) => theme.space.quarter}px;
  }
  &:before {
    content: '';
    position: absolute;
    inset: 0;
    transform: scaleX(${({ isActive }) => Number(isActive)});
    transform-origin: start;
    background-color: ${({ theme }) => theme.colors.interactive.action.primary};
    transition: transform ${TRANSITIONS.PAGE};
  }
`;
var MultiStepPageProgress = ({
  css: css16,
  totalPages,
  currentPage
}) => {
  const pageIndices = [...Array(totalPages).keys()];
  return /* @__PURE__ */ React14.createElement(
    Flex2,
    {
      justifyContent: "space-between",
      width: "100%",
      padding: " 0 25%",
      marginBottom: "oneAndHalf",
      css: css16
    },
    pageIndices.map((pageIndex) => /* @__PURE__ */ React14.createElement(
      PageIndicator,
      {
        key: `page-progress-${pageIndex}`,
        isActive: currentPage >= pageIndex,
        currentPage,
        pageIndex
      }
    ))
  );
};

// src/pages/wallet-detail/components/order-new-card/components/multi-step-footer/order-new-card-footer.component.tsx
var { Top, Start, Center, End, Bottom } = MultiStepFooterAreas;
var footerPlacement = {
  [Top]: css2({ gridArea: Top, justifySelf: "center" }),
  [Start]: css2({ gridArea: Start, justifySelf: "start" }),
  [Center]: css2({ gridArea: Center, justifySelf: "center" }),
  [End]: css2({ gridArea: End, justifySelf: "end" }),
  [Bottom]: css2({ gridArea: Bottom, justifySelf: "center" })
};
var FooterLayout = genesisStyled2(Box6)`
  align-items: center;
  display: grid;
  grid-template-areas:
  "top top top"
  "start center end"
  "bottom bottom bottom";
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  width: 100%;
`;
var OrderNewCardFooter = ({
  totalPages,
  currentPage,
  disabled,
  onNext,
  onPrev,
  isLoading,
  onSubmit
}) => {
  const { formatMessage } = useIntl9();
  const isMultiPage = totalPages > 1;
  const copy = {
    pageProgress: formatMessage(
      { id: "X_OF_Y" },
      { current: currentPage + 1, total: totalPages }
    )
  };
  return /* @__PURE__ */ React15.createElement(FooterLayout, { marginTop: "one" }, isMultiPage && /* @__PURE__ */ React15.createElement(
    MultiStepPageProgress,
    {
      css: footerPlacement[Top],
      currentPage,
      totalPages
    }
  ), isMultiPage && /* @__PURE__ */ React15.createElement(
    PrevButton,
    {
      currentPage,
      disabled,
      onClick: onPrev,
      css: footerPlacement[Start]
    }
  ), isMultiPage && /* @__PURE__ */ React15.createElement(
    BodyOneSecondary,
    {
      textAlign: "center",
      css: footerPlacement[Center],
      "aria-live": "polite"
    },
    /* @__PURE__ */ React15.createElement(VisuallyHidden, null, formatMessage({ id: "STEP" })),
    copy.pageProgress
  ), isLoading ? /* @__PURE__ */ React15.createElement(
    NextButton,
    {
      css: footerPlacement[End],
      currentPage,
      totalPages,
      disabled,
      onClick: onNext,
      isLoading
    }
  ) : /* @__PURE__ */ React15.createElement(
    NextButton,
    {
      css: footerPlacement[End],
      currentPage,
      totalPages,
      disabled,
      onClick: onNext,
      onSubmit
    }
  ));
};

// src/pages/wallet-detail/components/order-new-card/components/multi-step-layout.component.tsx
import React16 from "react";
import { Box as Box7, StackLayout as StackLayout5, styled as styled3 } from "@leagueplatform/genesis-core";
var FullPageHeight = styled3(Box7, {
  height: "100%",
  inset: 0,
  position: "absolute",
  backgroundColor: "$surfaceBackgroundTertiary"
});
var ContentPosition = styled3(StackLayout5, {
  padding: "$oneAndHalf 0",
  paddingTop: "$five",
  transition: `all ${TRANSITIONS.PAGE}`,
  overflow: "hidden"
});
ContentPosition.defaultProps = {
  horizontalAlignment: "center",
  verticalAlignment: "center"
};
var ContentWrapper = styled3(StackLayout5, {
  position: "relative",
  width: ACTIVITY_CONTENT_BASE_WIDTH,
  maxWidth: "100%"
});
ContentWrapper.defaultProps = {
  orientation: "vertical",
  horizontalAlignment: "center"
};
var MultiStepLayout = ({ children }) => /* @__PURE__ */ React16.createElement(FullPageHeight, { "data-testid": "multi-step-page" }, /* @__PURE__ */ React16.createElement(ContentPosition, { "data-testid": "multi-step-layout" }, /* @__PURE__ */ React16.createElement(ContentWrapper, { "data-testid": "multi-step-content-wrapper" }, children)));

// src/pages/wallet-detail/components/order-new-card/components/multi-step-slider.component.tsx
import React17, { useMemo as useMemo5 } from "react";
import { Transition } from "react-transition-group";
import { Box as Box8, Flex as Flex3, css as css3 } from "@leagueplatform/genesis-commons";
import { usePrefersReducedMotion } from "@leagueplatform/web-common";
var slideTransition = `transform ${TRANSITIONS.PAGE}, opacity ${TRANSITIONS.PAGE}`;
var reducedMotionSlideTransition = `opacity ${TRANSITIONS.PAGE}`;
var reducedMotionSlideStyles = css3({
  insetInlineStart: 0,
  transform: "none",
  transition: reducedMotionSlideTransition
});
var useSlideTransitionStyles = ({
  slideIndex,
  gap,
  activeIndex
}) => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const slideStyles = css3({
    insetInlineStart: `calc(${slideIndex} * ${gap})`,
    transform: `translateX(calc(-${gap} * ${activeIndex}))`,
    transition: slideTransition
  });
  return useMemo5(
    () => prefersReducedMotion ? reducedMotionSlideStyles : slideStyles,
    [prefersReducedMotion, slideStyles]
  );
};
var MultiStepSlide = ({
  children,
  gap = "100%",
  slideIndex,
  activeIndex
}) => {
  const slideTransitionStyles = useSlideTransitionStyles({
    gap,
    slideIndex,
    activeIndex
  });
  return /* @__PURE__ */ React17.createElement(
    Box8,
    {
      "aria-hidden": activeIndex !== slideIndex,
      css: slideTransitionStyles,
      height: "100%",
      opacity: Number(activeIndex === slideIndex),
      overflowY: "auto",
      position: "absolute",
      top: 0,
      width: "100%",
      className: "multi-step-slide"
    },
    /* @__PURE__ */ React17.createElement(
      Transition,
      {
        in: activeIndex === slideIndex,
        timeout: TRANSITION_DURATION_MS.XLONG,
        unmountOnExit: true
      },
      children
    )
  );
};
var MultiStepSlider = ({ children }) => /* @__PURE__ */ React17.createElement(
  Flex3,
  {
    height: "100%",
    width: "100%",
    position: "relative",
    className: "multi-step-slider"
  },
  children
);

// src/pages/wallet-detail/components/order-new-card/components/end-screen.component.tsx
import {
  Box as Box9,
  HeadingText as HeadingText7,
  ParagraphText as ParagraphText6,
  StackLayout as StackLayout6,
  ImageMessage,
  Button as Button3
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl10 } from "@leagueplatform/locales";
import { handleStaticAsset } from "@leagueplatform/asset-config";
import * as React18 from "react";
var EndScreen = ({ onClick, status }) => {
  const isSuccess = status === "success";
  const isLoading = status === "loading";
  const { formatMessage } = useIntl10();
  const SUCCESS_IMAGE = handleStaticAsset(
    "ORDER_NEW_CARD_SUCCESS" /* ORDER_NEW_CARD_SUCCESS */
  );
  const ERROR_IMAGE = handleStaticAsset(
    "ORDER_NEW_CARD_ERROR" /* ORDER_NEW_CARD_ERROR */
  );
  const logScreenLoaded = useWalletDetailScreenLoaded;
  if (isSuccess) {
    logScreenLoaded("order a new card success screen" /* ORDER_NEW_CARD_SUCCESS */);
  }
  return /* @__PURE__ */ React18.createElement(Box9, { css: { padding: "$none $two" } }, /* @__PURE__ */ React18.createElement(
    ImageMessage,
    {
      image: isSuccess ? SUCCESS_IMAGE : ERROR_IMAGE,
      imageGap: "$twoAndHalf"
    },
    /* @__PURE__ */ React18.createElement(StackLayout6, { horizontalAlignment: "center", spacing: "$half" }, /* @__PURE__ */ React18.createElement(HeadingText7, { level: "3", size: "lg" }, isSuccess ? formatMessage({ id: "SUCCESS" }) : formatMessage({ id: "ERROR_STATE_TITLE" })), /* @__PURE__ */ React18.createElement(ParagraphText6, null, /* @__PURE__ */ React18.createElement(
      ParagraphText6,
      {
        as: "span",
        css: { display: "block", textAlign: "center" }
      },
      isSuccess ? formatMessage({ id: "MEMBER_CARD_ON_ITS_WAY" }) : formatMessage({ id: "ERROR_HEADING" })
    ), /* @__PURE__ */ React18.createElement(
      ParagraphText6,
      {
        as: "span",
        css: { display: "block", textAlign: "center" }
      },
      isSuccess ? formatMessage({ id: "MEMBER_CARD_ARRIVAL" }) : formatMessage({ id: "TRY_LATER" })
    )), /* @__PURE__ */ React18.createElement(
      Button3,
      {
        onClick,
        width: "fillContainer",
        css: { marginTop: "$twoAndHalf" },
        loading: isLoading,
        disabled: isLoading
      },
      isSuccess ? formatMessage({ id: "CLOSE" }) : formatMessage({ id: "RESUBMIT" })
    ))
  ));
};

// src/pages/wallet-detail/components/order-new-card/components/exit-intent-screen.component.tsx
import * as React19 from "react";
import {
  Box as Box10,
  HeadingText as HeadingText8,
  ParagraphText as ParagraphText7,
  StackLayout as StackLayout7,
  ImageMessage as ImageMessage2,
  Button as Button4
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl11 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";
import { EVENT_NAME as EVENT_NAME2 } from "@leagueplatform/analytics";
var ExitIntentScreen = ({
  cancelFunction,
  continueFunction
}) => {
  const { formatMessage } = useIntl11();
  const trackCancelEventCallback = useWalletDetailAnalytics();
  const LEAVE_OR_EXIT_WARNING_IMAGE = handleStaticAsset2(
    "LEAVE_OR_EXIT_WARNING" /* LEAVE_OR_EXIT_WARNING */
  );
  useWalletDetailScreenLoaded("order a new card cancel" /* ORDER_NEW_CARD_CANCEL_ORDER */);
  const handleClose = React19.useCallback(() => {
    trackCancelEventCallback(EVENT_NAME2.BUTTON_CLICKED, {
      screen_name: "order a new card cancel" /* ORDER_NEW_CARD_CANCEL_ORDER */,
      detail: "cancel order"
    });
    cancelFunction();
  }, [cancelFunction, trackCancelEventCallback]);
  return /* @__PURE__ */ React19.createElement(
    Box10,
    {
      css: {
        display: "flex",
        margin: "0 auto",
        backgroundColor: "$surfaceBackgroundPrimary",
        borderRadius: "$large",
        boxShadow: "$dropdown",
        flexDirection: "column",
        overflow: "hidden auto",
        width: ACTIVITY_CONTENT_BASE_WIDTH,
        gap: "$one",
        padding: "$three"
      }
    },
    /* @__PURE__ */ React19.createElement(ImageMessage2, { image: LEAVE_OR_EXIT_WARNING_IMAGE, imageGap: "$twoAndHalf" }, /* @__PURE__ */ React19.createElement(StackLayout7, { horizontalAlignment: "center", spacing: "$half" }, /* @__PURE__ */ React19.createElement(HeadingText8, { level: "3", size: "lg", css: { textAlign: "center" } }, formatMessage({ id: "CANCEL_ORDER_NEW_CARD_TITLE" })), /* @__PURE__ */ React19.createElement(ParagraphText7, null, formatMessage({ id: "CANCEL_ORDER_NEW_CARD_DESC" })), /* @__PURE__ */ React19.createElement(
      Button4,
      {
        onClick: handleClose,
        width: "fillContainer",
        css: { marginTop: "$twoAndHalf", textTransform: "capitalize" }
      },
      formatMessage({ id: "CANCEL_ORDER" })
    ), /* @__PURE__ */ React19.createElement(
      Button4,
      {
        priority: "secondary",
        onClick: continueFunction,
        width: "fillContainer",
        css: { marginTop: "$one", textTransform: "capitalize" }
      },
      formatMessage({ id: "KEEP_GOING" })
    )))
  );
};

// src/pages/wallet-detail/components/order-new-card/order-new-card.component.tsx
var HEADING_ID = "order-new-card-form";
var CardContainer = styled4(Box11, {
  display: "flex",
  backgroundColor: "$surfaceBackgroundPrimary",
  borderRadius: "$large",
  boxShadow: "$dropdown",
  flexDirection: "column",
  height: "100%",
  minWidth: "100%",
  position: "relative",
  width: "100%",
  gap: "$one",
  padding: "$twoAndHalf"
});
var OrderNewCardForm = ({
  isExiting,
  cancelFunction,
  continueFunction,
  disableConfirmExitFlag
}) => {
  const { formatMessage } = useIntl12();
  const methods = useForm();
  const { isLoading: isMembersLoading } = useSelectMembersStep();
  const {
    mutate: submitIdCard,
    isLoading: isSubmitLoading,
    status
  } = useSubmitOrderNewCardMutation();
  const newAddressSteps = React20.useMemo(
    () => [
      SelectMembersStep,
      SelectAddressStep,
      NewAddressStep,
      ConfirmationScreen,
      EndScreen
    ],
    []
  );
  const defaultAddressSteps = React20.useMemo(
    () => [SelectMembersStep, SelectAddressStep, ConfirmationScreen, EndScreen],
    []
  );
  const { isDefault: isDefault3 } = orderNewCardFormInputNames;
  const isDefaultAddress2 = methods.watch(isDefault3);
  const [steps, setSteps] = React20.useState(defaultAddressSteps);
  const [currentStep, setCurrentStep] = React20.useState(0);
  const isFooterActive = currentStep !== steps.length - 1;
  const isConfirmationScreen = currentStep === steps.length - 2;
  const modalRef = React20.useRef(null);
  const handleFocus = () => {
    var _a;
    (_a = modalRef.current) == null ? void 0 : _a.focus();
  };
  const sendBenefitAnalyticsEvent = useWalletDetailAnalytics();
  React20.useEffect(() => {
    handleFocus();
  }, [currentStep]);
  React20.useEffect(() => {
    const isDefaultAddressSelected = checkIsDefaultAddress(isDefaultAddress2);
    if (isDefaultAddressSelected === false) {
      setSteps(newAddressSteps);
    } else {
      setSteps(defaultAddressSteps);
    }
  }, [currentStep, defaultAddressSteps, isDefaultAddress2, newAddressSteps]);
  React20.useEffect(() => {
    if (status === "success" && isConfirmationScreen || status === "error" && isConfirmationScreen) {
      setCurrentStep(currentStep + 1);
      disableConfirmExitFlag();
    }
  }, [
    currentStep,
    disableConfirmExitFlag,
    isConfirmationScreen,
    status,
    steps.length
  ]);
  const goBack = () => {
    setCurrentStep(currentStep - 1);
  };
  const validateForm = () => __async(void 0, null, function* () {
    const {
      setFocus,
      trigger,
      formState: { errors, isValid }
    } = methods;
    yield trigger();
    if (isValid) {
      return true;
    }
    const firstInstanceOfError = Object.keys(errors)[0];
    setFocus(firstInstanceOfError);
    return false;
  });
  const sendOrderNewCardAnalyticsEvent = () => {
    const { memberList: memberList3 } = orderNewCardFormInputNames;
    const numberOfSelectedUsers = methods.getValues(memberList3).length;
    switch (steps[currentStep].name) {
      case "SelectMembersStep":
        sendBenefitAnalyticsEvent(EVENT_NAME3.BUTTON_CLICKED, {
          product_area: PRODUCT_AREA2.WALLET,
          screen_name: "order a new card" /* ORDER_NEW_CARD_SELECT_MEMBER_STEP */,
          detail: "select user" /* SELECT_USER */,
          sub_detail: `${numberOfSelectedUsers}`
        });
        break;
      case "SelectAddressStep":
        sendBenefitAnalyticsEvent(EVENT_NAME3.BUTTON_CLICKED, {
          product_area: PRODUCT_AREA2.WALLET,
          screen_name: "order a new card" /* ORDER_NEW_CARD_SELECT_MEMBER_STEP */,
          detail: "select a delivery address" /* SELECT_DELIVERY_ADDRESS */,
          sub_detail: "continue" /* CONTINUE */
        });
        break;
      case "NewAddressStep":
        sendBenefitAnalyticsEvent(EVENT_NAME3.BUTTON_CLICKED, {
          product_area: PRODUCT_AREA2.WALLET,
          screen_name: "order a new card enter new address" /* ORDER_NEW_CARD_NEW_ADDRESS_STEP */,
          detail: "confirm your details" /* CONFIRM_DETAILS */
        });
        break;
      case "ConfirmationScreen":
        sendBenefitAnalyticsEvent(EVENT_NAME3.BUTTON_CLICKED, {
          product_area: PRODUCT_AREA2.WALLET,
          screen_name: "order a new card confirmation screen" /* ORDER_NEW_CARD_CONFIRMATION_STEP */,
          detail: "select order card" /* SELECT_ORDER_CARD */
        });
        break;
      default:
        sendBenefitAnalyticsEvent(EVENT_NAME3.BUTTON_CLICKED, {
          product_area: PRODUCT_AREA2.WALLET,
          screen_name: "order a new card" /* ORDER_NEW_CARD_SELECT_MEMBER_STEP */
        });
        break;
    }
  };
  const onNext = () => __async(void 0, null, function* () {
    sendOrderNewCardAnalyticsEvent();
    yield validateForm();
    if (!isConfirmationScreen && methods.formState.isValid) {
      setCurrentStep(currentStep + 1);
    }
  });
  const onSubmit = React20.useCallback(
    (data) => {
      const isErrorScreen = currentStep === steps.length - 1 && status === "error";
      if (currentStep === steps.length - 2 || isErrorScreen) {
        submitIdCard(data);
      }
    },
    [currentStep, status, steps.length, submitIdCard]
  );
  const handleRetrySubmit = React20.useCallback(() => {
    const formValues = methods.getValues();
    onSubmit(formValues);
  }, [methods, onSubmit]);
  const handleKeyPress = (e) => __async(void 0, null, function* () {
    if (
      // prevent onNext from firing on the end screen
      e.key === "Enter" && currentStep !== steps.length - 1
    ) {
      yield onNext();
    }
  });
  return /* @__PURE__ */ React20.createElement(MultiStepLayout, null, isExiting && /* @__PURE__ */ React20.createElement(
    ExitIntentScreen,
    {
      cancelFunction,
      continueFunction
    }
  ), /* @__PURE__ */ React20.createElement(
    FormProvider,
    __spreadValues({}, methods),
    /* @__PURE__ */ React20.createElement(
      StackLayout8,
      {
        tabIndex: -1,
        "aria-labelledby": HEADING_ID,
        ref: modalRef,
        "aria-live": "polite",
        spacing: "$oneAndHalf",
        verticalAlignment: "center",
        css: {
          width: "100%",
          height: "100%",
          position: "static",
          display: isExiting ? "none" : "",
          // override GDS outline in favour of our own on the correct element
          "&:focus, &:focus-visible": {
            outline: "none !important"
          },
          "&:focus-visible .card-container": {
            outline: "$borderWidths$outerFocus solid $interactiveFocusOuter"
          }
        },
        as: "form",
        onSubmit: methods.handleSubmit(onSubmit),
        onKeyDown: handleKeyPress
      },
      /* @__PURE__ */ React20.createElement(CardContainer, { className: "card-container" }, /* @__PURE__ */ React20.createElement(
        HeadingText9,
        {
          id: HEADING_ID,
          size: "xl",
          level: "2",
          css: { textAlign: "center", width: "100%" }
        },
        formatMessage({ id: "ORDER_NEW_CARD_HEADING" })
      ), /* @__PURE__ */ React20.createElement(MultiStepSlider, null, steps.map((ComponentStep, i) => /* @__PURE__ */ React20.createElement(
        MultiStepSlide,
        {
          key: `step-${i}`,
          activeIndex: currentStep,
          slideIndex: i
        },
        /* @__PURE__ */ React20.createElement(
          ComponentStep,
          {
            status,
            onClick: status === "success" ? cancelFunction : handleRetrySubmit
          }
        )
      )))),
      isFooterActive && /* @__PURE__ */ React20.createElement(
        OrderNewCardFooter,
        {
          totalPages: steps.length - 1,
          currentPage: currentStep,
          onNext,
          onPrev: goBack,
          onSubmit,
          isLoading: isSubmitLoading,
          disabled: isMembersLoading || isSubmitLoading
        }
      )
    )
  ));
};

// src/components/action-sub-links/hooks/use-save-html-card.hook.ts
import { useCallback as useCallback4 } from "react";

// src/components/action-sub-links/action-sub-links.component.tsx
var ActionIcon = ({ url = "", alt = "", variant = "primary" }) => {
  const isPrimaryIcon = variant === "primary";
  const WIDTH = isPrimaryIcon ? 24 : "auto";
  const MAX_WIDTH2 = isPrimaryIcon ? WIDTH : 16;
  const MARGIN = isPrimaryIcon ? "threeQuarters" : "half";
  if (!url && isPrimaryIcon) {
    return /* @__PURE__ */ React21.createElement(
      Icon4,
      {
        icon: "descriptiveDocument",
        css: { marginInlineEnd: "$threeQuarters", flexShrink: "0" },
        label: ""
      }
    );
  }
  return /* @__PURE__ */ React21.createElement(
    Image3,
    {
      alt,
      marginInlineStart: !isPrimaryIcon ? MARGIN : void 0,
      marginInlineEnd: isPrimaryIcon ? MARGIN : void 0,
      minWidth: WIDTH,
      src: url,
      width: WIDTH,
      maxWidth: MAX_WIDTH2
    }
  );
};
var GenericLink = ({
  action,
  className,
  onClickCallback,
  primaryIcon,
  secondaryIcon
}) => {
  const { url, name } = action;
  return /* @__PURE__ */ React21.createElement(
    TextAction,
    {
      css: {
        display: "flex",
        justifyContent: secondaryIcon ? "space-between" : "flex-start"
      },
      onClick: onClickCallback,
      href: url,
      className
    },
    !action.primary && /* @__PURE__ */ React21.createElement(ActionIcon, { url: primaryIcon, alt: "" }),
    /* @__PURE__ */ React21.createElement(
      Box12,
      {
        as: "span",
        css: {
          flexGrow: secondaryIcon ? "1" : void 0,
          textAlign: "start",
          maxWidth: "100%"
        }
      },
      name
    ),
    secondaryIcon && /* @__PURE__ */ React21.createElement(
      ActionIcon,
      {
        url: secondaryIcon.url,
        alt: secondaryIcon.alt,
        variant: "secondary"
      }
    )
  );
};
var DocumentLink = ({
  action,
  className,
  onClickCallback,
  primaryIcon,
  secondaryIcon
}) => {
  const { name, url, id } = action;
  const isCardInfo = id === ACTION_IDS.CARD_INFO;
  const slugifySettings = {
    remove: /[$*_+~.()'"!:@%]/g,
    lower: true
  };
  const classNameUrlPart = (url == null ? void 0 : url.split("/").slice(-1)[0]) || "";
  const sectionId = isCardInfo ? TAB_IDS.CARD_INFO : slugify(classNameUrlPart, slugifySettings);
  const contentfulUrl = getContentUrl(sectionId);
  return /* @__PURE__ */ React21.createElement(
    TextAction,
    {
      className,
      css: {
        display: "flex",
        justifyContent: secondaryIcon ? "space-between" : "flex-start"
      },
      href: contentfulUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: onClickCallback
    },
    !action.primary && /* @__PURE__ */ React21.createElement(ActionIcon, { url: primaryIcon, alt: "" }),
    /* @__PURE__ */ React21.createElement(
      Box12,
      {
        as: "span",
        css: {
          flexGrow: secondaryIcon ? "1" : void 0,
          textAlign: "start",
          maxWidth: "100%"
        }
      },
      name
    ),
    secondaryIcon && /* @__PURE__ */ React21.createElement(
      ActionIcon,
      {
        url: secondaryIcon.url,
        alt: secondaryIcon.alt,
        variant: "secondary"
      }
    )
  );
};
var AuthExternalLink = ({
  action,
  className,
  onClickCallback,
  primaryIcon,
  secondaryIcon
}) => {
  const { name, url } = action;
  const handleLinkCallback = useConfigProperty("core.customMethods.handleLink");
  return /* @__PURE__ */ React21.createElement(
    TextAction,
    {
      className,
      css: {
        display: "flex",
        justifyContent: secondaryIcon ? "space-between" : "flex-start"
      },
      href: url,
      onClick: (event) => {
        event.preventDefault();
        handleLinkCallback(url || "");
        onClickCallback();
      }
    },
    !action.primary && /* @__PURE__ */ React21.createElement(ActionIcon, { url: primaryIcon, alt: "" }),
    /* @__PURE__ */ React21.createElement(
      Box12,
      {
        as: "span",
        css: {
          flexGrow: secondaryIcon ? "1" : void 0,
          textAlign: "start",
          maxWidth: "100%"
        }
      },
      name
    ),
    secondaryIcon && /* @__PURE__ */ React21.createElement(
      ActionIcon,
      {
        url: secondaryIcon.url,
        alt: secondaryIcon.alt,
        variant: "secondary"
      }
    )
  );
};
var InternalLink = ({
  action,
  className,
  onClickCallback,
  primaryIcon,
  secondaryIcon
}) => {
  const { name, url, primary: isPrimary } = action;
  return /* @__PURE__ */ React21.createElement(
    TextAction,
    {
      as: LinkDOM,
      css: {
        display: "flex",
        justifyContent: secondaryIcon ? "space-between" : "flex-start",
        width: "100%"
      },
      onClick: onClickCallback,
      className,
      to: url || ""
    },
    !isPrimary && /* @__PURE__ */ React21.createElement(ActionIcon, { url: primaryIcon, alt: "" }),
    /* @__PURE__ */ React21.createElement(
      Box12,
      {
        as: "span",
        css: {
          flexGrow: secondaryIcon ? "1" : void 0,
          textAlign: "start",
          maxWidth: "100%"
        }
      },
      name
    ),
    secondaryIcon && /* @__PURE__ */ React21.createElement(
      ActionIcon,
      {
        url: secondaryIcon.url,
        alt: secondaryIcon.alt,
        variant: "secondary"
      }
    )
  );
};
var PhoneLink = ({
  action,
  onClickCallback,
  className,
  primaryIcon
}) => {
  const { url, name } = action;
  const phoneNumber = formatPhoneNumber(url == null ? void 0 : url.replace(/\D/g, ""));
  return /* @__PURE__ */ React21.createElement(Box12, { css: { display: "inline-block" }, className }, /* @__PURE__ */ React21.createElement(
    SubtitleOne,
    {
      as: "p",
      display: "flex",
      alignItems: "center",
      color: "interactive.action.primary"
    },
    !action.primary && /* @__PURE__ */ React21.createElement(ActionIcon, { url: primaryIcon, alt: "" }),
    /* @__PURE__ */ React21.createElement(
      Box12,
      {
        as: "span",
        css: {
          display: "inline-block",
          color: "$onSurfaceTextPrimary",
          maxWidth: "100%"
        }
      },
      name,
      /* @__PURE__ */ React21.createElement(
        TextAction,
        {
          css: { display: "block" },
          href: url,
          onClick: () => {
            onClickCallback();
          }
        },
        phoneNumber
      )
    )
  ));
};
var GenericContentAction = ({
  action,
  onClickCallback,
  className,
  primaryIcon,
  secondaryIcon
}) => {
  const [isShown, setIsShown] = useState3(false);
  const { title, body, name } = action;
  const { formatMessage } = useIntl13();
  return /* @__PURE__ */ React21.createElement(
    Modal2.Root,
    {
      open: isShown,
      onOpenChange: () => {
        setIsShown((previous) => !previous);
        onClickCallback();
      }
    },
    /* @__PURE__ */ React21.createElement(Modal2.Trigger, null, /* @__PURE__ */ React21.createElement(
      TextAction,
      {
        as: "button",
        className,
        css: {
          display: "flex",
          justifyContent: secondaryIcon ? "space-between" : "flex-start",
          width: "100%"
        }
      },
      !action.primary && /* @__PURE__ */ React21.createElement(ActionIcon, { url: primaryIcon, alt: "" }),
      /* @__PURE__ */ React21.createElement(
        Box12,
        {
          as: "span",
          css: {
            flexGrow: secondaryIcon ? "1" : void 0,
            textAlign: "start",
            maxWidth: "100%"
          }
        },
        name
      ),
      secondaryIcon && /* @__PURE__ */ React21.createElement(
        ActionIcon,
        {
          url: secondaryIcon.url,
          alt: secondaryIcon.alt,
          variant: "secondary"
        }
      )
    )),
    /* @__PURE__ */ React21.createElement(
      GenericContentModal,
      {
        title,
        description: body,
        buttonText: formatMessage({ id: "CLOSE" })
      }
    )
  );
};
var UnavailableAction = ({
  action,
  onClickCallback,
  className,
  primaryIcon,
  secondaryIcon
}) => {
  const { formatMessage } = useIntl13();
  const [isShown, setIsShown] = useState3(false);
  const {
    unavailable_action: unavailableAction,
    name,
    primary: isPrimary
  } = action;
  return /* @__PURE__ */ React21.createElement(
    Modal2.Root,
    {
      open: isShown,
      onOpenChange: () => {
        setIsShown((previous) => !previous);
        onClickCallback();
      }
    },
    /* @__PURE__ */ React21.createElement(Modal2.Trigger, null, /* @__PURE__ */ React21.createElement(
      TextAction,
      {
        as: "button",
        className,
        css: {
          display: "flex",
          justifyContent: secondaryIcon ? "space-between" : "flex-start",
          width: "100%"
        }
      },
      !isPrimary && /* @__PURE__ */ React21.createElement(ActionIcon, { url: primaryIcon, alt: "" }),
      /* @__PURE__ */ React21.createElement(
        Box12,
        {
          as: "span",
          css: {
            flexGrow: secondaryIcon ? "1" : void 0,
            textAlign: "start",
            maxWidth: "100%"
          }
        },
        name
      ),
      secondaryIcon && /* @__PURE__ */ React21.createElement(
        ActionIcon,
        {
          url: secondaryIcon.url,
          alt: secondaryIcon.alt,
          variant: "secondary"
        }
      )
    )),
    /* @__PURE__ */ React21.createElement(
      GenericContentModal,
      {
        title: unavailableAction == null ? void 0 : unavailableAction.title,
        description: unavailableAction == null ? void 0 : unavailableAction.description,
        imageSrc: unavailableAction == null ? void 0 : unavailableAction.logo_url,
        buttonText: formatMessage({ id: "CLOSE" }),
        phoneNumber: unavailableAction == null ? void 0 : unavailableAction.phone_number
      }
    )
  );
};
var ClaimsLink = ({
  action,
  className,
  onClickCallback,
  primaryIcon,
  secondaryIcon
}) => {
  let claimsTypeURL = action.url;
  const urlParams = new URLSearchParams(action.url);
  if (urlParams.has("type")) {
    claimsTypeURL = `${getModulePath(
      LEAGUE_MODULE_NAMES.claims
    )}?type=${urlParams.get("type")}`;
  }
  return /* @__PURE__ */ React21.createElement(
    InternalLink,
    {
      action: __spreadProps(__spreadValues({}, action), { url: claimsTypeURL }),
      className,
      onClickCallback,
      primaryIcon,
      secondaryIcon
    }
  );
};
var PrintCardLink = ({
  action,
  className,
  onClickCallback,
  primaryIcon
}) => {
  const { name, primary: isPrimary, cardRef } = action;
  const pageStyle = `
  @page {
    margin: 1in;
  }

  .wallet-print-card {
    width: 3.375in;
  }

  .wallet-print-card a, .wallet-print-card button {
    display: none;
  }
`;
  const handlePrint = useReactToPrint({
    content: () => cardRef.current,
    pageStyle
  });
  return /* @__PURE__ */ React21.createElement(
    TextAction,
    {
      as: "button",
      onClick: () => {
        onClickCallback();
        handlePrint();
      },
      className
    },
    !isPrimary && /* @__PURE__ */ React21.createElement(ActionIcon, { url: primaryIcon, alt: "" }),
    /* @__PURE__ */ React21.createElement(Box12, { as: "span", css: { textAlign: "start", maxWidth: "100%" } }, name)
  );
};
var OrderNewCardAction = ({
  action,
  onClickCallback,
  className,
  primaryIcon,
  secondaryIcon
}) => {
  const { formatMessage } = useIntl13();
  const [isShown, setIsShown] = useState3(false);
  const [isExiting, setIsExiting] = useState3(false);
  const [isConfirmExitFlagEnabled, setIsConfirmExitFlagEnabled] = useState3(true);
  const { name, primary: isPrimary } = action;
  const handleClose = () => {
    if (isConfirmExitFlagEnabled && !isExiting) {
      setIsExiting(true);
      return;
    }
    setIsShown(false);
    setIsExiting(false);
    setIsConfirmExitFlagEnabled(true);
  };
  const handleContinueOrder = () => {
    setIsExiting(false);
  };
  const disableConfirmExitFlag = () => {
    setIsConfirmExitFlagEnabled(false);
  };
  return /* @__PURE__ */ React21.createElement(
    Modal2.Root,
    {
      open: isShown,
      onOpenChange: (isOpen) => {
        if (isOpen === false) {
          handleClose();
          return;
        }
        setIsShown(true);
        onClickCallback();
      }
    },
    /* @__PURE__ */ React21.createElement(Modal2.Trigger, null, /* @__PURE__ */ React21.createElement(
      TextAction,
      {
        as: "button",
        className,
        css: {
          display: "flex",
          justifyContent: secondaryIcon ? "space-between" : "flex-start",
          width: "100%"
        }
      },
      !isPrimary && /* @__PURE__ */ React21.createElement(ActionIcon, { url: primaryIcon, alt: "" }),
      /* @__PURE__ */ React21.createElement(
        Box12,
        {
          as: "span",
          css: {
            flexGrow: secondaryIcon ? "1" : void 0,
            textAlign: "start",
            maxWidth: "100%"
          }
        },
        name
      ),
      secondaryIcon && /* @__PURE__ */ React21.createElement(
        ActionIcon,
        {
          url: secondaryIcon.url,
          alt: secondaryIcon.alt,
          variant: "secondary"
        }
      )
    )),
    /* @__PURE__ */ React21.createElement(
      Modal2.Content,
      {
        forceModalFocus: true,
        layout: "fullscreen",
        css: {
          ".GDS-modal": {
            width: "100vw",
            insetInlineStart: "0",
            height: "100vh",
            borderRadius: "$none",
            backgroundColor: "$surfaceBackgroundTertiary"
          },
          ".GDS-modal-close-button-wrapper": {
            display: "none"
          }
        }
      },
      /* @__PURE__ */ React21.createElement(
        HeadingBar,
        {
          css: { backgroundColor: "transparent" },
          trailingAction: /* @__PURE__ */ React21.createElement(
            Button5,
            {
              css: { "& > *": { paddingInlineEnd: 0 } },
              priority: "secondary",
              quiet: true,
              icon: "tinyClose",
              size: "medium",
              onClick: handleClose
            },
            /* @__PURE__ */ React21.createElement(VisuallyHidden2, null, formatMessage({ id: "CLOSE" }))
          )
        }
      ),
      /* @__PURE__ */ React21.createElement(Modal2.Title, null, /* @__PURE__ */ React21.createElement(VisuallyHidden2, null, formatMessage({ id: "ORDER_NEW_CARD_HEADING" }))),
      /* @__PURE__ */ React21.createElement(Modal2.Description, null, /* @__PURE__ */ React21.createElement(
        OrderNewCardForm,
        {
          isExiting,
          cancelFunction: handleClose,
          continueFunction: handleContinueOrder,
          disableConfirmExitFlag
        }
      ))
    )
  );
};

// src/hooks/use-action-link.hook.ts
var useActionLink = (action) => {
  const { name, url, primary, system_type: systemType } = action || {};
  const sendBenefitActionAnalyticsEvent = useWalletDetailAnalytics();
  const LinkComponent = useMemo7(() => {
    if (!action) {
      return void 0;
    }
    if (isOrderNewCardAction(action)) {
      return OrderNewCardAction;
    }
    if (isPrintCardAction(action)) {
      return PrintCardLink;
    }
    if (isSaveCardAction(action)) {
      return PrintCardLink;
    }
    if (isPhoneNumberAction(action)) {
      return PhoneLink;
    }
    if (isUnavailableAction(action)) {
      return UnavailableAction;
    }
    if (isGenericContentModal(action)) {
      return GenericContentAction;
    }
    if (isBenefitDocumentAction(action)) {
      return DocumentLink;
    }
    if (isEmailLinkAction(action)) {
      return GenericLink;
    }
    if (!isExternalLinkAction(action) || isSubmitClaimAction(action)) {
      return InternalLink;
    }
    if (isClaimsAction(action)) {
      return ClaimsLink;
    }
    return AuthExternalLink;
  }, [action]);
  const handleActionClick = useCallback5(() => {
    sendBenefitActionAnalyticsEvent(EVENT_NAME4.RESOURCE_CLICKED, {
      detail: primary ? "primary call to action" : "list action",
      sub_detail: name,
      resource_type: systemType,
      resource_id: url || null
    });
  }, [sendBenefitActionAnalyticsEvent, primary, name, systemType, url]);
  return { LinkComponent, handleActionClick };
};

// src/components/wallet-card/components/card-action.component.tsx
var CardAction = ({ action }) => {
  const { LinkComponent, handleActionClick } = useActionLink(action);
  if (!LinkComponent) {
    return null;
  }
  const { icon_url: icon, nav_icon: secondaryIcon } = action;
  return (
    // @ts-ignore-next-line
    /* @__PURE__ */ React22.createElement(
      Button6,
      {
        as: LinkComponent,
        action,
        onClickCallback: handleActionClick,
        primaryIcon: icon,
        secondaryIcon,
        css: {
          "&&": {
            width: "100%",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center"
          },
          // Some styles have the same specificity and so clash
          // These styles make the button look like secondary button
          borderColor: "$secondaryBorderDefault",
          color: "$secondaryTextDefault",
          borderRadius: "$button",
          borderWidth: "$thin",
          borderStyle: "solid",
          "&:hover, &:focus": {
            textDecoration: "none"
          }
        },
        priority: "secondary"
      }
    )
  );
};

// src/components/wallet-card/components/card-actions.component.tsx
var DesktopContainer = styled5("div", {
  display: "block",
  "@mobile": {
    display: "none"
  }
});
var MobileContainer = styled5("div", {
  display: "none",
  "@mobile": {
    display: "block"
  }
});
var CardActions = ({ cardRef }) => {
  const { formatMessage } = useIntl14();
  const { actions } = useCardActions({ cardRef });
  const sendBenefitActionAnalyticsEvent = useWalletDetailAnalytics();
  if (!actions.length)
    return null;
  if (actions.length === 1) {
    return /* @__PURE__ */ React23.createElement(StackLayout9, { as: "ul" }, actions.map((action) => /* @__PURE__ */ React23.createElement(Box13, { as: "li", key: `${action.id}-card-action-desktop` }, /* @__PURE__ */ React23.createElement(CardAction, { action }))));
  }
  return /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement(MobileContainer, null, /* @__PURE__ */ React23.createElement(Popover.Root, null, /* @__PURE__ */ React23.createElement(Popover.Trigger, null, /* @__PURE__ */ React23.createElement(
    Button7,
    {
      icon: "interfaceMeatballs",
      priority: "secondary",
      width: "fillContainer",
      onClick: () => sendBenefitActionAnalyticsEvent(EVENT_NAME5.BUTTON_CLICKED, {
        detail: "select card actions"
      })
    },
    formatMessage({ id: "CARD_ACTIONS" })
  )), /* @__PURE__ */ React23.createElement(Popover.Content, { align: "start", side: "bottom", showCloseButton: false }, /* @__PURE__ */ React23.createElement(StackLayout9, { as: "ul" }, actions.map((action) => /* @__PURE__ */ React23.createElement(Box13, { as: "li", key: `${action.id}-card-action-mobile` }, /* @__PURE__ */ React23.createElement(CardAction, { action }))))))), /* @__PURE__ */ React23.createElement(DesktopContainer, null, /* @__PURE__ */ React23.createElement(StackLayout9, { as: "ul" }, actions.map((action) => /* @__PURE__ */ React23.createElement(Box13, { as: "li", key: `${action.id}-card-action-desktop` }, /* @__PURE__ */ React23.createElement(CardAction, { action }))))));
};

// src/components/wallet-card/wallet-card.component.tsx
var WalletCard = ({ card: cardHtml }) => {
  const { isImageCard, cardFaces } = useWalletCard(cardHtml);
  const cardsRef = useRef3(null);
  if (!cardFaces.length) {
    return null;
  }
  return /* @__PURE__ */ React24.createElement(Box14, { ref: cardsRef, className: "wallet-print-card" }, /* @__PURE__ */ React24.createElement(
    StackLayout10,
    {
      space: "$one",
      css: {
        marginInlineStart: "auto",
        marginInlineEnd: "auto"
      }
    },
    cardFaces.map((cardFace, i) => {
      if (!isImageCard) {
        return /* @__PURE__ */ React24.createElement(
          Card,
          {
            key: `card-face-${i === 0 ? "front" : "back"}`,
            minHeight: 168,
            width: 280,
            dangerouslySetInnerHTML: {
              __html: cardFace.src
            }
          }
        );
      }
      return /* @__PURE__ */ React24.createElement(
        Image4,
        {
          key: `card-face-${i === 0 ? "front" : "back"}`,
          maxWidth: "100%",
          loading: "eager",
          src: cardFace.src,
          alt: cardFace.description
        }
      );
    }),
    /* @__PURE__ */ React24.createElement(CardActions, { cardRef: cardsRef })
  ));
};

// src/components/coverage/coverage.component.tsx
import React29 from "react";
import { useIntl as useIntl18 } from "@leagueplatform/locales";
import {
  ParagraphText as ParagraphText8,
  FormField,
  TextInput as TextInput2,
  Icon as Icon7
} from "@leagueplatform/genesis-core";
import {
  Box as Box18,
  css as css5,
  Flex as Flex6,
  genesisStyled as genesisStyled4,
  VisuallyHidden as VisuallyHidden3,
  Link
} from "@leagueplatform/genesis-commons";

// src/components/coverage/constants/coverage.constants.js
var COVERED = "covered";
var NOT_COVERED = "not_covered";
var PARTIAL = "partial";

// src/components/coverage/components/icons.component.tsx
import React25 from "react";
import { useIntl as useIntl15 } from "@leagueplatform/locales";
import { Icon as Icon5, ICONS, vars } from "@leagueplatform/ui-kit";
var CoveredIcon = (_a) => {
  var _b = _a, { size, title } = _b, rest = __objRest(_b, ["size", "title"]);
  return /* @__PURE__ */ React25.createElement(
    Icon5,
    __spreadValues({
      icon: ICONS.CHECK,
      size,
      colour: vars.colour.functional.green,
      title
    }, rest)
  );
};
var NotCoveredIcon = (_a) => {
  var _b = _a, { size, title } = _b, rest = __objRest(_b, ["size", "title"]);
  return /* @__PURE__ */ React25.createElement(
    Icon5,
    __spreadValues({
      icon: ICONS.X,
      size,
      colour: vars.colour.red,
      title
    }, rest)
  );
};
var PartialCoverageIcon = (_a) => {
  var _b = _a, { size, title } = _b, rest = __objRest(_b, ["size", "title"]);
  return /* @__PURE__ */ React25.createElement(
    Icon5,
    __spreadValues({
      icon: ICONS.WARNING,
      size,
      colour: vars.colour.purple,
      title
    }, rest)
  );
};
var CoverageIcon = ({ coverage, embedded }) => {
  const { formatMessage } = useIntl15();
  switch (coverage) {
    case COVERED:
      return /* @__PURE__ */ React25.createElement(
        CoveredIcon,
        {
          title: formatMessage({ id: "COVERED" }),
          size: embedded ? "20px" : "1.5em"
        }
      );
    case PARTIAL:
      return /* @__PURE__ */ React25.createElement(
        PartialCoverageIcon,
        {
          title: formatMessage({ id: "COVERED_WITH_RESTRICTIONS" }),
          size: embedded ? "20px" : "1.5em"
        }
      );
    case NOT_COVERED:
      return /* @__PURE__ */ React25.createElement(
        NotCoveredIcon,
        {
          title: formatMessage({ id: "NOT_COVERED" }),
          size: embedded ? "20px" : "1.5em"
        }
      );
    default:
      return null;
  }
};
var ExampleIcon = (props) => /* @__PURE__ */ React25.createElement(
  Icon5,
  __spreadValues({
    icon: ICONS.LIGHT_BULB,
    size: "1.5rem",
    colour: vars.colour.yellow,
    "aria-hidden": true
  }, props)
);
var RestrictionIcon = (props) => /* @__PURE__ */ React25.createElement(
  Icon5,
  __spreadValues({
    icon: ICONS.ASTERISK,
    size: "1.5rem",
    colour: vars.colour.purple,
    "aria-hidden": true
  }, props)
);

// src/components/coverage/components/category-group.component.tsx
import React27, { useCallback as useCallback6 } from "react";
import {
  Box as Box16,
  css as css4,
  Flex as Flex5,
  genesisStyled as genesisStyled3,
  HeadingThree
} from "@leagueplatform/genesis-commons";
import { Icon as Icon6 } from "@leagueplatform/genesis-core";

// src/components/coverage/components/category.component.tsx
import React26 from "react";
import { useIntl as useIntl16 } from "@leagueplatform/locales";
import {
  Box as Box15,
  Flex as Flex4,
  HeadingFour,
  BodyOne
} from "@leagueplatform/genesis-commons";
var Category = ({
  name,
  coverage,
  description,
  examples,
  restriction,
  onCategorySelect,
  id,
  embedded
}) => {
  const { formatMessage } = useIntl16();
  return /* @__PURE__ */ React26.createElement(
    Flex4,
    {
      onClick: () => {
        if (coverage !== NOT_COVERED) {
          onCategorySelect(id);
        }
      },
      embedded,
      isCovered: coverage !== NOT_COVERED,
      backgroundColor: "transparent"
    },
    /* @__PURE__ */ React26.createElement(Box15, { padding: "one" }, /* @__PURE__ */ React26.createElement(Flex4, { marginBottom: "one", alignItems: "center" }, /* @__PURE__ */ React26.createElement(
      HeadingFour,
      {
        as: "h3",
        fontSize: ["heading4", "heading4", "heading3"],
        fontWeight: "regular"
      },
      /* @__PURE__ */ React26.createElement(CoverageIcon, { coverage, embedded }),
      /* @__PURE__ */ React26.createElement(Box15, { as: "span", marginInlineStart: "one" }, name)
    )), (description || examples || restriction) && /* @__PURE__ */ React26.createElement(Box15, { paddingBottom: "half", marginInlineStart: ["none", "none", "two"] }, description && /* @__PURE__ */ React26.createElement(BodyOne, { paddingInlineEnd: ["half", "one", "four"] }, description), examples && /* @__PURE__ */ React26.createElement(Box15, { marginTop: "one", paddingInlineEnd: "two" }, /* @__PURE__ */ React26.createElement(Flex4, { alignItems: "center", marginBottom: "quarter" }, /* @__PURE__ */ React26.createElement(ExampleIcon, { role: "presentation" }), /* @__PURE__ */ React26.createElement(BodyOne, { fontWeight: "regular", marginInlineStart: "half" }, formatMessage({ id: "EXAMPLES" }))), examples.map((example) => /* @__PURE__ */ React26.createElement(BodyOne, { key: example }, example))), restriction && /* @__PURE__ */ React26.createElement(Box15, { marginTop: "one", paddingInlineEnd: "two" }, /* @__PURE__ */ React26.createElement(Flex4, { alignItems: "center", marginBottom: "quarter" }, /* @__PURE__ */ React26.createElement(RestrictionIcon, { role: "presentation" }), /* @__PURE__ */ React26.createElement(BodyOne, { marginInlineStart: "half", fontWeight: "regular" }, formatMessage({ id: "RESTRICTIONS" }))), /* @__PURE__ */ React26.createElement(BodyOne, null, restriction))))
  );
};

// src/components/coverage/components/category-group.component.tsx
var ListItem = genesisStyled3(Box16)(
  css4({
    backgroundColor: "surface.background.primary",
    borderBottomWidth: "thin",
    borderColor: "onSurface.border.subdued",
    borderInlineStartWidth: "thin",
    borderStyle: "solid",
    "&:first-of-type": { borderTop: "none" },
    "&:last-of-type": { borderBottom: "none" }
  })
);
var ExpandButton = genesisStyled3(Flex5)(
  css4({
    backgroundColor: "inherit",
    border: "none",
    color: "inherit",
    cursor: "pointer",
    fontSize: "inherit",
    fontWeight: "normal",
    justifyContent: "spaceBetween",
    padding: ["one", "one", "two"],
    paddingInlineEnd: "one",
    textAlign: "inherit",
    width: "100%",
    '&[aria-expanded="true"]': {
      borderBottom: "solid",
      borderBottomWidth: "thin",
      borderColor: "onSurface.border.subdued"
    }
  })
);
var CategoryGroup = ({
  id,
  name: groupName,
  coverage: groupCoverage,
  categories,
  isExpanded,
  onToggleExpand,
  onCategorySelect,
  embedded = false
}) => {
  const toggleExpandCallback = useCallback6(
    () => onToggleExpand(id),
    [id, onToggleExpand]
  );
  const HEADING_ID2 = `${id}-heading`;
  return /* @__PURE__ */ React27.createElement(React27.Fragment, null, /* @__PURE__ */ React27.createElement(
    HeadingThree,
    {
      as: "h2",
      alignContent: "center",
      display: "flex",
      fontSize: ["heading4", "heading4", "heading3"],
      id: HEADING_ID2,
      justifyContent: "space-between"
    },
    /* @__PURE__ */ React27.createElement(
      ExpandButton,
      {
        "aria-expanded": isExpanded,
        "aria-controls": id,
        as: "button",
        onClick: toggleExpandCallback
      },
      /* @__PURE__ */ React27.createElement(Flex5, { flexGrow: 1, alignItems: "center", as: "span" }, /* @__PURE__ */ React27.createElement(
        Box16,
        {
          display: ["none", "none", "block"],
          paddingInlineEnd: "one",
          as: "span"
        },
        /* @__PURE__ */ React27.createElement(CoverageIcon, { coverage: groupCoverage, embedded })
      ), /* @__PURE__ */ React27.createElement(Box16, { as: "span" }, groupName)),
      /* @__PURE__ */ React27.createElement(Box16, { flexGrow: "0", as: "span" }, /* @__PURE__ */ React27.createElement(
        Icon6,
        {
          icon: isExpanded ? "interfaceChevronDown" : "interfaceChevronForward"
        }
      ))
    )
  ), /* @__PURE__ */ React27.createElement(
    Box16,
    {
      "aria-labelledby": HEADING_ID2,
      backgroundColor: "surface.background.secondary",
      display: isExpanded ? "block" : "none",
      id,
      paddingInlineStart: ["one", "one", "four"],
      role: "region"
    },
    /* @__PURE__ */ React27.createElement(Box16, { as: "ul" }, categories == null ? void 0 : categories.map((category) => /* @__PURE__ */ React27.createElement(ListItem, { as: "li", key: category.unique_id }, /* @__PURE__ */ React27.createElement(
      Category,
      {
        id: category.unique_id,
        name: category.category,
        coverage: category.coverage,
        description: category.description,
        examples: category.examples,
        restriction: category.restriction,
        onCategorySelect,
        embedded
      }
    ))))
  ));
};

// src/components/coverage/components/empty-search.component.tsx
import React28 from "react";
import { useIntl as useIntl17 } from "@leagueplatform/locales";
import {
  BodyOne as BodyOne2,
  HeadingTwo,
  Image as Image5,
  Box as Box17
} from "@leagueplatform/genesis-commons";
import { handleStaticAsset as handleStaticAsset3 } from "@leagueplatform/asset-config";
var EmptySearch = ({ query }) => {
  const { formatMessage } = useIntl17();
  return /* @__PURE__ */ React28.createElement(Box17, { textAlign: "center" }, /* @__PURE__ */ React28.createElement(
    Image5,
    {
      src: handleStaticAsset3("ICON_SEARCH_EMPTY" /* ICON_SEARCH_EMPTY */),
      role: "presentation",
      width: 86.36,
      height: 100,
      marginTop: "two"
    }
  ), /* @__PURE__ */ React28.createElement(HeadingTwo, { color: "onSurface.text.subdued", paddingY: "oneAndHalf" }, formatMessage(
    {
      id: "COVERAGE_SEARCH_QUERY_NOT_FOUND",
      defaultMessage: "{query} could not be found."
    },
    { query }
  )), /* @__PURE__ */ React28.createElement(BodyOne2, { color: "onSurface.text.subdued", fontStyle: "italic" }, formatMessage({
    id: "COVERAGE_SEARCH_TRY_AGAIN",
    defaultMessage: "Try searching again using a different keyword."
  })));
};

// src/components/coverage/hooks/use-coverage.hook.ts
import {
  sendAnalyticsEvent,
  sendAnalyticsPageView
} from "@leagueplatform/analytics";
import { TYPING_DEBOUNCE_INTERVAL } from "@leagueplatform/web-common";
import { debounce } from "lodash";
import { useCallback as useCallback7, useEffect as useEffect3, useMemo as useMemo8, useReducer } from "react";

// src/components/coverage/utils/get-distinct-coverage-types-in-tree.util.ts
function getDistinctCoverageTypesInTree(categories = []) {
  const coverageTypes = categories.reduce(
    (types, category) => {
      var _a;
      const subcategoryCoverageTypes = getDistinctCoverageTypesInTree(
        (_a = category.sub) != null ? _a : []
      );
      return /* @__PURE__ */ new Set([
        ...Array.from(types),
        category.coverage,
        ...subcategoryCoverageTypes
      ]);
    },
    /* @__PURE__ */ new Set()
  );
  return Array.from(coverageTypes);
}

// src/components/coverage/hooks/queries/use-coverage-query.hook.ts
import { useQuery as useQuery3 } from "@tanstack/react-query";
import {
  getUserBenefitCategories,
  getEmployerBenefitCategories,
  GET_EMPLOYER_BENEFIT_CATEGORIES_MESSAGE_TYPE,
  GET_USER_BENEFIT_CATEGORIES_MESSAGE_TYPE
} from "@leagueplatform/wallet-api";
function useCoverageQuery({
  asOfDate,
  query,
  version = 1,
  employer,
  userId,
  benefitId
}, options) {
  const { userId: walletUserId, benefitId: walletBenefitId } = useWalletParams();
  const coverageUserId = userId != null ? userId : walletUserId;
  const coverageBenefitId = benefitId != null ? benefitId : walletBenefitId;
  const getCoverageCategories = employer ? getEmployerBenefitCategories : getUserBenefitCategories;
  const messageType = employer ? GET_EMPLOYER_BENEFIT_CATEGORIES_MESSAGE_TYPE : GET_USER_BENEFIT_CATEGORIES_MESSAGE_TYPE;
  return useQuery3(
    [messageType, coverageUserId, benefitId, query, version],
    () => getCoverageCategories(
      coverageUserId,
      coverageBenefitId,
      asOfDate,
      query,
      version
    ),
    __spreadValues({ select: (data) => {
      var _a;
      return (_a = data.categories) != null ? _a : [];
    } }, options)
  );
}

// src/components/coverage/hooks/use-coverage.hook.ts
var initialState = {
  query: "",
  displayQuery: "",
  expandedIds: [],
  categories: void 0,
  coverage: [],
  isTree: false
};
function coverageReducer(state2, action) {
  var _a;
  switch (action.type) {
    case "UPDATE_CATEGORIES": {
      const { categories } = action.payload;
      const isTree = Boolean(categories == null ? void 0 : categories.some((category) => !!category.sub));
      const hasQuery = Boolean(state2.query);
      const expandedIds = hasQuery ? categories == null ? void 0 : categories.map((c) => c.unique_id) : [];
      const coverage = getDistinctCoverageTypesInTree(categories);
      return __spreadProps(__spreadValues({}, state2), {
        isTree,
        expandedIds,
        categories,
        displayQuery: state2.query,
        coverage
      });
    }
    case "SET_SEARCH_QUERY": {
      const { query } = action.payload;
      return __spreadProps(__spreadValues({}, state2), {
        query
      });
    }
    case "EXPAND_ALL": {
      const { categories } = state2;
      const categoryIds = (_a = categories == null ? void 0 : categories.map((c) => c.unique_id)) != null ? _a : [];
      return __spreadProps(__spreadValues({}, state2), { expandedIds: categoryIds });
    }
    case "COLLAPSE_ALL": {
      return __spreadProps(__spreadValues({}, state2), { expandedIds: [] });
    }
    case "TOGGLE_EXPAND": {
      const { expandedIds } = state2;
      const { id } = action.payload;
      let newExpandedIds;
      if (expandedIds.includes(id)) {
        newExpandedIds = expandedIds.filter((val) => val !== id);
      } else {
        newExpandedIds = [...expandedIds, id];
      }
      return __spreadProps(__spreadValues({}, state2), {
        expandedIds: newExpandedIds
      });
    }
    default: {
      return state2;
    }
  }
}
function useCoverage(employer, benefitType, userId, benefitId) {
  useEffect3(() => {
    if (benefitType) {
      sendAnalyticsPageView({
        title: `Coverage Summary - ${benefitType}`
      });
    }
  }, [benefitType]);
  const [coverageState, dispatch] = useReducer(coverageReducer, initialState);
  const onExpandAll = useCallback7(() => dispatch({ type: "EXPAND_ALL" }), []);
  const onCollapseAll = useCallback7(
    () => dispatch({ type: "COLLAPSE_ALL" }),
    []
  );
  const onToggleExpand = useCallback7(
    (id) => {
      var _a;
      dispatch({ type: "TOGGLE_EXPAND", payload: { id } });
      const categoryName = (_a = coverageState.categories.find(
        (category) => category.unique_id === id
      )) == null ? void 0 : _a.category;
      if (!employer) {
        sendAnalyticsEvent({
          category: "Wallet",
          action: `Coverage Browse - ${benefitType}`,
          label: categoryName
        });
      }
    },
    [benefitType, coverageState.categories, employer]
  );
  const onQueryChange = useMemo8(
    () => debounce((query) => {
      dispatch({
        type: "SET_SEARCH_QUERY",
        payload: { query }
      });
      if (query && !employer) {
        sendAnalyticsEvent({
          category: "Wallet",
          action: `Coverage Search - ${benefitType}`,
          label: query
        });
      }
    }, TYPING_DEBOUNCE_INTERVAL),
    [benefitType, employer]
  );
  const { data: coverageData } = useCoverageQuery({
    userId,
    benefitId,
    query: coverageState.query,
    employer
  });
  useEffect3(() => {
    if (coverageData) {
      dispatch({
        type: "UPDATE_CATEGORIES",
        payload: { categories: coverageData }
      });
    }
  }, [coverageData]);
  const isFullyExpanded = useMemo8(
    () => {
      var _a;
      return !!((_a = coverageState.categories) == null ? void 0 : _a.every(
        (c) => coverageState.expandedIds.includes(c.unique_id)
      ));
    },
    [coverageState.categories, coverageState.expandedIds]
  );
  return __spreadProps(__spreadValues({}, coverageState), {
    isFullyExpanded,
    isFullyCollapsed: !isFullyExpanded && coverageState.expandedIds.length === 0,
    onExpandAll,
    onCollapseAll,
    onToggleExpand,
    onQueryChange
  });
}

// src/components/coverage/coverage.component.tsx
var ListItem2 = genesisStyled4(Box18)(
  css5({
    borderBottom: "solid",
    borderBottomWidth: "thin",
    borderColor: "onSurface.border.subdued",
    "&:last-of-type": {
      borderBottom: "none"
    }
  })
);
function Coverage({
  // userId & benefitId are needed here because of CoverageModal in the Enrollment flow
  userId,
  benefitId,
  embedded = false,
  autofocus = false,
  employer = false,
  onCategorySelect = () => {
  },
  // this will no longer be needed once WALLET-2567 is merged
  benefitType
}) {
  const {
    categories,
    expandedIds,
    isTree,
    coverage,
    displayQuery,
    isFullyExpanded,
    isFullyCollapsed,
    onQueryChange,
    onToggleExpand,
    onCollapseAll,
    onExpandAll
  } = useCoverage(employer, benefitType, userId, benefitId);
  const { formatMessage } = useIntl18();
  return /* @__PURE__ */ React29.createElement(Box18, null, /* @__PURE__ */ React29.createElement(
    Box18,
    {
      as: "form",
      role: "search",
      onSubmit: (event) => event.preventDefault()
    },
    /* @__PURE__ */ React29.createElement(VisuallyHidden3, { id: "search-input-description" }, formatMessage({
      id: "COVERAGE_SEARCH_BEHAVIOUR_DESCRIPTION"
    })),
    /* @__PURE__ */ React29.createElement(
      FormField,
      {
        id: formatMessage({
          id: "SEARCH"
        }),
        label: formatMessage({
          id: "SEARCH_COVERAGE"
        })
      },
      /* @__PURE__ */ React29.createElement(
        TextInput2,
        {
          leadingContent: /* @__PURE__ */ React29.createElement(Icon7, { icon: "interfaceSearch" }),
          id: formatMessage({
            id: "SEARCH_COVERAGE"
          }),
          "aria-label": formatMessage({
            id: "SEARCH_COVERAGE"
          }),
          "aria-describedby": "search-input-description",
          onChange: (event) => onQueryChange(event.target.value),
          autoFocus: embedded || autofocus
        }
      )
    ),
    /* @__PURE__ */ React29.createElement(Box18, { "aria-live": "polite" }, categories && categories.length === 0 ? /* @__PURE__ */ React29.createElement(EmptySearch, { query: displayQuery }) : /* @__PURE__ */ React29.createElement(React29.Fragment, null, /* @__PURE__ */ React29.createElement(
      Flex6,
      {
        marginTop: "oneAndHalf",
        marginBottom: "one",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "one"
      },
      /* @__PURE__ */ React29.createElement(
        Flex6,
        {
          alignItems: "center",
          "aria-hidden": "true",
          gap: "oneAndHalf",
          role: "presentation"
        },
        coverage.includes(COVERED) && /* @__PURE__ */ React29.createElement(
          ParagraphText8,
          {
            css: {
              display: "inline-flex",
              alignItems: "center",
              marginBlockEnd: "0 !important"
            }
          },
          /* @__PURE__ */ React29.createElement(CoverageIcon, { coverage: COVERED, embedded }),
          /* @__PURE__ */ React29.createElement(Box18, { as: "span", marginInlineStart: "half" }, formatMessage({ id: "COVERED" }))
        ),
        coverage.includes(PARTIAL) && /* @__PURE__ */ React29.createElement(
          ParagraphText8,
          {
            css: {
              display: "inline-flex",
              alignItems: "center",
              marginBlockEnd: "0 !important"
            }
          },
          /* @__PURE__ */ React29.createElement(CoverageIcon, { coverage: PARTIAL, embedded }),
          /* @__PURE__ */ React29.createElement(Box18, { as: "span", marginInlineStart: "half" }, formatMessage({ id: "COVERED_WITH_RESTRICTIONS" }))
        ),
        coverage.includes(NOT_COVERED) && /* @__PURE__ */ React29.createElement(
          ParagraphText8,
          {
            css: {
              display: "inline-flex",
              alignItems: "center",
              marginBlockEnd: "0 !important"
            }
          },
          /* @__PURE__ */ React29.createElement(
            CoverageIcon,
            {
              coverage: NOT_COVERED,
              embedded
            }
          ),
          /* @__PURE__ */ React29.createElement(Box18, { as: "span", marginInlineStart: "half" }, formatMessage({ id: "NOT_COVERED" }))
        )
      ),
      isTree && /* @__PURE__ */ React29.createElement(
        Flex6,
        {
          alignItems: "center",
          display: "flex",
          flexShrink: 0,
          gap: "one"
        },
        /* @__PURE__ */ React29.createElement(Box18, { as: "fieldset", display: "contents" }, /* @__PURE__ */ React29.createElement(
          ParagraphText8,
          {
            as: "legend",
            css: { marginBlockEnd: "0 !important" }
          },
          formatMessage({ id: "CATEGORIES" }),
          ":"
        ), /* @__PURE__ */ React29.createElement(
          Link,
          {
            "aria-disabled": isFullyExpanded,
            "aria-pressed": isFullyExpanded,
            as: "button",
            background: "none",
            border: "none",
            disabled: isFullyExpanded,
            onClick: onExpandAll,
            tabIndex: isFullyExpanded ? -1 : 0
          },
          formatMessage({ id: "EXPAND_ALL" })
        ), /* @__PURE__ */ React29.createElement(
          Link,
          {
            "aria-disabled": isFullyCollapsed,
            "aria-pressed": isFullyCollapsed,
            as: "button",
            background: "none",
            border: "none",
            disabled: isFullyCollapsed,
            onClick: onCollapseAll,
            tabIndex: isFullyCollapsed ? -1 : 0
          },
          formatMessage({ id: "COLLAPSE_ALL" })
        ))
      )
    ), categories && /* @__PURE__ */ React29.createElement(
      Box18,
      {
        borderRadius: "medium",
        borderStyle: "solid",
        borderWidth: "thin"
      },
      isTree ? /* @__PURE__ */ React29.createElement(Box18, { as: "ul" }, categories == null ? void 0 : categories.map((category) => /* @__PURE__ */ React29.createElement(ListItem2, { as: "li", key: category.unique_id }, /* @__PURE__ */ React29.createElement(
        CategoryGroup,
        {
          id: category.unique_id,
          name: category.category,
          coverage: category.coverage,
          categories: category.sub,
          isExpanded: isFullyExpanded || expandedIds.includes(category.unique_id),
          onToggleExpand,
          onCategorySelect,
          embedded
        }
      )))) : /* @__PURE__ */ React29.createElement(Box18, { as: "ul" }, categories == null ? void 0 : categories.map((category) => /* @__PURE__ */ React29.createElement(ListItem2, { as: "li", key: category.unique_id }, /* @__PURE__ */ React29.createElement(
        Category,
        {
          id: category.unique_id,
          name: category.category,
          coverage: category.coverage,
          description: category.description,
          examples: category.examples,
          restriction: category.restriction,
          onCategorySelect,
          embedded
        }
      ))))
    )))
  ));
}

// src/wallet.routes.tsx
import * as React81 from "react";
import { Route, Routes } from "@leagueplatform/routing";

// src/pages/wallet-landing/wallet-landing.page.tsx
import React38 from "react";
import {
  HeadingText as HeadingText13,
  ParagraphText as ParagraphText11,
  styled as styled6,
  Box as Box24,
  StackLayout as StackLayout14
} from "@leagueplatform/genesis-core";
import { Image as Image10 } from "@leagueplatform/genesis-commons";
import {
  PRODUCT_AREA as PRODUCT_AREA5,
  SUB_PRODUCT_AREA,
  SCREEN_NAMES as SCREEN_NAMES4,
  usePageViewAnalytics as usePageViewAnalytics2,
  trackAnalyticsEvent as trackAnalyticsEvent4,
  EVENT_NAME as EVENT_NAME8
} from "@leagueplatform/analytics";
import {
  ErrorState,
  LoadingIndicator as LoadingIndicator3,
  PageHeaderBackground
} from "@leagueplatform/web-common-components";
import { SectionHeader as SectionHeader3 } from "@leagueplatform/genesis-core-alpha";
import {
  getModulePath as getModulePath3,
  LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES3,
  useConfigProperty as useConfigProperty3
} from "@leagueplatform/core";
import { useIntl as useIntl25 } from "@leagueplatform/locales";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { RecentClaims } from "@leagueplatform/claims-b2b";
import { AddDependentBanner } from "@leagueplatform/dependents";
import { handleStaticAsset as handleStaticAsset7 } from "@leagueplatform/asset-config";

// src/components/card-link/card-link.component.tsx
import React30 from "react";
import {
  genesisStyled as genesisStyled5,
  Flex as Flex7,
  Image as Image6,
  SubtitleTwo,
  BodyTwo
} from "@leagueplatform/genesis-commons";
import { Icon as Icon8 } from "@leagueplatform/genesis-core";
import { LinkLegacy as RouterLink } from "@leagueplatform/routing";
import { StackLayout as StackLayout11 } from "@leagueplatform/web-common-components";
var CardContainer2 = genesisStyled5(Flex7)`
  text-decoration: none;
  flex-direction: row;
  align-items: center;
  border-radius: ${({ theme }) => theme.radii.large}px;
  padding: ${({ theme }) => theme.space.one}px;
  gap: ${({ theme }) => theme.space.one}px;
  background-color: ${({ theme }) => theme.colors.interactive.background.default};
  border-width: ${({ theme }) => theme.borderWidths.thin}px;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.interactive.border.default};
  color: ${({ theme }) => theme.colors.onSurface.icon.primary};
  position: relative;
  height: 100%;

  &:hover::after, &:focus::after {
    position: absolute;
    content: "";
    inset-inline-start: 0;
    top: 0;
    bottom: 0;
    inset-inline-end: 0;
    border-radius: calc(${({ theme }) => theme.radii.large - theme.borderWidths.thin}px);
    border-width: ${({ theme }) => theme.borderWidths.thin}px;
    border-color: inherit;
    border-style: solid;
    pointer-events: none;
  };

  &:hover {
    background-color: ${({ theme }) => theme.colors.interactive.background.hovered};
    border-color: ${({ theme }) => theme.colors.interactive.border.hovered};
  };

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.interactive.focus.outer};
  };

`;
var CardLink = ({
  to,
  icon,
  title,
  subtitle,
  onClick
}) => /* @__PURE__ */ React30.createElement(CardContainer2, { as: RouterLink, to, onClick }, icon && /* @__PURE__ */ React30.createElement(Image6, { src: icon, alt: "", size: 48 }), /* @__PURE__ */ React30.createElement(StackLayout11, { css: { flexGrow: 1 } }, /* @__PURE__ */ React30.createElement(
  SubtitleTwo,
  {
    as: "span",
    display: "block",
    color: "onSurface.text.primary",
    fontStyle: "normal"
  },
  title
), subtitle && /* @__PURE__ */ React30.createElement(BodyTwo, { as: "span", marginBlockStart: "one" }, subtitle)), /* @__PURE__ */ React30.createElement(Icon8, { icon: "interfaceChevronForward", size: "$two" }));

// src/components/grid-layout/grid-layout.component.tsx
import {
  css as css6,
  Box as Box19,
  genesisStyled as genesisStyled6
} from "@leagueplatform/genesis-commons";
var DEFAULT_STYLES = {
  MIN_GRID_ITEM_WIDTH: "250px",
  GRID_COLUMN_COUNT: 3
};
var GridContainer = genesisStyled6(Box19)(
  ({
    theme,
    gridColumnCount = DEFAULT_STYLES.GRID_COLUMN_COUNT,
    minGridItemWidth = DEFAULT_STYLES.MIN_GRID_ITEM_WIDTH
  }) => {
    const gapCount = gridColumnCount - 1;
    const totalGapWidth = gapCount * 16;
    const maxGridItemWidth = `calc((100% - ${totalGapWidth}px) / ${gridColumnCount})`;
    return css6({
      display: "grid",
      gridTemplateColumns: `repeat(auto-fill, minmax(max(${minGridItemWidth}, ${maxGridItemWidth}), 1fr));`,
      gridGap: `${theme.space.one}px`
    });
  }
);

// src/pages/wallet-landing/components/wallet-item-navigation-sections/wallet-item-navigation-sections.component.tsx
import React35 from "react";
import {
  LoadingIndicator as LoadingIndicator2,
  StackLayout as StackLayout13
} from "@leagueplatform/web-common-components";
import { useSearchParams } from "@leagueplatform/web-common";
import { useIntl as useIntl22 } from "@leagueplatform/locales";
import { Tabs } from "@leagueplatform/genesis-core";
import { SectionHeader as SectionHeader2 } from "@leagueplatform/genesis-core-alpha";
import { CARD_STATUS as CARD_STATUS4, PILL_STATUS as PILL_STATUS4 } from "@leagueplatform/wallet-api";
import { useNavigateLegacy as useNavigate } from "@leagueplatform/routing";

// src/pages/wallet-landing/components/wallet-item-navigation-sections/components/navigation-sidebar/navigation-sidebar.component.tsx
import * as React33 from "react";
import { LinkLegacy as RouterLink2 } from "@leagueplatform/routing";
import {
  HeadingText as HeadingText11,
  ParagraphText as ParagraphText10,
  UtilityText
} from "@leagueplatform/genesis-core";
import {
  Box as Box20,
  css as css8,
  Flex as Flex10,
  genesisStyled as genesisStyled8,
  Image as Image8,
  Link as _Link
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl20 } from "@leagueplatform/locales";
import { handleStaticAsset as handleStaticAsset5 } from "@leagueplatform/asset-config";
import {
  NAVIGATION_TYPE as NAVIGATION_TYPE2
} from "@leagueplatform/wallet-api";

// src/pages/wallet-landing/components/wallet-item-navigation-sections/components/navigation-sidebar/components/navigation-item/navigation-item.component.tsx
import React31 from "react";
import { HeadingText as HeadingText10, ParagraphText as ParagraphText9 } from "@leagueplatform/genesis-core";
import { Flex as Flex8, Image as Image7 } from "@leagueplatform/genesis-commons";
function NavigationItem({
  iconUrl,
  title,
  subtitle
}) {
  return /* @__PURE__ */ React31.createElement(Flex8, { alignItems: "center", padding: "one" }, iconUrl && /* @__PURE__ */ React31.createElement(Image7, { width: 48, minWidth: 48, height: 48, src: iconUrl, alt: "" }), /* @__PURE__ */ React31.createElement(Flex8, { flexDirection: "column", marginInlineStart: "one", width: 1 }, /* @__PURE__ */ React31.createElement(HeadingText10, { level: "display", size: "xs", as: "span" }, title), subtitle && /* @__PURE__ */ React31.createElement(ParagraphText9, { as: "span", emphasis: "subtle", size: "sm" }, subtitle)));
}

// src/pages/wallet-landing/components/wallet-item-navigation-sections/components/navigation-sidebar/components/status-filter-tabs/status-filter-tabs.view.jsx
import React32, { useState as useState4 } from "react";
import { useIntl as useIntl19 } from "@leagueplatform/locales";
import PropTypes from "prop-types";
import {
  Flex as Flex9,
  SubtitleTwo as SubtitleTwo2,
  genesisStyled as genesisStyled7,
  css as css7
} from "@leagueplatform/genesis-commons";
import { KEY } from "@leagueplatform/web-common";
import {
  trackAnalyticsEvent as trackAnalyticsEvent2,
  EVENT_NAME as EVENT_NAME6,
  PRODUCT_AREA as PRODUCT_AREA3,
  SCREEN_NAMES as SCREEN_NAMES2
} from "@leagueplatform/analytics";
var Tab = genesisStyled7(Flex9)(
  ({ isActiveTab, keyboardFocus }) => css7({
    boxShadow: "8px 0px 8px -8px rgba(0, 0, 0, 0.16), -8px 0px 8px -8px rgba(0, 0, 0, 0.16)",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: !isActiveTab && "surface.background.secondary"
    },
    "&:focus": {
      outline: !keyboardFocus && "none"
    }
  })
);
var zIndexBooster = 10;
var StatusFilterTabs = ({
  cardStatuses,
  setStatusFilter,
  statusFilter
}) => {
  const { $tmap } = useIntl19();
  const [keyboardFocus, setKeyboardFocus] = useState4(false);
  const handleClick = (status) => {
    setStatusFilter(status);
    trackAnalyticsEvent2(EVENT_NAME6.NAVIGATION_TAB_CLICKED, {
      screen_name: SCREEN_NAMES2.HOME_PAGE,
      product_area: PRODUCT_AREA3.WALLET,
      detail: `${status} benefit tab`
    });
  };
  const statusMessages = $tmap({
    active: "WALLET_BENEFIT_STATUS_ACTIVE",
    pending: "WALLET_BENEFIT_STATUS_PENDING",
    past: "WALLET_BENEFIT_STATUS_PAST",
    created: "WALLET_BENEFIT_STATUS_CREATED",
    ready: "WALLET_BENEFIT_STATUS_READY",
    in_waiting_period: "WALLET_BENEFIT_STATUS_IN_WAITING_PERIOD",
    inactive: "WALLET_BENEFIT_STATUS_INACTIVE",
    inactive_grace_period: "WALLET_BENEFIT_STATUS_INACTIVE_GRACE_PERIOD",
    allocated: "WALLET_BENEFIT_STATUS_ALLOCATED",
    opted_out: "WALLET_BENEFIT_STATUS_OPTED_OUT"
  });
  return /* @__PURE__ */ React32.createElement(Flex9, { role: "tablist", as: "ul" }, cardStatuses.map((status, index) => {
    const isFirstTab = index === 0;
    const isActiveTab = status === statusFilter;
    {
    }
    return /* @__PURE__ */ React32.createElement(
      Tab,
      {
        as: "li",
        role: "tab",
        "aria-selected": isActiveTab,
        keyboardFocus,
        tabIndex: "0",
        isActiveTab,
        backgroundColor: isActiveTab ? "surface.background.primary" : "surface.background.secondary",
        flexGrow: 1,
        height: "three",
        paddingY: "one",
        paddingX: "threeQuarters",
        borderStyle: "solid",
        borderWidth: "thin",
        borderColor: "onSurface.border.subdued",
        borderInlineStartStyle: !isFirstTab && "none",
        borderBottomStyle: isActiveTab && "none",
        borderStartEndRadius: "large",
        borderStartStartRadius: "large",
        zIndex: cardStatuses.length - index + (isActiveTab ? zIndexBooster : 0),
        onClick: () => {
          handleClick(status);
          setKeyboardFocus(false);
        },
        onKeyUp: (e) => {
          if (e.key === KEY.ENTER)
            handleClick(status);
          setKeyboardFocus(true);
        },
        key: status
      },
      /* @__PURE__ */ React32.createElement(
        SubtitleTwo2,
        {
          width: 1,
          textAlign: "center",
          color: "onSurface.text.subdued",
          lineHeight: "16px"
        },
        statusMessages(status)
      )
    );
  }));
};
StatusFilterTabs.propTypes = {
  cardStatuses: PropTypes.arrayOf(PropTypes.string).isRequired,
  setStatusFilter: PropTypes.func.isRequired,
  statusFilter: PropTypes.string.isRequired
};

// src/pages/wallet-landing/components/wallet-item-navigation-sections/hooks/use-wallet-item-navigation-sections.ts
import { useState as useState5 } from "react";
import {
  CARD_STATUS as CARD_STATUS2
} from "@leagueplatform/wallet-api";

// src/pages/wallet-landing/utils/parse-benefit-card-statuses.util.ts
import intersection from "lodash/intersection";
import {
  CARD_STATUS,
  PILL_STATUS
} from "@leagueplatform/wallet-api";
var normalizeStatus = (status) => {
  switch (status) {
    case CARD_STATUS.CREATED:
    case CARD_STATUS.READY:
    case CARD_STATUS.IN_WAITING_PERIOD:
      return PILL_STATUS.PENDING;
    case CARD_STATUS.INACTIVE_GRACE_PERIOD:
    case CARD_STATUS.INACTIVE:
      return PILL_STATUS.PAST;
    default:
      return CARD_STATUS.ACTIVE;
  }
};
function parseBenefitCardStatuses(walletItemsSectioned) {
  var _a;
  if (!walletItemsSectioned) {
    return [];
  }
  const benefitsSections = (_a = walletItemsSectioned == null ? void 0 : walletItemsSectioned.find(
    (section) => section.section_id === "benefits"
  )) == null ? void 0 : _a.sections;
  const statuses = /* @__PURE__ */ new Set();
  if (benefitsSections) {
    benefitsSections.forEach((section) => {
      if (section.wallet_items) {
        section.wallet_items.forEach(
          (item) => statuses.add(normalizeStatus(item.status))
        );
      }
    });
  }
  return statuses && intersection(
    [PILL_STATUS.PENDING, PILL_STATUS.ACTIVE, PILL_STATUS.PAST],
    Array.from(statuses)
  );
}

// src/pages/wallet-landing/components/wallet-item-navigation-sections/hooks/use-wallet-item-navigation-sections.ts
var useWalletItemNavigationSections = (itemSections) => {
  var _a, _b, _c;
  const parsedCardStatuses = parseBenefitCardStatuses(itemSections);
  const [activeSection, setActiveSection] = useState5(
    ((_c = (_b = (_a = itemSections == null ? void 0 : itemSections[0]) == null ? void 0 : _a.sections) == null ? void 0 : _b[0]) == null ? void 0 : _c.section_id) || ""
  );
  const [cardStatuses] = useState5(parsedCardStatuses);
  const [activeStatus, setActiveStatus] = useState5(
    (parsedCardStatuses == null ? void 0 : parsedCardStatuses.length) === 1 ? parsedCardStatuses[0] : CARD_STATUS2.ACTIVE
  );
  const value = {
    activeSection,
    activeStatus,
    cardStatuses,
    setActiveSection,
    setActiveStatus
  };
  return value;
};

// src/pages/wallet-landing/components/wallet-item-navigation-sections/util/send-navigation-analytic-event.util.ts
import {
  trackAnalyticsEvent as trackAnalyticsEvent3,
  EVENT_NAME as EVENT_NAME7,
  SCREEN_NAMES as SCREEN_NAMES3,
  PRODUCT_AREA as PRODUCT_AREA4
} from "@leagueplatform/analytics";
var sendNavigationAnalyticEvent = (benefitName, benefitId, vendorId, benefitProductType, benefitCategory, benefitSource) => {
  trackAnalyticsEvent3(EVENT_NAME7.BUTTON_CLICKED, {
    product_area: PRODUCT_AREA4.WALLET,
    screen_name: SCREEN_NAMES3.HOME_PAGE,
    benefit_name: benefitName,
    benefit_id: benefitId,
    vendor_id: vendorId,
    benefit_product_type: benefitProductType,
    benefit_category: benefitCategory,
    benefit_source: benefitSource,
    detail: "select benefit"
  });
};

// src/utils/get-wallet-path.util.ts
import { getModulePath as getModulePath2, LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES2 } from "@leagueplatform/core";
import { ADMIN, HEALTH_ADMIN } from "@leagueplatform/web-common";
function getWalletPath(currentUserRole, memberUserId) {
  const isAdmin = currentUserRole === ADMIN || currentUserRole === HEALTH_ADMIN;
  if (isAdmin && memberUserId) {
    return `/admin/wallet/${memberUserId}`;
  }
  return getModulePath2(LEAGUE_MODULE_NAMES2.wallet);
}

// src/common/league-credit-type.ts
var LEAGUE_CREDIT_TYPE = "personal_store_credit_balance";

// src/utils/normalize-id.util.ts
var LEAGUE_CREDIT_ID = "league-credit";
var normalizeId = (id) => {
  if (id === LEAGUE_CREDIT_TYPE)
    return LEAGUE_CREDIT_ID;
  return id;
};

// src/utils/get-product-icon.util.ts
import { handleStaticAsset as handleStaticAsset4 } from "@leagueplatform/asset-config";
var icons = {
  accident: "ACCIDENT" /* ACCIDENT */,
  calendar: "CALENDAR" /* CALENDAR */,
  critical_illness: "CRITICAL_ILLNESS" /* CRITICAL_ILLNESS */,
  dental: "DENTAL" /* DENTAL */,
  drug: "DRUG" /* DRUG */,
  home: "HOME" /* HOME */,
  life: "LIFE" /* LIFE */,
  spouse_optional_life: "LIFE" /* LIFE */,
  ltd: "LONG_TERM_DISABILITY" /* LONG_TERM_DISABILITY */,
  medical: "MEDICAL" /* MEDICAL */,
  pet: "PET" /* PET */,
  placeholder: "PLACEHOLDER" /* PLACEHOLDER */,
  std: "SHORT_TERM_DISABILITY" /* SHORT_TERM_DISABILITY */,
  spending_accounts: "SPENDING_ACCOUNTS" /* SPENDING_ACCOUNTS */,
  lsa: "SPENDING_ACCOUNTS" /* SPENDING_ACCOUNTS */,
  psa: "SPENDING_ACCOUNTS" /* SPENDING_ACCOUNTS */,
  hsa: "SPENDING_ACCOUNTS" /* SPENDING_ACCOUNTS */,
  vision: "VISION" /* VISION */,
  credit_card: "CREDIT_CARD" /* CREDIT_CARD */,
  "credit-card": "CREDIT_CARD" /* CREDIT_CARD */,
  wellness_accounts: "WELLNESS_ACCOUNTS" /* WELLNESS_ACCOUNTS */
};
function getProductIcon(productType) {
  if (!productType || !icons[productType]) {
    return handleStaticAsset4("REWARDS" /* REWARDS */);
  }
  return handleStaticAsset4(icons[productType]);
}

// src/pages/wallet-landing/components/wallet-item-navigation-sections/util/get-nav-item-props.util.ts
import {
  NAVIGATION_TYPE
} from "@leagueplatform/wallet-api";
function getWalletDetailsPath(navigationItem, currentUserRole, memberUserId) {
  const walletPath = getWalletPath(currentUserRole, memberUserId);
  const id = navigationItem.type === "benefit" ? navigationItem.benefit_id || navigationItem.benefit_product_type : normalizeId(navigationItem.id);
  return `${walletPath}/${id}`;
}
function getNavItemProps(item, userRole, memberUserId) {
  var _a, _b, _c, _d;
  const id = normalizeId(item.id);
  const url = getWalletDetailsPath(item, userRole, memberUserId);
  switch (item.type) {
    case NAVIGATION_TYPE.BENEFIT:
      return {
        benefitProductType: item.benefit_product_type,
        iconUrl: ((_a = item.benefit_logo) == null ? void 0 : _a.src) || item.icon_url || getProductIcon(item == null ? void 0 : item.benefit_product_type),
        id: item.benefit_id,
        title: (item == null ? void 0 : item.title) || item.name.text,
        subtitle: (item == null ? void 0 : item.subtitle) || item.vendor_name.text,
        status: item.status,
        url,
        vendorId: item.vendor_id
      };
    case NAVIGATION_TYPE.OTHER:
    default:
      return {
        iconUrl: ((_b = item.benefit_logo) == null ? void 0 : _b.src) || item.icon_url || getProductIcon(id),
        id,
        title: (item == null ? void 0 : item.title) || ((_c = item.name) == null ? void 0 : _c.text),
        subtitle: (item == null ? void 0 : item.subtitle) || ((_d = item.vendor_name) == null ? void 0 : _d.text),
        status: "active",
        url
      };
  }
}

// src/pages/wallet-landing/components/wallet-item-navigation-sections/util/filter-card-status.util.ts
import {
  CARD_STATUS as CARD_STATUS3,
  PILL_STATUS as PILL_STATUS3
} from "@leagueplatform/wallet-api";
var { PENDING, PAST } = PILL_STATUS3;
var {
  CREATED,
  READY,
  IN_WAITING_PERIOD,
  ACTIVE,
  INACTIVE_GRACE_PERIOD,
  INACTIVE
} = CARD_STATUS3;
var filterCardStatus = (cards, status) => {
  switch (status) {
    case PENDING:
      return cards.filter(
        (card) => [CREATED, READY, IN_WAITING_PERIOD].includes(card.status)
      );
    case PAST:
      return cards.filter(
        (card) => [INACTIVE_GRACE_PERIOD, INACTIVE].includes(card.status)
      );
    default:
      return cards.filter(
        (card) => card.status ? card.status === ACTIVE : card
      );
  }
};

// src/pages/wallet-landing/components/wallet-item-navigation-sections/components/navigation-sidebar/navigation-sidebar.component.tsx
var Link2 = genesisStyled8(_Link)(
  css8({
    display: "block",
    borderRadius: "0",
    "&:hover": {
      textDecoration: "none",
      backgroundColor: "surface.background.secondary"
    }
  })
);
var Divider = genesisStyled8(Box20)(
  css8({
    borderBottomStyle: "solid",
    borderBottomColor: "onSurface.border.subdued",
    borderBottomWidth: "thin",
    height: 0,
    marginX: "threeQuarters"
  })
);
var SectionWrapper = ({ children }) => /* @__PURE__ */ React33.createElement(
  Flex10,
  {
    flexDirection: "column",
    borderColor: "onSurface.border.subdued",
    borderWidth: "thin",
    borderStyle: "solid",
    borderTopWidth: "none",
    backgroundColor: "surface.background.primary",
    borderEndStartRadius: "large",
    borderEndEndRadius: "large"
  },
  children
);
var SectionHeader = genesisStyled8(Flex10)(
  () => css8({
    background: "inherit",
    border: "none",
    width: "100%",
    "&:hover": {
      backgroundColor: "surface.background.secondary",
      cursor: "pointer",
      boxShadow: "inset 4px 0px 0px #D6D6D6"
    }
  })
);
var NavigationSidebar = ({
  userRole,
  userId,
  navigationSections
}) => {
  const {
    activeSection,
    activeStatus,
    cardStatuses,
    setActiveSection,
    setActiveStatus
  } = useWalletItemNavigationSections(navigationSections);
  const { formatMessage } = useIntl20();
  const countBenefits = () => {
    const benefits = navigationSections == null ? void 0 : navigationSections.find(
      (item) => item.section_id === NAVIGATION_TYPE2.BENEFITS
    );
    if (benefits && benefits.sections && benefits.sections.length > 0) {
      return benefits.sections.reduce(
        (result, section) => section.wallet_items ? result + section.wallet_items.length : result,
        0
      );
    }
    return null;
  };
  const benefitsTotal = countBenefits();
  return /* @__PURE__ */ React33.createElement(
    Flex10,
    {
      flexDirection: "column",
      as: "nav",
      "aria-label": formatMessage({ id: "WALLET_LANDING_NAV_LABEL" })
    },
    navigationSections == null ? void 0 : navigationSections.map((itemGroup) => {
      var _a;
      return /* @__PURE__ */ React33.createElement(
        Box20,
        {
          marginBottom: "one",
          boxShadow: "card",
          key: itemGroup.section_id,
          borderRadius: "large",
          overflow: "hidden",
          as: "section"
        },
        (itemGroup.sections || itemGroup.wallet_items) && // Headings
        (itemGroup.section_id !== NAVIGATION_TYPE2.OTHER && cardStatuses && cardStatuses.length > 1 ? /* @__PURE__ */ React33.createElement(
          StatusFilterTabs,
          {
            cardStatuses,
            setStatusFilter: setActiveStatus,
            statusFilter: activeStatus
          }
        ) : /* @__PURE__ */ React33.createElement(
          Flex10,
          {
            backgroundColor: "surface.background.secondary",
            paddingX: "one",
            paddingY: "half",
            borderColor: "onSurface.border.subdued",
            borderWidth: "thin",
            borderStyle: "solid",
            borderStartEndRadius: "large",
            borderStartStartRadius: "large",
            as: "h2"
          },
          /* @__PURE__ */ React33.createElement(UtilityText, { as: "span", size: "eyebrow" }, itemGroup.name.text),
          itemGroup.section_id !== NAVIGATION_TYPE2.OTHER && benefitsTotal && /* @__PURE__ */ React33.createElement(
            UtilityText,
            {
              as: "span",
              css: { marginInlineStart: "$quarter" },
              size: "xs"
            },
            "(",
            benefitsTotal,
            ")"
          )
        )),
        itemGroup.wallet_items && // "Other" section
        /* @__PURE__ */ React33.createElement(SectionWrapper, null, itemGroup == null ? void 0 : itemGroup.wallet_items.map((item, itemIndex) => {
          const { url, id, title, subtitle, iconUrl } = getNavItemProps(
            item,
            userRole,
            userId
          );
          return /* @__PURE__ */ React33.createElement(
            Link2,
            {
              as: RouterLink2,
              to: url,
              key: id,
              onClick: () => {
                sendNavigationAnalyticEvent(
                  (item == null ? void 0 : item.title) || item.name.text,
                  item.id,
                  (item == null ? void 0 : item.subtitle) || item.vendor_id,
                  item.type,
                  item.type,
                  item.benefit_source
                );
              }
            },
            /* @__PURE__ */ React33.createElement(
              NavigationItem,
              {
                title,
                subtitle,
                iconUrl
              }
            ),
            itemGroup.wallet_items && itemIndex < itemGroup.wallet_items.length - 1 && /* @__PURE__ */ React33.createElement(Divider, null)
          );
        })),
        itemGroup.sections && // "Benefits" section
        /* @__PURE__ */ React33.createElement(SectionWrapper, null, (_a = itemGroup.sections) == null ? void 0 : _a.map((section, sectionIndex) => {
          var _a2;
          const filteredItems = section.wallet_items && filterCardStatus(section.wallet_items, activeStatus);
          const { section_id: sectionId } = section;
          const isActiveSection = activeSection === sectionId;
          return /* @__PURE__ */ React33.createElement(React33.Fragment, { key: sectionId }, filteredItems && filteredItems.length > 0 && /* @__PURE__ */ React33.createElement(Box20, null, /* @__PURE__ */ React33.createElement(HeadingText11, { level: "3", size: "lg" }, /* @__PURE__ */ React33.createElement(
            SectionHeader,
            {
              as: "button",
              "aria-expanded": isActiveSection,
              justifyContent: "space-between",
              alignItems: "center",
              paddingX: "one",
              paddingY: "oneAndHalf",
              onClick: () => {
                setActiveSection(
                  isActiveSection ? "" : sectionId
                );
              }
            },
            /* @__PURE__ */ React33.createElement(Box20, { as: "span", display: "block", textAlign: "start" }, /* @__PURE__ */ React33.createElement(HeadingText11, { level: "display", size: "sm", as: "span" }, section.name.text, /* @__PURE__ */ React33.createElement(
              ParagraphText10,
              {
                as: "span",
                css: { marginInlineStart: "$quarter" },
                emphasis: "subtle",
                size: "sm"
              },
              `(${filteredItems.length})`
            ))),
            /* @__PURE__ */ React33.createElement(
              Image8,
              {
                marginInlineStart: "one",
                alt: "",
                src: handleStaticAsset5(
                  isActiveSection ? "CARET_UP" /* CARET_UP */ : "CARET_DOWN" /* CARET_DOWN */
                ),
                width: 12,
                minWidth: 12,
                height: 6
              }
            )
          )), isActiveSection && filteredItems.map((item, itemIndex) => {
            const _a3 = getNavItemProps(
              item,
              userRole,
              userId
            ), { url, id } = _a3, navItem = __objRest(_a3, ["url", "id"]);
            return /* @__PURE__ */ React33.createElement(
              Link2,
              {
                as: RouterLink2,
                to: url,
                key: url,
                onClick: () => {
                  sendNavigationAnalyticEvent(
                    item.name.text,
                    item.benefit_id,
                    item.vendor_id,
                    item.benefit_product_type,
                    section.section_id,
                    item.benefit_source
                  );
                }
              },
              /* @__PURE__ */ React33.createElement(NavigationItem, __spreadValues({}, navItem)),
              itemIndex < (filteredItems == null ? void 0 : filteredItems.length) - 1 && /* @__PURE__ */ React33.createElement(Divider, null)
            );
          }), sectionIndex < ((_a2 = itemGroup.sections) == null ? void 0 : _a2.length) - 1 && /* @__PURE__ */ React33.createElement(Divider, null)));
        }))
      );
    })
  );
};

// src/pages/wallet-landing/components/wallet-item-navigation-sections/components/navigation-grid/navigation-grid.component.tsx
import * as React34 from "react";
import { HeadingText as HeadingText12 } from "@leagueplatform/genesis-core";
import { Box as Box21 } from "@leagueplatform/genesis-commons";
import { StackLayout as StackLayout12 } from "@leagueplatform/web-common-components";
var GRID_COLUMN_COUNT = 3;
var MIN_GRID_ITEM_WIDTH = "250px";
var NavigationGrid = ({
  navigationSections,
  userRole,
  userId,
  sectionId
}) => {
  var _a, _b;
  return /* @__PURE__ */ React34.createElement(StackLayout12, null, /* @__PURE__ */ React34.createElement(HeadingText12, { size: "sm", level: "3", id: sectionId }, navigationSections.name.text, " (", (_a = navigationSections == null ? void 0 : navigationSections.wallet_items) == null ? void 0 : _a.length, ")"), /* @__PURE__ */ React34.createElement(
    GridContainer,
    {
      gridColumnCount: GRID_COLUMN_COUNT,
      minGridItemWidth: MIN_GRID_ITEM_WIDTH,
      as: "ul"
    },
    (_b = navigationSections.wallet_items) == null ? void 0 : _b.map((walletItem) => {
      const { url, title, subtitle, iconUrl } = getNavItemProps(
        walletItem,
        userRole,
        userId
      );
      return /* @__PURE__ */ React34.createElement(Box21, { as: "li", key: url }, /* @__PURE__ */ React34.createElement(
        CardLink,
        {
          title,
          subtitle,
          icon: iconUrl,
          to: url,
          onClick: () => sendNavigationAnalyticEvent(
            walletItem.name.text,
            walletItem.id,
            walletItem.vendor_id,
            walletItem.type,
            walletItem.type,
            walletItem.benefit_source
          )
        }
      ));
    })
  ));
};

// src/pages/wallet-landing/components/wallet-item-navigation-sections/hooks/use-navigation-sections.ts
import { useMemo as useMemo9 } from "react";
import { useIntl as useIntl21 } from "@leagueplatform/locales";

// src/pages/wallet-landing/hooks/queries/use-wallet-items-sectioned-query.hook.ts
import {
  getWalletItemsSectioned,
  GET_WALLET_ITEMS_SECTIONED_MESSAGE_TYPE
} from "@leagueplatform/wallet-api";
import { useQuery as useQuery4 } from "@tanstack/react-query";
function useWalletItemsSectionedQuery(options) {
  const { userId } = useWalletParams();
  return useQuery4(
    [GET_WALLET_ITEMS_SECTIONED_MESSAGE_TYPE, userId],
    () => getWalletItemsSectioned(userId),
    options
  );
}

// src/pages/wallet-landing/components/wallet-item-navigation-sections/util/sort-benefit-sections-by-status.util.ts
var sortBenefitSectionsByStatus = (statusArray = [], itemSections = []) => {
  const sortedBenefitSections = statusArray.reduce(
    (previousValue, currentValue) => {
      const mappedItemSections = itemSections.map((item) => {
        if (item.wallet_items) {
          const filteredSections2 = [
            __spreadProps(__spreadValues({}, item), {
              wallet_items: filterCardStatus(item == null ? void 0 : item.wallet_items, currentValue)
            })
          ].filter((sections) => {
            var _a;
            return (_a = sections == null ? void 0 : sections.wallet_items) == null ? void 0 : _a.length;
          });
          return __spreadProps(__spreadValues({}, item), {
            sections: filteredSections2
          });
        }
        const filteredSections = item.sections.reduce(
          (prevSection, currentSection) => {
            const walletItems = filterCardStatus(
              (currentSection == null ? void 0 : currentSection.wallet_items) || [],
              currentValue
            );
            return [
              ...prevSection,
              __spreadProps(__spreadValues({}, currentSection), { wallet_items: walletItems })
            ].filter((sections) => {
              var _a;
              return (_a = sections == null ? void 0 : sections.wallet_items) == null ? void 0 : _a.length;
            });
          },
          []
        );
        return __spreadProps(__spreadValues({}, item), {
          sections: filteredSections
        });
      });
      return __spreadProps(__spreadValues({}, previousValue), { [currentValue]: mappedItemSections });
    },
    {}
  );
  return sortedBenefitSections;
};

// src/pages/wallet-landing/components/wallet-item-navigation-sections/hooks/use-navigation-sections.ts
var useNavigationSections = () => {
  var _a, _b;
  const { formatMessage } = useIntl21();
  const { data: queryData, isLoading } = useWalletItemsSectionedQuery();
  const itemSectioned = queryData == null ? void 0 : queryData.items_sectioned;
  const parsedCardStatuses = useMemo9(
    () => parseBenefitCardStatuses(itemSectioned || []),
    [itemSectioned]
  );
  const sortedBenefitSections = useMemo9(
    () => sortBenefitSectionsByStatus(parsedCardStatuses, itemSectioned),
    [parsedCardStatuses, itemSectioned]
  );
  const heading = (_b = (_a = itemSectioned == null ? void 0 : itemSectioned.find((item) => item.section_id === "benefits")) == null ? void 0 : _a.name.text) != null ? _b : formatMessage({ id: "COVERAGE" });
  return {
    cardStatuses: parsedCardStatuses,
    isLoading,
    benefitSections: sortedBenefitSections,
    itemSectioned: itemSectioned || [],
    heading
  };
};

// src/pages/wallet-landing/components/wallet-item-navigation-sections/wallet-item-navigation-sections.component.tsx
var WalletItemNavigationSections = ({
  userId,
  userRole,
  layout = "grid",
  showHeading = false
}) => {
  const { isLoading, itemSectioned, benefitSections, cardStatuses, heading } = useNavigationSections();
  const { $tmap } = useIntl22();
  const navigate = useNavigate();
  const searchParams = useSearchParams();
  const tabParam = searchParams.get("tab");
  const getCardStatusMessage = $tmap({
    active: "WALLET_BENEFIT_STATUS_ACTIVE",
    [PILL_STATUS4.PENDING]: "WALLET_BENEFIT_STATUS_PENDING",
    [PILL_STATUS4.PAST]: "WALLET_BENEFIT_STATUS_PAST",
    [CARD_STATUS4.CREATED]: "WALLET_BENEFIT_STATUS_CREATED",
    [CARD_STATUS4.READY]: "WALLET_BENEFIT_STATUS_READY",
    [CARD_STATUS4.IN_WAITING_PERIOD]: "WALLET_BENEFIT_IN_WAITING_PERIOD",
    [CARD_STATUS4.INACTIVE]: "WALLET_BENEFIT_STATUS_INACTIVE",
    [CARD_STATUS4.INACTIVE_GRACE_PERIOD]: "WALLET_BENEFIT_STATUS_INACTIVE_GRACE_PERIOD",
    [CARD_STATUS4.ALLOCATED]: "WALLET_BENEFIT_STATUS_ALLOCATED",
    [CARD_STATUS4.OPTED_OUT]: "WALLET_BENEFIT_STATUS_OPTED_OUT"
  });
  const handleTabChange = (value) => {
    const status = value.replace("-tab", "");
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set("tab", status);
    navigate({
      search: newSearchParams.toString()
    });
  };
  const getDefaultTabValue = () => {
    if (tabParam && cardStatuses.includes(tabParam)) {
      return `${tabParam}-tab`;
    }
    const hasActiveTab = cardStatuses.includes(CARD_STATUS4.ACTIVE) || cardStatuses.includes(PILL_STATUS4.ACTIVE);
    return hasActiveTab ? "active-tab" : `${cardStatuses[0]}-tab`;
  };
  if (isLoading) {
    return /* @__PURE__ */ React35.createElement(LoadingIndicator2, { inline: true });
  }
  if (layout === "sidebar") {
    return /* @__PURE__ */ React35.createElement(
      NavigationSidebar,
      {
        userId,
        userRole,
        navigationSections: itemSectioned
      }
    );
  }
  if (cardStatuses.length === 1) {
    const singleBenefitSection = benefitSections[cardStatuses[0]];
    return /* @__PURE__ */ React35.createElement(StackLayout13, null, showHeading && /* @__PURE__ */ React35.createElement(SectionHeader2, { title: heading, headingLevel: "2" }), singleBenefitSection == null ? void 0 : singleBenefitSection.map((statuses) => /* @__PURE__ */ React35.createElement(React35.Fragment, { key: statuses.section_id }, statuses.sections.map((section) => /* @__PURE__ */ React35.createElement(
      NavigationGrid,
      {
        key: `${statuses.section_id}-${section.section_id}`,
        navigationSections: section,
        sectionId: section.section_id
      }
    )))));
  }
  return /* @__PURE__ */ React35.createElement(StackLayout13, null, showHeading && /* @__PURE__ */ React35.createElement(SectionHeader2, { title: heading, headingLevel: "2" }), /* @__PURE__ */ React35.createElement(
    Tabs.Root,
    {
      defaultValue: getDefaultTabValue(),
      onValueChange: handleTabChange
    },
    /* @__PURE__ */ React35.createElement(StackLayout13, { space: "$three" }, /* @__PURE__ */ React35.createElement(Tabs.TabList, { tabDistribution: "hugContents", divider: true }, cardStatuses.map((status) => /* @__PURE__ */ React35.createElement(Tabs.Tab, { value: `${status}-tab`, key: `${status}-tab` }, getCardStatusMessage(status)))), cardStatuses.map((status) => {
      var _a;
      return /* @__PURE__ */ React35.createElement(Tabs.TabPanel, { value: `${status}-tab`, key: `${status}-tab-panel` }, /* @__PURE__ */ React35.createElement(StackLayout13, null, (_a = benefitSections[status]) == null ? void 0 : _a.map((statuses) => /* @__PURE__ */ React35.createElement(React35.Fragment, { key: statuses.section_id }, statuses.sections.map((section) => /* @__PURE__ */ React35.createElement(
        NavigationGrid,
        {
          key: `${statuses.section_id}-${section.section_id}`,
          navigationSections: section,
          sectionId: section.section_id
        }
      ))))));
    }))
  ));
};

// src/pages/wallet-landing/components/wallet-enrollment-state/wallet-enrollment.component.tsx
import React37 from "react";
import { useIntl as useIntl24 } from "@leagueplatform/locales";
import { JOURNEY_ROUTES } from "@leagueplatform/health-journey-common";
import { GenesisRouterLink } from "@leagueplatform/web-common-components";
import {
  BodyOne as BodyOne4,
  Box as Box23,
  HeadingOne,
  HeadingTwo as HeadingTwo2,
  HeadingThree as HeadingThree3,
  Image as Image9,
  Flex as Flex12,
  PrimaryButton as PrimaryButton3,
  genesisStyled as genesisStyled9,
  css as css9
} from "@leagueplatform/genesis-commons";
import { handleStaticAsset as handleStaticAsset6 } from "@leagueplatform/asset-config";

// src/pages/wallet-landing/components/wallet-enrollment-state/components/confirm-finalize-selections-modal.component.tsx
import React36 from "react";
import {
  HeadingThree as HeadingThree2,
  Box as Box22,
  PrimaryButton as PrimaryButton2,
  SecondaryButton,
  BodyOneSecondary as BodyOneSecondary2,
  BodyOne as BodyOne3,
  Checkbox as Checkbox2,
  Label,
  LabelText,
  ErrorMessage,
  Flex as Flex11
} from "@leagueplatform/genesis-commons";
import { Modal as Modal3 } from "@leagueplatform/ui-kit";
import { useIntl as useIntl23 } from "@leagueplatform/locales";
var ConfirmFinalizeSelectionsModal = ({
  onConfirmFinalizingSelections,
  onCancelFinalizingSelections,
  toggleConfirmationCheckbox,
  isConfirmationChecked,
  hasUncheckedError
}) => {
  const { formatMessage } = useIntl23();
  return /* @__PURE__ */ React36.createElement(Modal3.Wrapper, { onClose: onCancelFinalizingSelections, options: null }, /* @__PURE__ */ React36.createElement(
    Box22,
    {
      role: "dialog",
      "aria-labelledby": "modal-title",
      backgroundColor: "surface.background.primary",
      borderRadius: "medium",
      width: 600,
      maxWidth: "100%"
    },
    /* @__PURE__ */ React36.createElement(Box22, { padding: "two" }, /* @__PURE__ */ React36.createElement(HeadingThree2, { id: "modal-title", as: "h2", marginY: "one" }, formatMessage({ id: "PLEASE_NOTE" })), /* @__PURE__ */ React36.createElement(BodyOneSecondary2, { marginTop: "one" }, formatMessage({ id: "FINALIZE_SELECTIONS_COPY_1" })), /* @__PURE__ */ React36.createElement(BodyOne3, { marginTop: "one" }, /* @__PURE__ */ React36.createElement("strong", null, formatMessage({ id: "FINALIZE_SELECTIONS_COPY_2" }))), /* @__PURE__ */ React36.createElement(
      "form",
      {
        onSubmit: (event) => {
          event.preventDefault();
          onConfirmFinalizingSelections();
        }
      },
      /* @__PURE__ */ React36.createElement(
        Label,
        {
          htmlFor: "finalize-checkbox-id",
          display: "flex",
          marginTop: "one"
        },
        /* @__PURE__ */ React36.createElement(
          Checkbox2,
          {
            id: "finalize-checkbox-id",
            name: "finalize-checkbox",
            checked: isConfirmationChecked,
            onChange: toggleConfirmationCheckbox,
            marginInlineEnd: "half",
            error: hasUncheckedError,
            "aria-describedby": hasUncheckedError ? "finalize-checkbox-error" : ""
          }
        ),
        /* @__PURE__ */ React36.createElement(LabelText, { color: "onSurface.text.primary" }, formatMessage({ id: "FINALIZE_SELECTIONS_ACKNOWLEDGEMENT" }))
      ),
      hasUncheckedError && /* @__PURE__ */ React36.createElement(
        ErrorMessage,
        {
          id: "finalize-checkbox-error",
          align: "center",
          display: "flex",
          marginTop: "half"
        },
        formatMessage({ id: "THIS_BOX_MUST_BE_CHECKED_TO_CONTINUE" })
      ),
      /* @__PURE__ */ React36.createElement(Flex11, { justifyContent: "flex-end", marginTop: "oneAndHalf" }, /* @__PURE__ */ React36.createElement(
        SecondaryButton,
        {
          role: "button",
          onClick: onCancelFinalizingSelections,
          marginInlineEnd: "oneAndHalf"
        },
        formatMessage({ id: "CANCEL" })
      ), /* @__PURE__ */ React36.createElement(PrimaryButton2, null, formatMessage({ id: "SUBMIT" })))
    ))
  ));
};

// src/pages/wallet-landing/components/wallet-enrollment-state/hooks/use-finalize-selections.hook.ts
import { useState as useState6 } from "react";

// src/pages/wallet-landing/components/wallet-enrollment-state/hooks/queries/use-submit-benefit-selection-mutation.hook.ts
import { useMutation as useMutation2, useQueryClient } from "@tanstack/react-query";
import { toastActions, TOAST_STATUS } from "@leagueplatform/toast-messages";
import {
  submitBenefitSelection,
  SUBMIT_BENEFIT_SELECTION_MESSAGE_TYPE,
  GET_WALLET_MESSAGE_TYPE as GET_WALLET_MESSAGE_TYPE3
} from "@leagueplatform/wallet-api";
import { captureError, captureMessage } from "@leagueplatform/observability";

// src/hooks/queries/use-user-active-group-query.hook.ts
import { getActiveGroup } from "@leagueplatform/web-common";

// src/hooks/queries/use-user-profile-query.hook.ts
import {
  getUserProfile,
  GET_USER_PROFILE_MESSAGE_TYPE
} from "@leagueplatform/user-profile-api";
import { useQuery as useQuery5 } from "@tanstack/react-query";
function useUserProfileQuery(userId, options) {
  return useQuery5(
    [GET_USER_PROFILE_MESSAGE_TYPE, userId],
    () => getUserProfile(userId),
    options
  );
}

// src/hooks/queries/use-user-active-group-query.hook.ts
function useUserActiveGroupQuery(userId) {
  return useUserProfileQuery(userId, {
    // TODO: make this take options & support selectors
    select: (data) => {
      const group = getActiveGroup(data.groups);
      return group;
    }
  });
}

// src/hooks/queries/use-plan-id-query.hook.ts
var usePlanIdQuery = (userId) => {
  const { data = { plan_enrollment: {} } } = useUserActiveGroupQuery(userId);
  const { plan_enrollment: planEnrollment } = data;
  const [planId = ""] = Object.keys(planEnrollment != null ? planEnrollment : {});
  return planId;
};

// src/pages/wallet-landing/components/wallet-enrollment-state/hooks/queries/use-submit-benefit-selection-mutation.hook.ts
var useSubmitBenefitSelectionMutation = ({
  groupId,
  allocateImmediately
}) => {
  const queryClient = useQueryClient();
  const { userId } = useWalletParams();
  const planId = usePlanIdQuery(userId);
  return useMutation2(
    [SUBMIT_BENEFIT_SELECTION_MESSAGE_TYPE, groupId],
    () => submitBenefitSelection(groupId, allocateImmediately, planId),
    {
      onSuccess: ({ validation_errors: validationErrors }) => {
        if (validationErrors && validationErrors.length > 0) {
          toastActions.add({
            type: TOAST_STATUS.ERROR,
            textId: "ERROR_FINALIZING_SELECTIONS_INVALID_SELECTIONS"
          });
          captureMessage("Invalid selections", {
            severityLevel: "error",
            context: {
              "validation errors": __spreadValues({}, validationErrors)
            }
          });
        } else {
          queryClient.invalidateQueries([GET_WALLET_MESSAGE_TYPE3, userId]);
          toastActions.add({
            type: TOAST_STATUS.SUCCESS,
            textId: "SELECTIONS_FINALIZED_SUCCESS"
          });
        }
      },
      onError: (err) => {
        toastActions.add({
          type: TOAST_STATUS.ERROR,
          textId: "ERROR_FINALIZING_SELECTIONS"
        });
        captureError(err);
      }
    }
  );
};

// src/pages/wallet-landing/components/wallet-enrollment-state/hooks/use-finalize-selections.hook.ts
function useFinalizeSelections(groupId) {
  const [isConfirmingFinalization, setIsConfirmingFinalization] = useState6(false);
  const [isConfirmationChecked, setIsConfirmationChecked] = useState6(false);
  const [hasUncheckedError, setHasUncheckedError] = useState6(false);
  const { mutate: submitBenefitSelectionQuery } = useSubmitBenefitSelectionMutation({
    groupId,
    allocateImmediately: true
  });
  const resetState = () => {
    setIsConfirmingFinalization(false);
    setHasUncheckedError(false);
    setIsConfirmationChecked(false);
  };
  return {
    isConfirmationChecked,
    isConfirmingFinalization,
    hasUncheckedError,
    onFinalizeSelections: () => setIsConfirmingFinalization(true),
    onConfirmFinalizingSelections: () => {
      if (isConfirmationChecked) {
        resetState();
        submitBenefitSelectionQuery();
      } else {
        setHasUncheckedError(true);
      }
    },
    onCancelFinalizingSelections: () => resetState(),
    toggleConfirmationCheckbox: () => setIsConfirmationChecked(!isConfirmationChecked)
  };
}

// src/pages/wallet-landing/components/wallet-enrollment-state/wallet-enrollment.component.tsx
var LastDayLabel = genesisStyled9.span`
  font-weight: normal;
`;
var ContentContainer = genesisStyled9(Flex12)(
  css9({
    borderRadius: "small",
    borderColor: "onSurface.border.subdued"
  })
);
var CardInfo = genesisStyled9(Flex12)(
  css9({
    marginInlineStart: "three",
    flexDirection: "column",
    justifyContent: "space-between"
  })
);
var Icon9 = genesisStyled9(Image9)(
  ({ size }) => css9({
    width: size,
    height: size,
    alt: ""
  })
);
var WalletEnrollment = ({
  enrollmentEndDate = "",
  showPlanSelections,
  groupId = "",
  isNewHireEnrollment
}) => {
  const { formatMessage, formatDate } = useIntl24();
  const finalizeSelectionsState = useFinalizeSelections(groupId);
  return /* @__PURE__ */ React37.createElement(
    Box23,
    {
      maxWidth: "1000px",
      marginX: "auto",
      marginTop: "two",
      marginBottom: "twoAndHalf",
      paddingX: "two"
    },
    /* @__PURE__ */ React37.createElement(
      Flex12,
      {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: ["column", "column", "row"]
      },
      /* @__PURE__ */ React37.createElement(HeadingOne, null, formatMessage({ id: "WALLET" })),
      enrollmentEndDate && /* @__PURE__ */ React37.createElement(BodyOne4, { as: "p", className: "enrollment-end-date" }, /* @__PURE__ */ React37.createElement("strong", null, formatMessage(
        {
          id: "LAST_DAY_OF_ENROLLMENT"
        },
        {
          lastDay: /* @__PURE__ */ React37.createElement(LastDayLabel, null, formatDate(enrollmentEndDate, {
            year: "numeric",
            month: "short",
            day: "numeric"
          }))
        }
      )))
    ),
    /* @__PURE__ */ React37.createElement(ContentContainer, { borderWidth: "none", textAlign: "center", paddingY: "two" }, /* @__PURE__ */ React37.createElement(
      Flex12,
      {
        flexDirection: "column",
        align: "center",
        width: "100%",
        maxWidth: "60ch",
        margin: "auto"
      },
      /* @__PURE__ */ React37.createElement(
        Icon9,
        {
          src: handleStaticAsset6("CARD_LEAGUE_ICON" /* CARD_LEAGUE_ICON */),
          size: "13rem",
          marginY: "two",
          marginX: "auto"
        }
      ),
      /* @__PURE__ */ React37.createElement(HeadingTwo2, null, formatMessage({ id: "WALLET_WELCOME" })),
      /* @__PURE__ */ React37.createElement(BodyOne4, { marginY: "one", textAlign: "center" }, formatMessage(
        {
          id: "WALLET_DESCRIPTION"
        },
        {
          healthProgramLink: /* @__PURE__ */ React37.createElement(GenesisRouterLink, { to: JOURNEY_ROUTES.programsHome() }, formatMessage({ id: "HEALTH_PROGRAM_LINK_COPY" }))
        }
      )),
      showPlanSelections && isNewHireEnrollment && /* @__PURE__ */ React37.createElement(Box23, { marginTop: "one" }, /* @__PURE__ */ React37.createElement(HeadingThree3, null, formatMessage({ id: "FINALIZE_SELECTIONS_HEADER_COPY" })), /* @__PURE__ */ React37.createElement(
        PrimaryButton3,
        {
          marginTop: "one",
          onClick: finalizeSelectionsState.onFinalizeSelections
        },
        formatMessage({ id: "FINALIZE_PLAN_SELECTIONS" })
      ))
    )),
    showPlanSelections && /* @__PURE__ */ React37.createElement(
      Flex12,
      {
        justifyContent: "space-between",
        flexDirection: ["column", "column", "row"]
      },
      /* @__PURE__ */ React37.createElement(
        ContentContainer,
        {
          padding: "two",
          paddingInlineStart: "three",
          marginInlineEnd: ["none", "none", "one"],
          marginTop: ["one", "one", "none"],
          borderWidth: "thin"
        },
        /* @__PURE__ */ React37.createElement(
          Icon9,
          {
            src: handleStaticAsset6("DOCUMENT_ICON" /* DOCUMENT_ICON */),
            size: "75px"
          }
        ),
        /* @__PURE__ */ React37.createElement(CardInfo, null, /* @__PURE__ */ React37.createElement(Box23, null, /* @__PURE__ */ React37.createElement(HeadingThree3, null, formatMessage({ id: "TOTAL_REWARDS_LABEL" })), /* @__PURE__ */ React37.createElement(BodyOne4, { marginY: "one" }, formatMessage({ id: "TOTAL_REWARDS_DESCRIPTION" }))), /* @__PURE__ */ React37.createElement(Flex12, { align: "center" }, /* @__PURE__ */ React37.createElement(GenesisRouterLink, { to: "/member/coverage-summary" }, formatMessage({ id: "TOTAL_REWARDS_LINK" }), /* @__PURE__ */ React37.createElement(
          Icon9,
          {
            src: handleStaticAsset6("RIGHT_ARROW" /* RIGHT_ARROW */),
            size: "10px",
            marginX: "half",
            transform: "rotateY(calc(180deg * var(--league-is-rtl)))"
          }
        ))))
      ),
      /* @__PURE__ */ React37.createElement(
        ContentContainer,
        {
          padding: "two",
          paddingInlineStart: "three",
          marginInlineStart: ["none", "none", "one"],
          marginTop: ["one", "one", "none"],
          borderWidth: "thin"
        },
        /* @__PURE__ */ React37.createElement(
          Image9,
          {
            src: handleStaticAsset6("PENCIL_ICON" /* PENCIL_ICON */),
            size: "75px",
            alt: ""
          }
        ),
        /* @__PURE__ */ React37.createElement(CardInfo, null, /* @__PURE__ */ React37.createElement(Box23, null, /* @__PURE__ */ React37.createElement(HeadingThree3, null, formatMessage({ id: "CHANGE_PLAN_LABEL" })), /* @__PURE__ */ React37.createElement(BodyOne4, { marginY: "one" }, formatMessage({ id: "CHANGE_PLAN_DESCRIPTION" }))), /* @__PURE__ */ React37.createElement(Flex12, { align: "center" }, /* @__PURE__ */ React37.createElement(GenesisRouterLink, { to: "/enroll" }, formatMessage({ id: "CHANGE_PLAN_LINK" }), /* @__PURE__ */ React37.createElement(
          Icon9,
          {
            src: handleStaticAsset6("RIGHT_ARROW" /* RIGHT_ARROW */),
            size: "10px",
            marginX: "half",
            transform: "rotateY(calc(180deg * var(--league-is-rtl)))"
          }
        ))))
      )
    ),
    finalizeSelectionsState.isConfirmingFinalization && /* @__PURE__ */ React37.createElement(
      ConfirmFinalizeSelectionsModal,
      __spreadValues({}, finalizeSelectionsState)
    )
  );
};

// src/pages/wallet-landing/hooks/use-wallet-landing.hook.ts
import { useClaimsQuery } from "@leagueplatform/claims-b2b";
import { useFeatureFlagQuery } from "@leagueplatform/user-profile-api";

// src/wallet.config.ts
import defaultsDeep from "lodash/defaultsDeep";
import {
  getConfig,
  useConfigProperty as useConfigProperty2
} from "@leagueplatform/core";
var defaultConfig = {
  showBenefitDetailFeedbackComponent: false,
  showLandingPageHeaderBranding: false,
  // TODO: Benefit Status Banner flags should be BE feature flags instead and will be updated soon
  showBenefitStatusBannerCreated: false,
  showBenefitStatusBannerPending: false,
  showBenefitStatusBannerExpired: false,
  showLandingPageClaimsEntry: false,
  enableNoNetworkLiveBalances: false
};
var useWalletConfig = () => useConfigProperty2("wallet", defaultConfig);
var getWalletConfig = () => defaultsDeep({}, getConfig().config.wallet, defaultConfig);

// src/common/feature-flags.ts
var WALLET_API_FEATURE_FLAGS = {
  BENEFITS_LANDING_GRID_LAYOUT: "benefits_landing_page_grid",
  IS_CLINICAL_PROGRAMS_ENABLED: "enable_wallet_clinical_program",
  IS_CONTENT_PANEL_BENEFIT_CARD_ENABLED: "enable_content_panel_benefit_card",
  IS_DEPENDENTS_DROPDOWN_ENABLED: "enable_dependents_dropdown",
  IS_MASONRY_LANDING_ENABLED: "enable_masonry_wallet_landing_screen",
  IS_NON_ACTIVE_POLICY_INFORMATION_HIDDEN: "wallet_hide_non_active_policy_information",
  IS_SPENDING_ACCOUNT_BALANCE_BANNER_HIDDEN: "hide_spending_account_balance_banner",
  MANAGE_DEPENDENTS_V2: "manage_dependent_v2",
  WALLET_LIVE_BALANCE_V2: "wallet_live_balance_v2"
};

// src/pages/wallet-landing/hooks/queries/use-user-config-query.hook.ts
import {
  getUserConfig,
  GET_USER_CONFIG_MESSAGE_TYPE
} from "@leagueplatform/wallet-api";
import { useQuery as useQuery6 } from "@tanstack/react-query";
function useUserConfigQuery(userId) {
  return useQuery6(
    [GET_USER_CONFIG_MESSAGE_TYPE, userId],
    () => getUserConfig(userId)
  );
}

// src/hooks/queries/use-group-query.hook.ts
import { useQuery as useQuery7 } from "@tanstack/react-query";
import { GET_GROUP_MESSAGE_TYPE, getGroup } from "@leagueplatform/wallet-api";
function useGroupQuery(groupId, options) {
  return useQuery7(
    [GET_GROUP_MESSAGE_TYPE, groupId],
    // This function will not be enabled if groupId does not exist.
    // getGroup also throws an error if no groupId is passed.
    // @ts-ignore
    () => getGroup(groupId),
    __spreadValues({
      enabled: !!groupId
    }, options)
  );
}

// src/pages/wallet-landing/utils/get-is-in-new-hire-enrollment.util.ts
function getIsInNewHireEnrollment(isInEnrollment, enrollmentEndDate, annualEnrollmentPeriod, planEnrollment) {
  const newHireEnrollment = Object.values(planEnrollment).some(
    ({ enrollmentType: type }) => type === "new_hire"
  );
  if (Object.values(planEnrollment).length > 0) {
    return newHireEnrollment;
  }
  if (!isInEnrollment || !enrollmentEndDate) {
    return false;
  }
  if (isInEnrollment && enrollmentEndDate && !annualEnrollmentPeriod) {
    return true;
  }
  const annualEnrollmentStartDate = new Date(annualEnrollmentPeriod.start_date);
  const annualEnrollmentEndDate = new Date(annualEnrollmentPeriod.end_date);
  const now = /* @__PURE__ */ new Date();
  if (now > annualEnrollmentStartDate && now < annualEnrollmentEndDate) {
    return false;
  }
  return isInEnrollment && (enrollmentEndDate.getUTCFullYear() !== annualEnrollmentEndDate.getUTCFullYear() || enrollmentEndDate.getUTCMonth() !== annualEnrollmentEndDate.getUTCMonth() || enrollmentEndDate.getUTCDay() !== annualEnrollmentEndDate.getUTCDay());
}

// src/pages/wallet-landing/hooks/queries/use-is-new-hire-enrollment.hook.ts
function useIsNewHireEnrollmentQuery(userId) {
  var _a, _b, _c;
  const walletQuery = useWalletQuery(userId);
  const { data: activeGroup } = useUserActiveGroupQuery(userId);
  const groupQuery = useGroupQuery(activeGroup == null ? void 0 : activeGroup.group_id);
  if (!walletQuery.data || !groupQuery.data) {
    return {
      data: null,
      isError: walletQuery.isError || groupQuery.isError,
      isLoading: walletQuery.isLoading || groupQuery.isLoading
    };
  }
  const annualEnrollmentPeriod = (_a = groupQuery.data.group.employer) == null ? void 0 : _a.benefits_annual_enrollment_period;
  const planEnrollment = (_b = groupQuery.data.plan_enrollment) != null ? _b : {};
  const isInEnrollment = walletQuery.data.in_enrollment_period;
  const enrollmentEndDate = new Date((_c = walletQuery.data) == null ? void 0 : _c.enrollment_end_date);
  const isNewHireEnrollment = getIsInNewHireEnrollment(
    isInEnrollment,
    enrollmentEndDate,
    annualEnrollmentPeriod,
    planEnrollment
  );
  return {
    isError: walletQuery.isError || groupQuery.isError,
    isLoading: walletQuery.isLoading || groupQuery.isLoading,
    data: isNewHireEnrollment
  };
}

// src/pages/wallet-landing/hooks/use-wallet-landing.hook.ts
function useWalletLanding() {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const { userId } = useWalletParams();
  const userConfigQuery = useUserConfigQuery(userId);
  const shouldShowSubmitClaims = ((_a = userConfigQuery.data) == null ? void 0 : _a.hide_submit_claims) === false;
  const walletQuery = useWalletQuery(userId);
  const claimsQuery = useClaimsQuery(userId, {
    enabled: shouldShowSubmitClaims
  });
  const isNewHireEnrollmentQuery = useIsNewHireEnrollmentQuery(userId);
  const walletItemsSectionedQuery = useWalletItemsSectionedQuery();
  const { data: userRole } = useUserProfileQuery(void 0, {
    select: (data) => data.role
  });
  const { data: isManageDependentsEnabled } = useFeatureFlagQuery(
    WALLET_API_FEATURE_FLAGS.MANAGE_DEPENDENTS_V2
  );
  const { data: isGridLayoutEnabled } = useFeatureFlagQuery(
    WALLET_API_FEATURE_FLAGS.BENEFITS_LANDING_GRID_LAYOUT
  );
  const { data: activeGroup } = useUserActiveGroupQuery(userId);
  const groupId = activeGroup == null ? void 0 : activeGroup.group_id;
  const showQleAddDependentBanner = ((_b = userConfigQuery.data) == null ? void 0 : _b.show_add_dependents_with_qle) || ((_c = userConfigQuery.data) == null ? void 0 : _c.show_add_dependents_without_qle);
  const claims = (_d = claimsQuery.data) == null ? void 0 : _d.claims;
  const showQLEBanner = showQleAddDependentBanner && isManageDependentsEnabled;
  const showClaims = claims && claims.length > 0;
  const isLoading = [
    userConfigQuery,
    walletQuery,
    claimsQuery,
    walletItemsSectionedQuery
  ].some((query) => query.isInitialLoading);
  const isError = [
    userConfigQuery,
    walletQuery,
    claimsQuery,
    walletItemsSectionedQuery
  ].some((query) => query.isError);
  const errors = [
    userConfigQuery.error,
    walletQuery.error,
    claimsQuery.error,
    walletItemsSectionedQuery.error
  ];
  const { showLandingPageHeaderBranding, showLandingPageClaimsEntry, slots } = useWalletConfig();
  const benefitItemSections = (_e = walletItemsSectionedQuery.data) == null ? void 0 : _e.items_sectioned;
  const isEmpty = !(benefitItemSections == null ? void 0 : benefitItemSections.length) && !isLoading;
  const isNewHireEnrollment = isNewHireEnrollmentQuery.data || false;
  return {
    enrollmentEndDate: (_f = walletQuery.data) == null ? void 0 : _f.enrollment_end_date,
    groupId,
    isFirstTimeEnrollment: (_g = walletQuery.data) == null ? void 0 : _g.is_first_time_enrollment,
    isGridLayoutEnabled,
    isLoading,
    isError,
    isEmpty,
    isNewHireEnrollment,
    showClaims,
    showLandingPageHeaderBranding,
    showPlanSelections: ((_h = walletQuery.data) == null ? void 0 : _h.selection_status) === "completed" /* COMPLETED */,
    showQLEBanner,
    userId,
    userRole,
    showLandingPageClaimsEntry,
    slots,
    errors
  };
}

// src/pages/wallet-landing/wallet-landing.page.tsx
var withBrandingHeaderHeight = "232px";
var maximumWidth = 1280;
var Wrapper = styled6(Box24, {
  "@desktop": {
    marginInlineStart: "calc(100vw - 100%)",
    marginInlineEnd: 0
  }
});
var SidebarLayout = styled6(Box24, {
  gap: "$two",
  flexWrap: "wrap",
  display: "flex",
  "& > :first-child": {
    flexGrow: 1,
    flexBasis: "30ch"
  },
  "& > :last-child": {
    flexBasis: 0,
    flexGrow: 999,
    minInlineSize: "50%"
  }
});
function WalletLandingHeader() {
  const { formatMessage } = useIntl25();
  const {
    showClaims,
    showLandingPageHeaderBranding,
    showLandingPageClaimsEntry
  } = useWalletLanding();
  const groupLogo = useConfigProperty3("core.ui.groupLogo");
  return /* @__PURE__ */ React38.createElement(
    PageHeaderBackground,
    {
      pageHeaderBackgroundHeight: showLandingPageHeaderBranding ? withBrandingHeaderHeight : void 0,
      height: showLandingPageHeaderBranding ? withBrandingHeaderHeight : void 0
    },
    /* @__PURE__ */ React38.createElement(
      Box24,
      {
        css: {
          display: "flex",
          width: "100%",
          maxWidth: maximumWidth,
          marginInlineStart: "auto",
          marginInlineEnd: "auto",
          justifyContent: "space-between",
          marginTop: "$twoAndHalf"
        }
      },
      /* @__PURE__ */ React38.createElement(StackLayout14, { spacing: "$two", css: { flexDirection: "column" } }, showLandingPageHeaderBranding && groupLogo && groupLogo.element, /* @__PURE__ */ React38.createElement(StackLayout14, { spacing: "$threeQuarters" }, /* @__PURE__ */ React38.createElement(HeadingText13, { size: "xxl", level: "1" }, formatMessage({ id: "WALLET" })), showLandingPageHeaderBranding && /* @__PURE__ */ React38.createElement(ParagraphText11, { emphasis: "subtle" }, showLandingPageClaimsEntry ? formatMessage({ id: "WALLET_WITH_CLAIMS_LANDING_TITLE" }) : formatMessage({ id: "WALLET_LANDING_TITLE" })))),
      showClaims && /* @__PURE__ */ React38.createElement(
        Image10,
        {
          src: handleStaticAsset7("WALLET_IMAGE" /* WALLET_IMAGE */),
          role: "presentation",
          width: 140,
          height: 132
        }
      )
    )
  );
}
function WalletLandingPage() {
  const { formatMessage } = useIntl25();
  useDocumentTitle(formatMessage({ id: "WALLET" }));
  usePageViewAnalytics2({
    title: SCREEN_NAMES4.HOME_PAGE,
    product_area: PRODUCT_AREA5.WALLET
  });
  const {
    enrollmentEndDate,
    groupId,
    isFirstTimeEnrollment,
    isGridLayoutEnabled,
    isLoading,
    isError,
    isEmpty,
    isNewHireEnrollment,
    showClaims,
    showLandingPageHeaderBranding,
    showPlanSelections,
    showQLEBanner,
    userId,
    userRole,
    showLandingPageClaimsEntry,
    slots,
    errors
  } = useWalletLanding();
  if (isLoading) {
    return /* @__PURE__ */ React38.createElement(LoadingIndicator3, null);
  }
  if (isError) {
    return /* @__PURE__ */ React38.createElement(Wrapper, { css: { padding: "$none $two" } }, /* @__PURE__ */ React38.createElement(Box24, { css: { marginTop: "$three" } }, /* @__PURE__ */ React38.createElement(ErrorState, { error: errors })));
  }
  if (isFirstTimeEnrollment) {
    return /* @__PURE__ */ React38.createElement(
      WalletEnrollment,
      {
        enrollmentEndDate,
        showPlanSelections,
        isNewHireEnrollment,
        groupId
      }
    );
  }
  const Banner = slots == null ? void 0 : slots.Banner;
  if (isEmpty) {
    return /* @__PURE__ */ React38.createElement(Wrapper, { css: { padding: "$none $two" } }, /* @__PURE__ */ React38.createElement(WalletLandingHeader, null), Banner ? /* @__PURE__ */ React38.createElement(Banner, null) : null, /* @__PURE__ */ React38.createElement(
      StackLayout14,
      {
        spacing: "$three",
        css: __spreadValues({
          // @ts-ignore-next-line
          marginBlockStart: "$two"
        }, !showLandingPageClaimsEntry && {
          marginBlockStart: "$five",
          alignItems: "center",
          justifyContent: "center"
        })
      },
      showLandingPageClaimsEntry && /* @__PURE__ */ React38.createElement(React38.Fragment, null, /* @__PURE__ */ React38.createElement(StackLayout14, { spacing: "$one" }, /* @__PURE__ */ React38.createElement(
        SectionHeader3,
        {
          title: formatMessage({ id: "CLAIMS" }),
          headingLevel: "2"
        }
      ), /* @__PURE__ */ React38.createElement(
        GridContainer,
        {
          width: "100%",
          css: { "& :first-child": { gridColumn: "span 2" } }
        },
        /* @__PURE__ */ React38.createElement(Box24, null, /* @__PURE__ */ React38.createElement(
          CardLink,
          {
            to: getModulePath3(LEAGUE_MODULE_NAMES3.claims),
            title: formatMessage({ id: "CLAIMS_BENEFIT_CARD_TITLE" }),
            subtitle: formatMessage({
              id: "CLAIMS_BENEFIT_CARD_SUBTITLE"
            }),
            icon: handleStaticAsset7(
              "CLAIMS_ENTRY" /* CLAIMS_ENTRY */
            ),
            onClick: () => trackAnalyticsEvent4(EVENT_NAME8.BUTTON_CLICKED, {
              product_area: PRODUCT_AREA5.WALLET,
              sub_product_area: SUB_PRODUCT_AREA.CLAIMS,
              screen_name: SCREEN_NAMES4.HOME_PAGE,
              details: "view insurance claims"
            })
          }
        ))
      )), /* @__PURE__ */ React38.createElement(
        SectionHeader3,
        {
          title: formatMessage({ id: "COVERAGE" }),
          headingLevel: "2"
        }
      )),
      /* @__PURE__ */ React38.createElement(
        ErrorState,
        {
          error: null,
          headingString: formatMessage({
            id: "WALLET_LANDING_BENEFITS_EMPTY_STATE_TITLE"
          }),
          bodyString: formatMessage({
            id: "WALLET_LANDING_BENEFITS_EMPTY_STATE_DESCRIPTION"
          }),
          hideButton: true
        }
      )
    ));
  }
  return /* @__PURE__ */ React38.createElement(Wrapper, { css: { padding: "$none $two" } }, /* @__PURE__ */ React38.createElement(WalletLandingHeader, null), Banner ? /* @__PURE__ */ React38.createElement(Banner, null) : null, /* @__PURE__ */ React38.createElement(
    SidebarLayout,
    {
      css: {
        maxWidth: maximumWidth,
        marginInlineStart: "auto",
        marginInlineEnd: "auto",
        marginTop: showLandingPageHeaderBranding ? "$two" : "$minusTwoAndHalf",
        marginBottom: "$two"
      }
    },
    !isGridLayoutEnabled && /* @__PURE__ */ React38.createElement(Box24, { css: { minWidth: 280 } }, /* @__PURE__ */ React38.createElement(
      WalletItemNavigationSections,
      {
        userRole,
        userId,
        layout: "sidebar"
      }
    )),
    /* @__PURE__ */ React38.createElement(StackLayout14, { spacing: "$three", css: { alignItems: "normal" } }, !showLandingPageHeaderBranding && /* @__PURE__ */ React38.createElement(
      StackLayout14,
      {
        spacing: "$oneAndHalf",
        css: {
          marginTop: "$five",
          "@mobile": {
            marginTop: "$none"
          }
        }
      },
      /* @__PURE__ */ React38.createElement(
        SectionHeader3,
        {
          title: formatMessage({ id: "WALLET_LANDING_TITLE" }),
          headingLevel: "2",
          subtitle: formatMessage({ id: "WALLET_LANDING_BODY" })
        }
      )
    ), showLandingPageClaimsEntry && /* @__PURE__ */ React38.createElement(StackLayout14, { spacing: "$one" }, /* @__PURE__ */ React38.createElement(
      SectionHeader3,
      {
        title: formatMessage({ id: "CLAIMS" }),
        headingLevel: "2"
      }
    ), /* @__PURE__ */ React38.createElement(
      GridContainer,
      {
        width: "100%",
        css: { "& :first-child": { gridColumn: "span 2" } }
      },
      /* @__PURE__ */ React38.createElement(Box24, null, /* @__PURE__ */ React38.createElement(
        CardLink,
        {
          to: getModulePath3(LEAGUE_MODULE_NAMES3.claims),
          title: formatMessage({ id: "CLAIMS_BENEFIT_CARD_TITLE" }),
          subtitle: formatMessage({
            id: "CLAIMS_BENEFIT_CARD_SUBTITLE"
          }),
          icon: handleStaticAsset7(
            "CLAIMS_ENTRY" /* CLAIMS_ENTRY */
          ),
          onClick: () => trackAnalyticsEvent4(EVENT_NAME8.BUTTON_CLICKED, {
            product_area: PRODUCT_AREA5.WALLET,
            sub_product_area: SUB_PRODUCT_AREA.CLAIMS,
            screen_name: SCREEN_NAMES4.HOME_PAGE,
            details: "view insurance claims"
          })
        }
      ))
    )), isGridLayoutEnabled && /* @__PURE__ */ React38.createElement(
      WalletItemNavigationSections,
      {
        userRole,
        userId,
        showHeading: showLandingPageClaimsEntry
      }
    ), showClaims ? /* @__PURE__ */ React38.createElement(RecentClaims, { userId }) : !showLandingPageHeaderBranding && /* @__PURE__ */ React38.createElement(
      Image10,
      {
        src: handleStaticAsset7("WALLET_IMAGE" /* WALLET_IMAGE */),
        role: "presentation",
        width: "200",
        height: "190",
        display: "block",
        marginX: "auto"
      }
    ), showQLEBanner && /* @__PURE__ */ React38.createElement(Box24, null, /* @__PURE__ */ React38.createElement(AddDependentBanner, null)))
  ));
}

// src/pages/wallet-detail/wallet-detail.component.tsx
import * as React79 from "react";
import {
  EVENT_NAME as EVENT_NAME20,
  PRODUCT_AREA as PRODUCT_AREA8,
  SCREEN_NAMES as SCREEN_NAMES7,
  trackAnalyticsEvent as trackAnalyticsEvent5,
  usePageViewAnalytics as usePageViewAnalytics3
} from "@leagueplatform/analytics";
import { Box as Box49, Flex as Flex23 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl53 } from "@leagueplatform/locales";
import { useDocumentTitle as useDocumentTitle2, useGoBack } from "@leagueplatform/web-common";
import {
  BackButtonArrow,
  ErrorState as ErrorState5,
  LoadingIndicator as LoadingIndicator12,
  PageNotFound,
  StackLayout as StackLayout35
} from "@leagueplatform/web-common-components";
import { getModulePath as getModulePath4, LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES4 } from "@leagueplatform/core";

// src/pages/wallet-detail/hooks/use-wallet-detail.hook.ts
import { parseISO } from "date-fns";
import { useMemo as useMemo10 } from "react";
function useWalletDetail() {
  const { userId, benefitId } = useWalletParams();
  const {
    data: benefitCard,
    isLoading,
    isError,
    error
  } = useWalletDetailQuery(userId, benefitId);
  const derivedData = useMemo10(() => {
    if (!benefitCard) {
      return {};
    }
    return {
      cardStartDate: benefitCard.start_date ? parseISO(benefitCard.start_date) : null,
      cardEndDate: benefitCard.end_date ? parseISO(benefitCard.end_date) : null,
      cardInactiveDate: benefitCard.inactive_date ? parseISO(benefitCard.inactive_date) : null,
      formattedStartDate: benefitCard.formatted_start_date ? benefitCard.formatted_start_date : null,
      formattedEndDate: benefitCard.formatted_end_date ? benefitCard.formatted_end_date : null,
      submitClaimsEndDate: benefitCard.submit_claims_end_date ? benefitCard.submit_claims_end_date : null,
      useBalanceEndDate: benefitCard.use_balance_end_date ? benefitCard.use_balance_end_date : null
    };
  }, [benefitCard]);
  const {
    cardStartDate,
    cardEndDate,
    cardInactiveDate,
    formattedStartDate,
    formattedEndDate,
    submitClaimsEndDate,
    useBalanceEndDate
  } = derivedData;
  const { showBenefitDetailFeedbackComponent } = useWalletConfig();
  return {
    isLoading,
    benefitId,
    benefitCard,
    cardStartDate,
    cardEndDate,
    cardInactiveDate,
    formattedStartDate,
    formattedEndDate,
    submitClaimsEndDate,
    useBalanceEndDate,
    showBenefitDetailFeedbackComponent,
    isError,
    error
  };
}

// src/hooks/use-medical-card.hook.ts
import { useFeatureFlagQuery as useFeatureFlagQuery2 } from "@leagueplatform/user-profile-api";
function useMedicalCard() {
  const { benefitCard, error, isError } = useWalletDetail();
  const isMedicalBenefit = (benefitCard == null ? void 0 : benefitCard.product_type) === "medical";
  const { data: isContentPanelBenefitCardEnabled } = useFeatureFlagQuery2(
    WALLET_API_FEATURE_FLAGS.IS_CONTENT_PANEL_BENEFIT_CARD_ENABLED
  );
  return {
    isMedicalBenefit,
    isMedicalCardEnabled: isMedicalBenefit && isContentPanelBenefitCardEnabled,
    error,
    isError
  };
}

// src/components/page-header-background/pageheaderbackground.component.tsx
import React39 from "react";
import { useConfigProperty as useConfigProperty4 } from "@leagueplatform/core";
import { genesisStyled as genesisStyled10, css as css10, Flex as Flex13 } from "@leagueplatform/genesis-commons";
var StyledHeaderContainer = genesisStyled10(Flex13)(({ pageHeader }) => {
  var _a;
  const paddingBottom = (pageHeader == null ? void 0 : pageHeader.shape) === "line" ? "twoAndHalf" : ["four", "four", "two", "four"];
  const borderBottomRadius = (pageHeader == null ? void 0 : pageHeader.shape) === "line" ? 0 : "80% 60%";
  return css10({
    height: "100%",
    backgroundColor: "transparent",
    position: "relative",
    marginBottom: "two",
    paddingTop: ["twoAndHalf", "threeQuarters", "three"],
    paddingBottom,
    "&::after": {
      content: '""',
      backgroundColor: `${(_a = pageHeader == null ? void 0 : pageHeader.backgroundColor) != null ? _a : "surface.background.tertiary"}`,
      zIndex: -1,
      position: "absolute",
      top: 0,
      bottom: 0,
      insetInlineStart: 0,
      insetInlineEnd: 0,
      borderEndStartRadius: borderBottomRadius,
      borderEndEndRadius: borderBottomRadius,
      transform: "scaleX(1.2)"
    }
  });
});
var WalletPageHeaderBackground = (props) => {
  const pageHeaderConfig = useConfigProperty4("core.ui.components.pageHeader");
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    /* @__PURE__ */ React39.createElement(StyledHeaderContainer, __spreadValues({ pageHeader: pageHeaderConfig }, props))
  );
};

// src/components/sidebar-layout/sidebar-layout.component.tsx
import {
  genesisStyled as genesisStyled11,
  Flex as Flex14,
  css as css11
} from "@leagueplatform/genesis-commons";
var SidebarLayout2 = genesisStyled11(Flex14)(
  ({
    space = "two",
    minInlineSize = "50%",
    sidebarWidth,
    isSideBarOnRight
  }) => css11({
    gap: space,
    flexWrap: "wrap",
    "& > :first-child": isSideBarOnRight ? {
      flexBasis: 0,
      flexGrow: 999,
      minInlineSize
    } : {
      flexGrow: 1,
      flexBasis: sidebarWidth
    },
    "& > :last-child": isSideBarOnRight ? {
      flexGrow: 1,
      flexBasis: sidebarWidth
    } : {
      flexBasis: 0,
      flexGrow: 999,
      minInlineSize
    }
  })
);

// src/components/detail-header-banner/detail-header-banner.component.tsx
import { useConfigProperty as useConfigProperty5 } from "@leagueplatform/core";
import {
  ParagraphText as ParagraphText12,
  StatusBanner,
  TextAction as TextAction2
} from "@leagueplatform/genesis-core";
import React40 from "react";
var DetailBanner = ({ banner }) => {
  const {
    link: { url: linkUrl, text: linkText } = {},
    description,
    title,
    banner_type: bannerType,
    icon: { url: iconUrl } = {}
  } = banner;
  const handleLinkCallback = useConfigProperty5("core.customMethods.handleLink");
  const handleLinkClick = React40.useCallback(
    (event) => {
      if (!linkUrl) {
        return;
      }
      event.preventDefault();
      handleLinkCallback(linkUrl);
    },
    [handleLinkCallback, linkUrl]
  );
  return /* @__PURE__ */ React40.createElement(
    StatusBanner,
    {
      icon: iconUrl,
      showIcon: true,
      status: bannerType,
      title
    },
    /* @__PURE__ */ React40.createElement(ParagraphText12, null, description),
    linkUrl && /* @__PURE__ */ React40.createElement(
      TextAction2,
      {
        css: { maxWidth: "fit-content" },
        href: linkUrl,
        indicator: "externalLink",
        onClick: handleLinkClick,
        rel: "noopener noreferrer",
        target: "_blank"
      },
      linkText
    )
  );
};
var DetailHeaderBanner = ({
  banners = []
}) => {
  if (!banners.length) {
    return null;
  }
  return /* @__PURE__ */ React40.createElement(DetailBanner, { banner: banners[0] });
};

// src/pages/wallet-detail/components/card-detail-summary/card-detail-summary.component.tsx
import React41 from "react";
import { useIntl as useIntl26 } from "@leagueplatform/locales";
import {
  Box as Box25,
  HeadingText as HeadingText14,
  ParagraphText as ParagraphText13,
  StackItem as StackItem3,
  StackLayout as StackLayout15,
  UtilityText as UtilityText2
} from "@leagueplatform/genesis-core";
import { Image as Image11 } from "@leagueplatform/genesis-commons";
import { handleStaticAsset as handleStaticAsset8 } from "@leagueplatform/asset-config";
function CardDetailSummary({
  title,
  subtitle,
  planName = null,
  productType,
  startDate = null,
  endDate = null,
  icon
}) {
  var _a;
  const { userId, benefitId } = useWalletParams();
  const { formatMessage } = useIntl26();
  const { data: benefitCard } = useWalletDetailQuery(userId, benefitId);
  const hasStartOrEndDate = Boolean(startDate || endDate);
  const shouldDisplayDates = hasStartOrEndDate && ((_a = benefitCard == null ? void 0 : benefitCard.content_configuration) == null ? void 0 : _a.show_policy_dates) !== false;
  const policyDates = [startDate, endDate].filter((date) => !!date).join(" - ");
  return /* @__PURE__ */ React41.createElement(
    Box25,
    {
      css: {
        width: "100%",
        "@mobile": {
          paddingTop: "$three"
        }
      }
    },
    /* @__PURE__ */ React41.createElement(
      StackLayout15,
      {
        horizontalAlignment: "center",
        verticalAlignment: "center",
        spacing: {
          "@initial": "$two",
          "@mobile": "$threeQuarters",
          "@mobileLandscape": "$threeQuarters",
          "@tablet": "$threeQuarters",
          "@desktop": "$two"
        },
        orientation: "horizontal"
      },
      /* @__PURE__ */ React41.createElement(
        StackItem3,
        {
          css: {
            width: "$five",
            height: "$five",
            backgroundColor: "$surfaceBackgroundPrimary",
            borderRadius: "$circle",
            "@mobile": {
              order: "2"
            }
          },
          horizontalAlignment: "center",
          verticalAlignment: "center"
        },
        /* @__PURE__ */ React41.createElement(
          Image11,
          {
            width: "48px",
            height: "48px",
            alignSelf: "center",
            src: icon || getProductIcon(productType),
            alt: ""
          }
        )
      ),
      /* @__PURE__ */ React41.createElement(StackLayout15, { spacing: "$quarter", horizontalAlignment: "start" }, /* @__PURE__ */ React41.createElement(
        StackLayout15,
        {
          orientation: {
            "@initial": "horizontal",
            "@mobile": "vertical",
            "@mobileLandscape": "vertical",
            "@tablet": "vertical",
            "@desktop": "horizontal"
          }
        },
        planName && /* @__PURE__ */ React41.createElement(
          UtilityText2,
          {
            size: "eyebrow",
            emphasis: "emphasized",
            css: { marginBottom: "$half" }
          },
          planName
        ),
        /* @__PURE__ */ React41.createElement(HeadingText14, { level: "1", size: "xxl" }, title)
      ), subtitle && /* @__PURE__ */ React41.createElement(HeadingText14, { as: "p", level: "display", size: "lg" }, subtitle), shouldDisplayDates && /* @__PURE__ */ React41.createElement(
        StackLayout15,
        {
          spacing: "$threeQuarters",
          orientation: "horizontal",
          horizontalAlignment: "start",
          css: {
            marginTop: "$quarter"
          }
        },
        /* @__PURE__ */ React41.createElement(
          Image11,
          {
            width: "24px",
            height: "24px",
            src: handleStaticAsset8("CALENDAR" /* CALENDAR */),
            alt: ""
          }
        ),
        /* @__PURE__ */ React41.createElement(ParagraphText13, { emphasis: "subtle", css: { textAlign: "start" } }, `${formatMessage({ id: "POLICY_ACTIVE" })}: `, /* @__PURE__ */ React41.createElement(Box25, { as: "span", css: { display: "inline-block" } }, policyDates))
      ))
    )
  );
}

// src/pages/wallet-detail/components/card-status/card-status.view.jsx
import PropTypes2 from "prop-types";
import React42 from "react";
import { useIntl as useIntl27 } from "@leagueplatform/locales";
import { HeadingText as HeadingText15, ParagraphText as ParagraphText14 } from "@leagueplatform/genesis-core";
import {
  Box as Box26,
  Flex as Flex15,
  Image as Image12,
  genesisStyled as genesisStyled12,
  css as css12,
  Link as Link3
} from "@leagueplatform/genesis-commons";
import { CARD_STATUS as CARD_STATUS5 } from "@leagueplatform/wallet-api";
import { handleStaticAsset as handleStaticAsset9 } from "@leagueplatform/asset-config";
var HeaderIcon = genesisStyled12(Image12)(
  css12({
    marginInlineEnd: "half",
    width: 16,
    height: 16,
    position: "relative",
    top: 1
  })
);
var Body = genesisStyled12(Box26)(
  css12({
    padding: "one",
    textAlign: "center",
    borderEndStartRadius: "small",
    borderEndEndRadius: "small"
  })
);
var dateFormat = {
  year: "numeric",
  month: "short",
  day: "numeric"
};
function dayDistance(a, b) {
  return Math.abs(Math.round((a - b) / 1e3 / 60 / 60 / 24));
}
function boldText(msg) {
  return /* @__PURE__ */ React42.createElement("strong", null, msg);
}
function Pending({ currentDate, startDate, endDate }) {
  const { formatMessage, formatDate } = useIntl27();
  return /* @__PURE__ */ React42.createElement(Box26, { marginBottom: "two" }, /* @__PURE__ */ React42.createElement(
    HeadingText15,
    {
      level: "4",
      size: "md",
      css: {
        borderStartStartRadius: "$small",
        borderStartEndRadius: "$small",
        textTransform: "uppercase",
        textAlign: "center",
        padding: "half",
        verticalAlign: "baseline",
        backgroundColor: "$highlightIcon",
        color: "$onSurfaceTextReversed"
      }
    },
    /* @__PURE__ */ React42.createElement(
      HeaderIcon,
      {
        alt: "",
        src: handleStaticAsset9("CLOCK_ICON_WHITE" /* CLOCK_ICON_WHITE */)
      }
    ),
    formatMessage(
      { id: "BECOMES_ACTIVE_ON_DATE" },
      { date: formatDate(startDate, dateFormat) }
    )
  ), /* @__PURE__ */ React42.createElement(Body, { backgroundColor: "highlight.background.subdued" }, startDate > currentDate && /* @__PURE__ */ React42.createElement(HeadingText15, { level: "4", size: "md", css: { marginBottom: "$half" } }, formatMessage(
    { id: "BECOMES_ACTIVE_IN_X_DAYS" },
    { days: dayDistance(currentDate, startDate) }
  )), /* @__PURE__ */ React42.createElement(ParagraphText14, { size: "sm" }, formatMessage(
    { id: "YOU_CAN_ONLY_SUBMIT_CLAIMS_IN_DATE_RANGE" },
    {
      strong: boldText,
      dateRange: ` ${formatDate(startDate, dateFormat)} -
                  ${formatDate(endDate, dateFormat)}`
    }
  ))));
}
Pending.propTypes = {
  currentDate: PropTypes2.instanceOf(Date).isRequired,
  startDate: PropTypes2.instanceOf(Date).isRequired,
  endDate: PropTypes2.instanceOf(Date).isRequired
};
function ActivationPending() {
  const { formatMessage } = useIntl27();
  return /* @__PURE__ */ React42.createElement(Box26, { marginBottom: "two" }, /* @__PURE__ */ React42.createElement(
    HeadingText15,
    {
      level: "4",
      size: "md",
      css: {
        borderStartStartRadius: "small",
        borderStartEndRadius: "small",
        textTransform: "uppercase",
        textAlign: "center",
        padding: "half",
        verticalAlign: "baseline",
        backgroundColor: "$highlightIcon",
        color: "$onSurfaceTextReversed"
      }
    },
    /* @__PURE__ */ React42.createElement(
      HeaderIcon,
      {
        alt: "",
        src: handleStaticAsset9("CLOCK_ICON_WHITE" /* CLOCK_ICON_WHITE */)
      }
    ),
    formatMessage({ id: "ACTIVATION_PENDING" })
  ), /* @__PURE__ */ React42.createElement(Body, { backgroundColor: "highlight.background.subdued" }, /* @__PURE__ */ React42.createElement(HeadingText15, { level: "4", size: "md", css: { marginBottom: "$half" } }, formatMessage({
    id: "YOUR_ACCOUNT_IS_ACTIVE_AND_IN_THE_PROCESS_OF_BEING_SET_UP"
  })), /* @__PURE__ */ React42.createElement(ParagraphText14, { size: "sm" }, formatMessage(
    {
      id: "IF_YOU_HAVE_AN_URGENT_CLAIM_PLEASE_CONTACT_CUSTOMER_SUPPORT"
    },
    {
      // eslint-disable-next-line react/no-unstable-nested-components
      a: (text) => /* @__PURE__ */ React42.createElement(
        Link3,
        {
          fontSize: "body2",
          href: `mailto:${formatMessage({ id: "HELP_EMAIL" })}`
        },
        text
      )
    }
  ))));
}
function ExpiringSoon({ currentDate, endDate, inactiveDate }) {
  const { formatMessage, formatDate } = useIntl27();
  return /* @__PURE__ */ React42.createElement(Box26, { marginBottom: "two" }, /* @__PURE__ */ React42.createElement(
    HeadingText15,
    {
      level: "4",
      size: "md",
      css: {
        borderStartStartRadius: "small",
        borderStartEndRadius: "small",
        textTransform: "uppercase",
        textAlign: "center",
        padding: "half",
        verticalAlign: "baseline",
        backgroundColor: "$onSurfaceTextPrimary",
        color: "$onSurfaceTextReversed"
      }
    },
    /* @__PURE__ */ React42.createElement(
      HeaderIcon,
      {
        alt: "",
        src: handleStaticAsset9("CLOCK_ICON_WHITE" /* CLOCK_ICON_WHITE */)
      }
    ),
    formatMessage(
      { id: "EXPIRES_ON_DATE" },
      { date: formatDate(endDate, dateFormat) }
    )
  ), /* @__PURE__ */ React42.createElement(Body, { backgroundColor: "highlight.background.subdued" }, /* @__PURE__ */ React42.createElement(HeadingText15, { level: "4", size: "md", css: { marginBottom: "$half" } }, formatMessage(
    { id: "YOU_HAVE_X_DAYS_BEFORE_EXPIRY" },
    { days: dayDistance(currentDate, endDate) }
  )), /* @__PURE__ */ React42.createElement(ParagraphText14, { size: "sm" }, formatMessage(
    { id: "AFTER_EXPIRY_YOU_HAVE_UNTIL_DATE_TO_SUBMIT" },
    {
      strong: boldText,
      inactiveDate: formatDate(inactiveDate, dateFormat),
      endDate: formatDate(endDate, dateFormat)
    }
  ))));
}
ExpiringSoon.propTypes = {
  currentDate: PropTypes2.instanceOf(Date).isRequired,
  endDate: PropTypes2.instanceOf(Date).isRequired,
  inactiveDate: PropTypes2.instanceOf(Date).isRequired
};
function Expired({ currentDate, endDate, inactiveDate }) {
  const { formatMessage, formatDate } = useIntl27();
  const daysUntilInactive = dayDistance(currentDate, inactiveDate);
  return /* @__PURE__ */ React42.createElement(Box26, { marginBottom: "two" }, /* @__PURE__ */ React42.createElement(
    HeadingText15,
    {
      level: "4",
      size: "md",
      css: {
        borderStartStartRadius: "small",
        borderStartEndRadius: "small",
        textTransform: "uppercase",
        textAlign: "center",
        padding: "half",
        verticalAlign: "baseline",
        backgroundColor: "$warningBorderDefault",
        color: "$onSurfaceTextPrimary"
      }
    },
    /* @__PURE__ */ React42.createElement(
      HeaderIcon,
      {
        alt: "",
        src: handleStaticAsset9("CLOCK_ICON_BLURPLE" /* CLOCK_ICON_BLURPLE */)
      }
    ),
    formatMessage(
      { id: "SUBMIT_PAST_CLAIMS_BY_DATE" },
      { date: formatDate(inactiveDate, dateFormat) }
    )
  ), /* @__PURE__ */ React42.createElement(Body, { backgroundColor: "warning.background.subdued" }, /* @__PURE__ */ React42.createElement(HeadingText15, { level: "4", size: "md", css: { marginBottom: "$half" } }, daysUntilInactive > 1 && formatMessage(
    { id: "THIS_POLICY_HAS_EXPIRED" },
    { days: daysUntilInactive }
  ), daysUntilInactive <= 1 && formatMessage({ id: "THIS_POLICY_EXPIRES_TOMORROW" })), /* @__PURE__ */ React42.createElement(ParagraphText14, { size: "sm" }, formatMessage(
    { id: "YOU_HAVE_UNTIL_DATE_TO_SUBMIT_PAST_CLAIMS" },
    {
      strong: boldText,
      inactiveDate: formatDate(inactiveDate, dateFormat),
      endDate: formatDate(endDate, dateFormat)
    }
  ))));
}
Expired.propTypes = {
  currentDate: PropTypes2.instanceOf(Date).isRequired,
  endDate: PropTypes2.instanceOf(Date).isRequired,
  inactiveDate: PropTypes2.instanceOf(Date).isRequired
};
var { CREATED: CREATED2, READY: READY2, IN_WAITING_PERIOD: IN_WAITING_PERIOD2, INACTIVE_GRACE_PERIOD: INACTIVE_GRACE_PERIOD2, INACTIVE: INACTIVE2 } = CARD_STATUS5;
function Switch({ status, currentDate, startDate, endDate, inactiveDate }) {
  const {
    showBenefitStatusBannerCreated,
    showBenefitStatusBannerPending,
    showBenefitStatusBannerExpired
  } = useWalletConfig();
  switch (status) {
    case CREATED2:
      return showBenefitStatusBannerCreated && /* @__PURE__ */ React42.createElement(
        ActivationPending,
        {
          currentDate,
          startDate,
          endDate
        }
      );
    case READY2:
    case IN_WAITING_PERIOD2:
      return showBenefitStatusBannerPending && /* @__PURE__ */ React42.createElement(
        Pending,
        {
          currentDate,
          startDate,
          endDate
        }
      );
    case INACTIVE_GRACE_PERIOD2:
    case INACTIVE2:
      return showBenefitStatusBannerExpired && /* @__PURE__ */ React42.createElement(
        Expired,
        {
          currentDate,
          endDate,
          inactiveDate
        }
      );
    default:
      return null;
  }
}
function CardStatus({
  status,
  currentDate,
  startDate,
  endDate,
  inactiveDate
}) {
  return /* @__PURE__ */ React42.createElement(Flex15, { flexDirection: "column" }, /* @__PURE__ */ React42.createElement(
    Switch,
    {
      status,
      currentDate,
      startDate,
      endDate,
      inactiveDate
    }
  ));
}
CardStatus.propTypes = {
  status: PropTypes2.string,
  currentDate: PropTypes2.instanceOf(Date).isRequired,
  startDate: PropTypes2.instanceOf(Date),
  endDate: PropTypes2.instanceOf(Date),
  inactiveDate: PropTypes2.instanceOf(Date)
};
CardStatus.defaultProps = {
  startDate: null,
  endDate: null,
  inactiveDate: null,
  status: null
};
Switch.propTypes = CardStatus.propTypes;

// src/pages/wallet-detail/components/card-detail-quick-action-links/card-detail-quick-action-links.component.tsx
import * as React44 from "react";
import { Box as Box27 } from "@leagueplatform/genesis-core";
import { SectionHeader as SectionHeader4 } from "@leagueplatform/genesis-core-alpha";
import { StackLayout as StackLayout16 } from "@leagueplatform/web-common-components";

// src/pages/wallet-detail/components/card-detail-quick-action-links/components/action-link/action-link.component.tsx
import React43 from "react";
var ActionLink = ({ action }) => {
  const { LinkComponent, handleActionClick } = useActionLink(action);
  const { icon_url: icon, nav_icon: secondaryIcon } = action;
  if (!LinkComponent) {
    return null;
  }
  return /* @__PURE__ */ React43.createElement(
    LinkComponent,
    {
      primaryIcon: icon,
      secondaryIcon,
      action,
      onClickCallback: handleActionClick
    }
  );
};

// src/pages/wallet-detail/components/card-detail-quick-action-links/hooks/use-card-detail-quick-action-links.hook.ts
import { useIntl as useIntl28 } from "@leagueplatform/locales";

// src/pages/wallet-detail/components/card-detail-quick-action-links/utils/filter-save-card-action.util.ts
var filterSaveCardAction = (actions) => actions.filter((action) => !isSaveCardAction(action));

// src/pages/wallet-detail/components/card-detail-quick-action-links/hooks/use-card-detail-quick-action-links.hook.ts
var useCardDetailQuickActionLinks = () => {
  const { userId, benefitId } = useWalletParams();
  const { formatMessage } = useIntl28();
  const { data: sortedActionCategories, isLoading } = useWalletDetailQuery(
    userId,
    benefitId,
    void 0,
    {
      select: (data) => {
        var _a;
        const nonPrimaryCategoryActions = ((_a = data.categorized_actions) == null ? void 0 : _a.map((categoryAction) => __spreadProps(__spreadValues({}, categoryAction), {
          actions: filterSaveCardAction(categoryAction.actions)
        }))) || [];
        const fallbackActions = data.actions !== null ? [
          {
            actions: filterSaveCardAction(data.actions),
            title: formatMessage({ id: "ACTIONS" })
          }
        ] : [];
        if (nonPrimaryCategoryActions.length === 0 && fallbackActions.length === 0) {
          return [];
        }
        if (nonPrimaryCategoryActions.length === 0) {
          return fallbackActions;
        }
        return nonPrimaryCategoryActions;
      }
    }
  );
  const filteredCategoryActions = sortedActionCategories == null ? void 0 : sortedActionCategories.filter(
    (actionCategory) => actionCategory.actions.length
  );
  return { actionGroups: filteredCategoryActions, isLoading };
};

// src/pages/wallet-detail/components/card-detail-quick-action-links/card-detail-quick-action-links.component.tsx
var CardDetailQuickActionLinks = () => {
  const { actionGroups, isLoading } = useCardDetailQuickActionLinks();
  if (!actionGroups || actionGroups.length === 0 || isLoading) {
    return null;
  }
  return /* @__PURE__ */ React44.createElement(
    Box27,
    {
      css: {
        backgroundColor: "$surfaceBackgroundPrimary",
        borderWidth: "$thin",
        borderColor: "$onSurfaceBorderSubdued",
        borderStyle: "solid",
        borderRadius: "$medium",
        padding: "$oneAndHalf"
      }
    },
    /* @__PURE__ */ React44.createElement(StackLayout16, { space: "$oneAndHalf" }, actionGroups.map((actionGroup) => /* @__PURE__ */ React44.createElement(React44.Fragment, { key: `${actionGroup.title.replace(" ", "-")}-group` }, /* @__PURE__ */ React44.createElement(SectionHeader4, { headingLevel: "2", title: actionGroup.title }), /* @__PURE__ */ React44.createElement(StackLayout16, { as: "ul", space: "$oneAndHalf" }, actionGroup.actions.map((action) => /* @__PURE__ */ React44.createElement(
      Box27,
      {
        as: "li",
        role: "listitem",
        key: `${action.name.replace(" ", "-")}-action`,
        css: { listStyle: "none", maxWidth: "80ch" }
      },
      /* @__PURE__ */ React44.createElement(ActionLink, { key: action.url, action })
    ))))))
  );
};

// src/pages/wallet-detail/components/faq-links/faq-links.component.tsx
import React45 from "react";
import { SectionHeader as SectionHeader5 } from "@leagueplatform/genesis-core-alpha";
import { Link as Link4, Box as Box28 } from "@leagueplatform/genesis-commons";
import { StackLayout as StackLayout17 } from "@leagueplatform/web-common-components";

// src/pages/wallet-detail/components/faq-links/hooks/use-faq-links.hook.ts
import { sendAnalyticsEvent as sendAnalyticsEvent2 } from "@leagueplatform/analytics";

// src/pages/wallet-detail/components/faq-links/hooks/queries/use-faq-links-query.hook.ts
import {
  getFaqLinks,
  GET_FAQ_LINKS_MESSAGE_TYPE
} from "@leagueplatform/wallet-api";
import { useQuery as useQuery8 } from "@tanstack/react-query";

// src/pages/wallet-detail/components/faq-links/utils/get-normalized-faq-items.util.ts
function getNormalizedFaqItems(data) {
  return data.benefit_product_types.reduce(
    (sections, productType) => [
      ...sections,
      ...productType.sections.map((section) => {
        var _a, _b;
        return {
          productType: productType.benefit_product_type,
          country: productType.country,
          heading: section.faq_article_section_display_text.text,
          questions: section.faqs.map((faq) => ({
            text: faq.question_display_text.text,
            url: faq.url.url
          })),
          linkText: (_a = section.faq_article_section_link_text) == null ? void 0 : _a.text,
          linkUrl: (_b = section.faq_article_section_link_url) == null ? void 0 : _b.text
        };
      })
    ],
    []
  );
}

// src/pages/wallet-detail/components/faq-links/hooks/queries/use-faq-links-query.hook.ts
function useFaqLinksQuery(benefitProductType) {
  const { userId } = useWalletParams();
  return useQuery8(
    [GET_FAQ_LINKS_MESSAGE_TYPE, userId, benefitProductType],
    () => getFaqLinks(benefitProductType, userId),
    // TODO: Allow query to take RQ options
    { select: (data) => getNormalizedFaqItems(data) }
  );
}

// src/pages/wallet-detail/components/faq-links/hooks/use-faq-links.hook.ts
var useFaqLinks = ({
  benefitProductType
}) => {
  var _a;
  const onLinkClick = (sectionHeading, label) => {
    sendAnalyticsEvent2({
      category: "Wallet",
      action: `FAQ: ${sectionHeading}`,
      label,
      params: {}
    });
  };
  const faqLinksQuery = useFaqLinksQuery(benefitProductType);
  return { onLinkClick, sections: (_a = faqLinksQuery.data) != null ? _a : [] };
};

// src/pages/wallet-detail/components/faq-links/faq-links.component.tsx
var FaqLinks = ({ benefitProductType = "" }) => {
  const { onLinkClick: handleLinkClick, sections } = useFaqLinks({
    benefitProductType
  });
  if (!sections) {
    return null;
  }
  return /* @__PURE__ */ React45.createElement(React45.Fragment, null, sections.map((section) => /* @__PURE__ */ React45.createElement(
    StackLayout17,
    {
      key: section.heading,
      space: "$oneAndHalf",
      css: {
        borderWidth: "$thin",
        borderColor: "$onSurfaceBorderSubdued",
        borderStyle: "solid",
        borderRadius: "$medium",
        padding: "$oneAndHalf"
      }
    },
    /* @__PURE__ */ React45.createElement(SectionHeader5, { headingLevel: "2", title: section.heading }),
    /* @__PURE__ */ React45.createElement(StackLayout17, { space: "$oneAndHalf", as: "ul" }, section.questions.map(({ text, url }) => /* @__PURE__ */ React45.createElement(Box28, { as: "li", key: url }, /* @__PURE__ */ React45.createElement(
      Link4,
      {
        maxWidth: "80ch",
        fontWeight: "medium",
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: () => {
          handleLinkClick(section.heading, text);
        }
      },
      text
    ))), section.linkText && /* @__PURE__ */ React45.createElement(
      Box28,
      {
        as: "li",
        paddingTop: "oneAndHalf",
        borderTopWidth: "thin",
        borderColor: "onSurface.border.subdued",
        borderStyle: "solid"
      },
      /* @__PURE__ */ React45.createElement(
        Link4,
        {
          href: section.linkUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          maxWidth: "80ch",
          onClick: () => {
            handleLinkClick(section.heading, section.linkText || "");
          }
        },
        section.linkText
      )
    ))
  )));
};

// src/pages/wallet-detail/components/navigation-tabs/navigation-tabs.component.tsx
import * as React75 from "react";
import { useIntl as useIntl49 } from "@leagueplatform/locales";
import { EVENT_NAME as EVENT_NAME18 } from "@leagueplatform/analytics";
import { Tabs as Tabs5, Box as Box48 } from "@leagueplatform/genesis-core";

// src/pages/wallet-detail/hooks/use-fallback-tabs.hook.ts
import { useMemo as useMemo11 } from "react";
import { useIntl as useIntl29 } from "@leagueplatform/locales";
import { BENEFIT_CARD_ACTION, SYSTEM_TYPES as SYSTEM_TYPES2 } from "@leagueplatform/wallet-api";
function useFallbackTabs() {
  const { formatMessage } = useIntl29();
  const fallbackTabs = useMemo11(() => {
    const coverageOverviewTab = {
      id: "overview",
      type: BENEFIT_CARD_ACTION.CONTENT,
      system_type: SYSTEM_TYPES2.CoverageOverview,
      name: formatMessage({ id: "OVERVIEW" }),
      banners: {},
      indicator: false
    };
    return [coverageOverviewTab];
  }, [formatMessage]);
  return fallbackTabs;
}

// src/pages/wallet-detail/hooks/use-select-benefit-tabs.hook.ts
import { useMemo as useMemo12 } from "react";
import { useIntl as useIntl30 } from "@leagueplatform/locales";
import { useUrlParam } from "@leagueplatform/web-common";
import { useFeatureFlagQuery as useFeatureFlagQuery3 } from "@leagueplatform/user-profile-api";
import {
  BENEFIT_CARD_ACTION as BENEFIT_CARD_ACTION2,
  SYSTEM_TYPES as SYSTEM_TYPES3
} from "@leagueplatform/wallet-api";

// src/pages/wallet-detail/utils/is-benefit-tab.util.ts
import {
  ACTION_TYPES,
  TAB_SYSTEM_TYPES
} from "@leagueplatform/wallet-api";
function isBenefitTab(action) {
  return action.type === ACTION_TYPES.CONTENT || TAB_SYSTEM_TYPES.includes(action.system_type);
}

// src/pages/wallet-detail/hooks/use-select-benefit-tabs.hook.ts
function getTabOrder(tab) {
  switch (tab.system_type) {
    case SYSTEM_TYPES3.About: {
      return 0;
    }
    case SYSTEM_TYPES3.CardInfo: {
      return 1;
    }
    default: {
      return 2;
    }
  }
}
function compareTabs(a, b) {
  return getTabOrder(a) - getTabOrder(b);
}
var PLAN_PROGRESS_DEEPLINK_TAB_STRING = "plan_progress";
function useSelectBenefitTabs() {
  const { formatMessage } = useIntl30();
  const { urlParam: deeplinkTab } = useUrlParam("tab");
  const isPlanProgressDeeplink = deeplinkTab === PLAN_PROGRESS_DEEPLINK_TAB_STRING;
  const { data: includeAboutTab } = useFeatureFlagQuery3(
    WALLET_API_FEATURE_FLAGS.IS_CLINICAL_PROGRAMS_ENABLED
  );
  const planProgressTab = useMemo12(
    () => ({
      banners: {},
      id: "PLAN_PROGRESS",
      indicator: false,
      isDefaultSelected: isPlanProgressDeeplink,
      name: formatMessage({ id: "PLAN_PROGRESS" }),
      system_type: SYSTEM_TYPES3.UsageOverview,
      type: BENEFIT_CARD_ACTION2.CONTENT
    }),
    [formatMessage, isPlanProgressDeeplink]
  );
  const planProgressAndCoverageTab = useMemo12(
    () => ({
      banners: {},
      id: "PLAN_PROGRESS_COST_COVERAGE",
      indicator: false,
      isDefaultSelected: isPlanProgressDeeplink,
      name: formatMessage({ id: "PLAN_PROGRESS_COST_COVERAGE" }),
      system_type: SYSTEM_TYPES3.PlanProgressCoverageOverview,
      type: BENEFIT_CARD_ACTION2.CONTENT
    }),
    [formatMessage, isPlanProgressDeeplink]
  );
  const aboutTab = useMemo12(
    () => ({
      id: "ABOUT",
      type: BENEFIT_CARD_ACTION2.CONTENT,
      system_type: SYSTEM_TYPES3.About,
      name: formatMessage({ id: "ABOUT" }),
      banners: {},
      indicator: false
    }),
    [formatMessage]
  );
  return (benefitCard) => {
    var _a, _b;
    const hasUserLiveBalances = benefitCard.show_user_benefit_live_balances;
    const isCombinedPlanProgressandCoverage = (_a = benefitCard.content_configuration) == null ? void 0 : _a.show_cost_and_coverage;
    let tabs = ((_b = benefitCard.content_actions) == null ? void 0 : _b.filter(isBenefitTab)) || [];
    if (hasUserLiveBalances && !isCombinedPlanProgressandCoverage) {
      tabs = [planProgressTab, ...tabs];
    }
    if (hasUserLiveBalances && isCombinedPlanProgressandCoverage) {
      tabs = [planProgressAndCoverageTab, ...tabs];
    }
    if (benefitCard.description && includeAboutTab) {
      tabs = [aboutTab, ...tabs];
    }
    tabs.sort(compareTabs);
    return tabs;
  };
}

// src/pages/wallet-detail/hooks/queries/use-wallet-detail-tabs-query.hook.ts
var EMPTY_TABS = [];
function useWalletDetailTabsQuery(userId, benefitId) {
  var _a;
  const fallbackTabs = useFallbackTabs();
  const selectBenefitTabs = useSelectBenefitTabs();
  const query = useWalletDetailQuery(
    userId,
    benefitId,
    void 0,
    {
      select: selectBenefitTabs
    }
  );
  let tabs = (_a = query.data) != null ? _a : EMPTY_TABS;
  if (tabs.length === 0 && !query.isLoading) {
    tabs = fallbackTabs;
  }
  return __spreadProps(__spreadValues({}, query), { data: tabs });
}

// src/pages/wallet-detail/hooks/queries/use-wallet-tabs-content-query.hook.ts
import { useMemo as useMemo17 } from "react";
import { useFeatureFlagQuery as useFeatureFlagQuery8 } from "@leagueplatform/user-profile-api";

// src/pages/wallet-detail/utils/get-content-component.util.ts
import {
  CARD_STATUS as CARD_STATUS6,
  SYSTEM_TYPES as SYSTEM_TYPES6
} from "@leagueplatform/wallet-api";

// src/pages/wallet-detail/components/card-body/card-body.component.tsx
import React46 from "react";
import DOMPurify2 from "dompurify";
import { transformAnchorTag } from "@leagueplatform/web-common";

// src/pages/wallet-detail/components/card-body/card-body-box.component.tsx
import {
  genesisStyled as genesisStyled13,
  Box as Box29
} from "@leagueplatform/genesis-commons";
var CardBodyBox = genesisStyled13(Box29)`
  background-color: ${({ theme }) => theme.colors.surface.background.primary};
  color: ${({ theme }) => theme.colors.onSurface.text.primary};
  .benefit-coverage-container {
    color: ${({ theme }) => theme.colors.onSurface.text.primary};
    background-color: ${({ theme }) => theme.colors.surface.background.primary};
    font-family: ${({ theme }) => theme.fonts.body};
    h1,
    h2,
    h3,
    h4 {
      font-family: ${({ theme }) => theme.fonts.heading};
      font-weight: ${({ theme }) => theme.fontWeights.medium}
    }
    article,
    section {
      box-shadow: none;
    }

    article {
      margin: ${({ theme }) => theme.space.half}px 0;
      padding: 0;
    }

    h2 {
      font-size: ${({ theme }) => theme.fontSizes.heading2}px;
      margin-top: ${({ theme }) => theme.space.oneAndHalf}px;
    }

    h3 {
      font-size: ${({ theme }) => theme.fontSizes.heading3}px;
    }

    p {
      border-bottom: none;
      line-height: ${({ theme }) => theme.lineHeights.body1}px;
    }

    h3 + p {
      padding-top: 0;
    }

    h6 {
      font-size: ${({ theme }) => theme.fontSizes.heading2}px;
      margin-top: ${({ theme }) => theme.space.oneAndHalf}px;
      &:first-of-type {
        margin-top: ${({ theme }) => theme.space.oneAndHalf}px;
      }
    }

    dd,
    a {
      font-weight: ${({ theme }) => theme.fontWeights.medium};
    }

    dt {
      border-bottom: none;
      margin-bottom: ${({ theme }) => theme.space.one}px;
    }

    pre {
      line-height: 1.4em;
      padding-inline-start: ${({ theme }) => theme.space.oneAndHalf}px;
    }

    strong a {
      font-weight:  ${({ theme }) => theme.fontWeights.semibold};
    }

    .note {
      font-weight: normal;
      padding-top: ${({ theme }) => theme.space.half}px;
    }

    sup {
      font-size: ${({ theme }) => theme.fontSizes.caption}px;
    }

    table {
      border-collapse: collapse;
      margin: ${({ theme }) => theme.space.one}px 0;
      width: 100%;
    }

    table,
    td,
    th {
      border: ${({ theme }) => theme.borderWidths.thin}px solid ${({ theme }) => theme.colors.onSurface.border.subdued};
    }

    th {
      background-color: ${({ theme }) => theme.colors.onSurface.border.subdued};
      font-weight: ${({ theme }) => theme.fontWeights.medium};
    }

    th,
    td {
      padding: ${({ theme }) => theme.space.half}px;
      text-align: center;
    }

    td.subheading {
      text-align: start;
    }

    td.instructions {
      text-align: start;
    }

    table.usage {
      line-height: 1.5em;
    }

    .tabular {
      border-bottom: none;
      margin-inline-start: 0;
      display: flex;
      position: relative;
      &:before {
        order: 1;
        display: block;
        content: '';
        flex-grow: 1;
        height: 20px;
        background-image: linear-gradient(
          to right,
          rgba(0, 0, 0, 0.25) 25%,
          rgba(255, 255, 255, 0) 0%
        );
        background-position: bottom;
        background-size: 9px 2px;
        background-repeat: repeat-x;
      }

      span {
        &.desc {
          flex-grow: 0;
          flex-basis: auto;
          flex-shrink: 1;
          flex-wrap: wrap;
          order: 0;
          padding-inline-end: 0.25em;
          max-width: 60%;
        }
        &.value {
          text-align: start;
          order: 2;
          flex-basis: auto;
          flex-grow: 0;
          padding-inline-start: 0.25em;
          max-width: 60%;
        }
      }
    }

    .account-overview {
      & > div {
        margin: ${({ theme }) => theme.space.three}px 0 ${({ theme }) => theme.space.two}px;
      }

      h3 {
        font-size: ${({ theme }) => theme.fontSizes.heading3}px;
        margin-bottom: ${({ theme }) => theme.space.one}px;
      }

      .tooltip {
        position: relative;
        &:before {
          width: ${({ theme }) => theme.space.one}px;
          height:${({ theme }) => theme.space.one}px;
          font-weight: ${({ theme }) => theme.fontWeights.regular};
          font-size: ${({ theme }) => theme.fontSizes.body2}px;
          line-height: ${({ theme }) => theme.lineHeights.overline}px;
        }
        .tooltip-content {
          background-color: ${({ theme }) => theme.colors.surface.background.primary};
          color: ${({ theme }) => theme.colors.onSurface.text.primary};
          border: ${({ theme }) => theme.borderWidths.thin}px solid ${({
  theme
}) => theme.colors.onSurface.border.default};
          inset-inline-start: -41px;
          width: 400px;

          &:before,
          &:after {
            content: '';
            position: absolute;
            top: 100%;
            inset-inline-start: ${({ theme }) => theme.space.three}px;
            transform: translateX(-50%);
            width: 0;
            height: 0;
          }

          &:before {
            border-top: ${({ theme }) => theme.space.one}px solid ${({
  theme
}) => theme.colors.onSurface.border.default};
          }

          &:after {
            content: '';
            border-top: ${({ theme }) => theme.space.one - 1}px solid ${({
  theme
}) => theme.colors.surface.background.primary};
            border-inline-end: ${({ theme }) => theme.space.one - 2}px solid transparent;
            border-inline-start: ${({ theme }) => theme.space.one - 2}px solid transparent;
          }
        }

        &:hover {
          .tooltip-content {
            transform: translateY(-20px);
          }
        }
      }

      .tabular {
        border-top: ${({ theme }) => theme.borderWidths.thin}px solid ${({
  theme
}) => theme.colors.onSurface.border.subdued};
        align-items: center;
        padding: ${({ theme }) => theme.space.oneAndHalf}px ${({ theme }) => theme.space.one}px;
        height: 8rem;

        &.total-funds {
          background-color: ${({ theme }) => theme.colors.surface.background.secondary};
        }

        &.total-available-balance {
          border-top-color: ${({ theme }) => theme.colors.decorative.brand.primary.bright};
          border-bottom: ${({ theme }) => theme.borderWidths.thin}px solid ${({
  theme
}) => theme.colors.decorative.brand.primary.bright};
          background-color: ${({ theme }) => theme.colors.decorative.brand.primary.brightest};
        }

        .desc {
          flex-basis: 70%;
          font-size: ${({ theme }) => theme.fontSizes.body1}px;
        }
        .label {
          font-weight: ${({ theme }) => theme.fontWeights.medium};
        }
        .value {
          .amount {
            font-size: ${({ theme }) => theme.fontSizes.heading4}px;
          }
          .info {
            margin-top: ${({ theme }) => theme.space.quarter}px;
            font-size: ${({ theme }) => theme.fontSizes.body2}px;
          }
        }
        p {
          padding: 0;
          line-height: 1.6;
          font-size: 100%;
        }
      }
    }
  }

  // TODO: Remove this once the card body content is updated to use RichText
  ul {
    margin-block-end: var(--GDS-space-oneAndHalf);
    padding: 0px 0px 0px 18px;
    list-style: revert !important;
  }
`;

// src/pages/wallet-detail/components/card-body/card-body.component.tsx
var CardBody = ({ body = "" }) => {
  if (!body)
    return null;
  DOMPurify2.addHook("afterSanitizeAttributes", transformAnchorTag);
  const cleanHTML = DOMPurify2.sanitize(body, {
    FORCE_BODY: true,
    ALLOWED_ATTR: ["target", "class", "href", "role"]
  });
  DOMPurify2.removeHook("afterSanitizeAttributes");
  return /* @__PURE__ */ React46.createElement(
    CardBodyBox,
    {
      dangerouslySetInnerHTML: {
        __html: cleanHTML
      }
    }
  );
};

// src/pages/wallet-detail/components/content-panel/components/about-benefit/about-benefit.component.tsx
import React47 from "react";
import {
  InternalOrExternalLink,
  LoadingIndicator as LoadingIndicator4
} from "@leagueplatform/web-common-components";
import { Image as Image13 } from "@leagueplatform/genesis-commons";
import { HtmlToReact as HtmlToReact2, StackLayout as StackLayout18 } from "@leagueplatform/genesis-core";
var htmlToReactOptionsOverride = {
  a: {
    component: InternalOrExternalLink
  }
  // TODO: Add style overrides to HtmlToReact options
};
var AboutBenefit = () => {
  var _a, _b;
  const { userId, benefitId } = useWalletParams();
  const { data: aboutData, isLoading } = useWalletDetailQuery(
    userId,
    benefitId,
    void 0,
    {
      select: (data) => ({
        description: data.description,
        featuredImage: data.featured_image
      })
    }
  );
  if (isLoading) {
    return /* @__PURE__ */ React47.createElement(LoadingIndicator4, { inline: true });
  }
  return /* @__PURE__ */ React47.createElement(StackLayout18, { spacing: "$one" }, (aboutData == null ? void 0 : aboutData.featuredImage) && /* @__PURE__ */ React47.createElement(
    Image13,
    {
      src: (_a = aboutData == null ? void 0 : aboutData.featuredImage) == null ? void 0 : _a.src,
      alt: ((_b = aboutData == null ? void 0 : aboutData.featuredImage) == null ? void 0 : _b.description) || "",
      marginBottom: "two",
      loading: "eager",
      width: "auto",
      maxWidth: "100%"
    }
  ), /* @__PURE__ */ React47.createElement(
    HtmlToReact2,
    {
      htmlString: aboutData == null ? void 0 : aboutData.description,
      options: htmlToReactOptionsOverride
    }
  ));
};

// src/pages/wallet-detail/components/content-panel/components/card-details/card-details.component.tsx
import React51 from "react";
import { Box as Box31, css as css13, Flex as Flex16, genesisStyled as genesisStyled14 } from "@leagueplatform/genesis-commons";
import {
  LoadingIndicator as LoadingIndicator5,
  StackLayout as StackLayout20
} from "@leagueplatform/web-common-components";

// src/pages/wallet-detail/components/content-panel/components/card-details/hooks/use-member-card.hook.ts
import { useMemo as useMemo13, useCallback as useCallback8 } from "react";
import { useIntl as useIntl31 } from "@leagueplatform/locales";
import { useFeatureFlagQuery as useFeatureFlagQuery4 } from "@leagueplatform/user-profile-api";
import { EVENT_NAME as EVENT_NAME9 } from "@leagueplatform/analytics";
var PRIMARY_USER = "primary";
var DEPENDENT_USER = "dependent";
var formatDependentOptions = (dependents) => {
  var _a;
  return (_a = dependents == null ? void 0 : dependents.sort((a, b) => a.first_name.localeCompare(b.first_name))) == null ? void 0 : _a.map((dependent) => ({
    label: `${dependent.first_name} ${dependent.last_name}`,
    value: dependent.dependent_id
  }));
};
var formatCardDetailsArray = (memberIdLabel, groupIdLabel, insurance) => [
  {
    key: memberIdLabel,
    value: insurance == null ? void 0 : insurance.member_policy_number
  },
  {
    key: groupIdLabel,
    value: insurance == null ? void 0 : insurance.provider_policy_number
  },
  {
    key: "RxBIN",
    value: insurance == null ? void 0 : insurance.rx_bin
  },
  {
    key: "RxPCN",
    value: insurance == null ? void 0 : insurance.rx_pcn
  },
  {
    key: "RxGROUP",
    value: insurance == null ? void 0 : insurance.rx_group
  },
  {
    key: "RxID",
    value: insurance == null ? void 0 : insurance.rx_id
  },
  {
    key: "RxCarrier",
    value: insurance == null ? void 0 : insurance.rx_carrier
  }
].filter((cardDetail) => cardDetail.value);
var useMemberCard = () => {
  const { userId, benefitId } = useWalletParams();
  const sendBenefitAnalyticsEvent = useWalletDetailAnalytics();
  const { data: isDropdownEnabled } = useFeatureFlagQuery4(
    WALLET_API_FEATURE_FLAGS.IS_DEPENDENTS_DROPDOWN_ENABLED
  );
  const primaryUserId = userId != null ? userId : PRIMARY_USER;
  const { formatMessage } = useIntl31();
  const [member] = useSelectedMember();
  const selectedUserId = member == null ? void 0 : member.id;
  const { data: userData, isInitialLoading: isUserLoading } = useWalletDetailQuery(userId, benefitId);
  const {
    data: dependentData,
    isInitialLoading: isDependentLoading,
    fetchStatus
  } = useWalletDetailQuery(userId, benefitId, selectedUserId, {
    enabled: !!selectedUserId && selectedUserId !== primaryUserId
  });
  const dependentInsurance = dependentData == null ? void 0 : dependentData.insurance;
  const dependentPolicyInfo = dependentData == null ? void 0 : dependentData.policy_info;
  const {
    insurance,
    dependents,
    member_first_name: memberFirstName,
    member_last_name: memberLastName,
    policy_info: policyInfo
  } = userData || {};
  let currentInsurance = insurance;
  if (selectedUserId && selectedUserId !== primaryUserId) {
    currentInsurance = dependentInsurance;
  }
  const dependentOptions = useMemo13(
    () => formatDependentOptions(dependents || []),
    [dependents]
  );
  const memberOptions = useMemo13(
    () => [
      { label: `${memberFirstName} ${memberLastName}`, value: primaryUserId },
      ...dependentOptions
    ],
    [dependentOptions, memberFirstName, memberLastName, primaryUserId]
  );
  const cardDetails = useMemo13(() => {
    if (policyInfo) {
      return dependentPolicyInfo || policyInfo;
    }
    return formatCardDetailsArray(
      formatMessage({ id: "MEMBER_ID" }),
      formatMessage({ id: "GROUP_ID" }),
      currentInsurance || {}
    );
  }, [currentInsurance, dependentPolicyInfo, formatMessage, policyInfo]);
  const onMemberChange = useCallback8(
    (value) => {
      sendBenefitAnalyticsEvent(EVENT_NAME9.BUTTON_CLICKED, {
        detail: `select ${value !== primaryUserId ? DEPENDENT_USER : PRIMARY_USER}`
      });
    },
    [primaryUserId, sendBenefitAnalyticsEvent]
  );
  const showMemberSelect = !!(dependents == null ? void 0 : dependents.length) && !!isDropdownEnabled;
  const isLoading = fetchStatus === "idle" ? isUserLoading : isDependentLoading;
  return {
    memberOptions,
    onMemberChange,
    isLoading,
    cardDetails,
    showMemberSelect
  };
};

// src/pages/wallet-detail/components/content-panel/components/card-details/components/card-details-table.component.tsx
import React48 from "react";
import { ParagraphText as ParagraphText15, Box as Box30, StackLayout as StackLayout19 } from "@leagueplatform/genesis-core";
import { SectionHeader as SectionHeader6 } from "@leagueplatform/genesis-core-alpha";
import { useIntl as useIntl32 } from "@leagueplatform/locales";
var CardDetailsTable = ({
  cardDetails,
  hasDependents
}) => {
  const { formatMessage, $tifelse } = useIntl32();
  if (cardDetails.length === 0) {
    return /* @__PURE__ */ React48.createElement(Box30, { as: "section" }, /* @__PURE__ */ React48.createElement(ParagraphText15, null, $tifelse(
      hasDependents,
      "POLICY_INFORMATION_UNAVAILABLE_DEPENDENTS",
      "POLICY_INFORMATION_UNAVAILABLE"
    )));
  }
  const validCardDetails = cardDetails.filter((card) => !!card.value);
  return /* @__PURE__ */ React48.createElement(StackLayout19, { as: "table", spacing: "$one", css: { borderCollapse: "separate" } }, /* @__PURE__ */ React48.createElement(Box30, { as: "caption" }, /* @__PURE__ */ React48.createElement(
    SectionHeader6,
    {
      headingLevel: "2",
      title: formatMessage({ id: "FOR_PROVIDERS_AND_PHARMACISTS" }),
      css: { textAlign: "start" }
    }
  )), /* @__PURE__ */ React48.createElement(Box30, { as: "tbody" }, validCardDetails.map((card) => /* @__PURE__ */ React48.createElement(Box30, { as: "tr", key: card.key }, /* @__PURE__ */ React48.createElement(
    ParagraphText15,
    {
      as: "th",
      emphasis: "subtle",
      scope: "row",
      css: {
        paddingTop: "$half",
        paddingBottom: "$half",
        textAlign: "start",
        minWidth: "150px",
        paddingInlineEnd: "$half"
      }
    },
    card.key,
    ":"
  ), /* @__PURE__ */ React48.createElement(
    ParagraphText15,
    {
      as: "td",
      css: {
        fontWeight: "bold",
        paddingTop: "$half",
        paddingBottom: "$half"
      }
    },
    card.value
  )))));
};

// src/pages/wallet-detail/components/member-dropdown/member-dropdown.component.tsx
import { Select as Select2, FormField as FormField2 } from "@leagueplatform/genesis-core";
import * as React50 from "react";
import { useIntl as useIntl33 } from "@leagueplatform/locales";

// src/pages/wallet-detail/components/plan-progress/hooks/use-member-dropdown.hook.ts
import * as React49 from "react";
import { useFeatureFlagQuery as useFeatureFlagQuery5 } from "@leagueplatform/user-profile-api";
import { EVENT_NAME as EVENT_NAME10 } from "@leagueplatform/analytics";
var PRIMARY_USER2 = "primary";
var DEPENDENT_USER2 = "dependent";
function selectMemberOptions2(data) {
  var _a, _b;
  const primaryUserOption = {
    label: `${data.member_first_name} ${data.member_last_name}`,
    value: "primary"
  };
  const dependentOptions = (_b = (_a = data.dependents) == null ? void 0 : _a.sort((a, b) => a.first_name.localeCompare(b.first_name)).map((dependent) => ({
    label: `${dependent.first_name} ${dependent.last_name}`,
    value: dependent.dependent_id
  }))) != null ? _b : [];
  return [primaryUserOption, ...dependentOptions];
}
function useMemberDropdown() {
  const { userId, benefitId } = useWalletParams();
  const sendBenefitAnalyticsEvent = useWalletDetailAnalytics();
  const { data: isDropdownEnabled } = useFeatureFlagQuery5(
    WALLET_API_FEATURE_FLAGS.IS_DEPENDENTS_DROPDOWN_ENABLED
  );
  const { data: memberOptions = [] } = useWalletDetailQuery(
    userId,
    benefitId,
    void 0,
    {
      select: selectMemberOptions2
    }
  );
  const hasMemberOptions = memberOptions.length > 1;
  const showMemberSelect = isDropdownEnabled && hasMemberOptions;
  const primaryUserId = userId != null ? userId : PRIMARY_USER2;
  const onMemberChange = React49.useCallback(
    (value) => {
      sendBenefitAnalyticsEvent(EVENT_NAME10.BUTTON_CLICKED, {
        detail: `select ${value !== primaryUserId ? DEPENDENT_USER2 : PRIMARY_USER2}`
      });
    },
    [primaryUserId, sendBenefitAnalyticsEvent]
  );
  return {
    showMemberSelect,
    memberOptions,
    onMemberChange
  };
}

// src/pages/wallet-detail/components/member-dropdown/member-dropdown.component.tsx
var MEMBER_SELECT_ID = "member-select";
var MemberDropDown = () => {
  var _a;
  const { userId } = useWalletParams();
  const { formatMessage } = useIntl33();
  const { memberOptions: options, onMemberChange } = useMemberDropdown();
  const [member, setMember] = useSelectedMember();
  const primaryUserId = options[0].value === "primary" ? userId : "";
  React50.useEffect(() => {
    setMember({ id: primaryUserId, name: options[0].label });
  }, [options, primaryUserId, setMember]);
  const handleChange = ({ value, label }) => {
    if (value === "primary") {
      setMember({ id: primaryUserId, name: label });
      return;
    }
    setMember({ id: value, name: label });
  };
  return /* @__PURE__ */ React50.createElement(
    FormField2,
    {
      id: "member-select",
      label: formatMessage({ id: "MEMBER_LABEL" }),
      name: MEMBER_SELECT_ID
    },
    /* @__PURE__ */ React50.createElement(
      Select2,
      {
        id: MEMBER_SELECT_ID,
        onChange: (evt) => {
          var _a2;
          evt.preventDefault();
          const { currentTarget } = evt;
          const { value } = currentTarget;
          const label = (_a2 = options.find((option) => option.value === value)) == null ? void 0 : _a2.label;
          handleChange({ value, label: label != null ? label : "" });
          onMemberChange(value);
        },
        value: (_a = member == null ? void 0 : member.id) != null ? _a : options[0].value,
        options
      }
    )
  );
};

// src/pages/wallet-detail/components/content-panel/components/card-details/card-details.component.tsx
var SidebarLayout3 = genesisStyled14(Flex16)(
  css13({
    gap: "two",
    flexWrap: "wrap",
    "& > :first-child": {
      flexBasis: 0,
      flexGrow: 999,
      minInlineSize: "50%"
    },
    "& > :last-child": {
      flexGrow: 1
    }
  })
);
var CardDetails = () => {
  const { cardDetails, showMemberSelect, isLoading } = useMemberCard();
  const { isMedicalCardEnabled } = useMedicalCard();
  const showBenefitCard = !isLoading && isMedicalCardEnabled && cardDetails.length !== 0;
  return /* @__PURE__ */ React51.createElement(SidebarLayout3, null, /* @__PURE__ */ React51.createElement(StackLayout20, { space: "$oneAndHalf" }, showMemberSelect && /* @__PURE__ */ React51.createElement(MemberDropDown, null), isLoading && /* @__PURE__ */ React51.createElement(LoadingIndicator5, { inline: true }), !isLoading && /* @__PURE__ */ React51.createElement(
    CardDetailsTable,
    {
      cardDetails,
      hasDependents: showMemberSelect
    }
  )), showBenefitCard && /* @__PURE__ */ React51.createElement(Box31, { maxWidth: 320, marginX: "auto" }, /* @__PURE__ */ React51.createElement(WalletCard, null)));
};

// src/pages/wallet-detail/components/content-panel/components/league-credit/league-credit.component.tsx
import React52, { useState as useState7 } from "react";
import { useConfigProperty as useConfigProperty6 } from "@leagueplatform/core";
import { useIntl as useIntl34 } from "@leagueplatform/locales";
import { FontAwesomeIcon } from "@leagueplatform/ui-kit";
import {
  SubtleLink,
  Box as Box32,
  Flex as Flex17,
  PrimaryButton as PrimaryButton4,
  TextInput as TextInput3
} from "@leagueplatform/genesis-commons";
import {
  VisuallyHidden as VisuallyHidden4,
  HeadingText as HeadingText16,
  UtilityText as UtilityText3,
  ParagraphText as ParagraphText16
} from "@leagueplatform/genesis-core";

// src/hooks/queries/use-user-settings-query.hook.ts
import {
  getUserSettings,
  GET_USER_SETTINGS_MESSAGE_TYPE
} from "@leagueplatform/user-profile-api";
import { useQuery as useQuery9 } from "@tanstack/react-query";
function useUserSettingsQuery(select) {
  const { userId } = useWalletParams();
  return useQuery9(
    [GET_USER_SETTINGS_MESSAGE_TYPE, userId],
    () => getUserSettings(userId),
    {
      select
    }
  );
}

// src/pages/wallet-detail/components/content-panel/components/league-credit/hooks/use-league-credit.hook.ts
import { useCallback as useCallback10 } from "react";

// src/pages/wallet-detail/components/content-panel/components/league-credit/hooks/queries/use-user-store-credit-balance-query.hook.ts
import {
  getUserStoreCreditBalance,
  GET_USER_STORE_CREDIT_BALANCE_MESSAGE_TYPE
} from "@leagueplatform/user-profile-api";
import { useQuery as useQuery10 } from "@tanstack/react-query";
function useUserStoreCreditBalanceQuery(select) {
  const { userId } = useWalletParams();
  return useQuery10(
    [GET_USER_STORE_CREDIT_BALANCE_MESSAGE_TYPE, userId],
    () => getUserStoreCreditBalance(userId),
    {
      select
    }
  );
}

// src/pages/wallet-detail/components/content-panel/components/league-credit/hooks/queries/use-redeem-promo-code-mutation.hook.ts
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
import { toastActions as toastActions2, TOAST_STATUS as TOAST_STATUS2 } from "@leagueplatform/toast-messages";
import { captureError as captureError2 } from "@leagueplatform/observability";
import { useMutation as useMutation3 } from "@tanstack/react-query";
var REDEEM_PROMO_CODE_MESSAGE_TYPE = "redeem_promo_code";
function redeemPromoCode({ code }) {
  return SocketAsFetch.fetch({
    message_type: REDEEM_PROMO_CODE_MESSAGE_TYPE,
    info: {
      code
    }
  });
}
function useRedeemPromoCodeMutation() {
  return useMutation3(redeemPromoCode, {
    onError: (err, variables) => {
      toastActions2.add({
        type: TOAST_STATUS2.ERROR,
        textId: "PROMO_CODE_NOT_FOUND"
      });
      captureError2(err, {
        context: {
          params: {
            promoCode: variables.code
          }
        }
      });
    },
    onSuccess: () => {
      toastActions2.add({
        type: TOAST_STATUS2.SUCCESS,
        textId: "PROMO_CODE_SUCCESS"
      });
    }
  });
}

// src/pages/wallet-detail/components/content-panel/components/league-credit/hooks/use-learn-more-url-query.hook.ts
import { isKPMG as getIsKPMG } from "@leagueplatform/web-common";

// src/pages/wallet-detail/components/content-panel/components/league-credit/utils/get-learn-more-url.util.ts
import {
  isFrench as isFrenchFn,
  DEFAULT_LOCALE
} from "@leagueplatform/locales";
import { UNITED_STATES } from "@leagueplatform/web-common";
var learnMoreUrls = {
  canadaFrench: "https://help.league.com/fr/faqs/Working-version/CAN/what-is-league-credit",
  canadaEnglish: "https://help.league.com/en/faqs/Working-version/CAN/what-is-league-credit",
  usEnglish: "https://ushelp.league.com/en/faqs/Working-version/US/what-is-league-credit",
  kpmgFrench: "https://kpmghelp.league.com/s/topic/0TO1T0000002gjaWAA/league-credit?language=fr",
  kpmgEnglish: "https://kpmghelp.league.com/s/topic/0TO1T0000002gjaWAA/league-credit?language=en_US"
};
var getLearnMoreUrl = (countryCode, isKPMG) => {
  const isFrench = isFrenchFn(DEFAULT_LOCALE);
  const isAmerican = countryCode === UNITED_STATES;
  if (isAmerican) {
    return learnMoreUrls.usEnglish;
  }
  if (isKPMG) {
    return isFrench ? learnMoreUrls.kpmgFrench : learnMoreUrls.kpmgEnglish;
  }
  return isFrench ? learnMoreUrls.canadaFrench : learnMoreUrls.canadaEnglish;
};

// src/pages/wallet-detail/components/content-panel/components/league-credit/hooks/use-learn-more-url-query.hook.ts
function useLearnMoreUrlQuery(userId) {
  const { data: activeGroup } = useUserActiveGroupQuery(userId);
  return useGroupQuery(activeGroup == null ? void 0 : activeGroup.group_id, {
    select: (data) => {
      const isKPMG = getIsKPMG(data.group.name);
      return getLearnMoreUrl(data.group.country_code, isKPMG);
    }
  });
}

// src/pages/wallet-detail/components/content-panel/components/league-credit/hooks/use-league-credit.hook.ts
function selectUserStoreCreditBalanceAndRedeemedCodes(data) {
  var _a, _b;
  const redeemedCodes = (data.details || []).filter(
    (code) => code.type === "code" && code.balance > 0
  );
  return {
    balance: {
      F: (_a = data.amount) != null ? _a : 0,
      C: (_b = data.currency) != null ? _b : "CAD"
    },
    redeemedCodes
  };
}
var useLeagueCredit = () => {
  const { userId } = useWalletParams();
  const { data: learnMoreUrl } = useLearnMoreUrlQuery(userId);
  const {
    data: { balance, redeemedCodes } = {}
  } = useUserStoreCreditBalanceQuery(
    selectUserStoreCreditBalanceAndRedeemedCodes
  );
  const { data: lifemarketUrl } = useUserSettingsQuery(
    (data) => data.marketplace_url
  );
  const { mutate } = useRedeemPromoCodeMutation();
  const onSubmit = useCallback10(
    (promoCode) => mutate({ code: promoCode }),
    [mutate]
  );
  return {
    balance,
    redeemedCodes,
    lifemarketUrl,
    learnMoreUrl,
    onSubmit
  };
};

// src/pages/wallet-detail/components/content-panel/components/league-credit/league-credit.component.tsx
var TableCell = (props) => {
  const { children, color, fontWeight, textAlign } = props;
  return /* @__PURE__ */ React52.createElement(
    ParagraphText16,
    {
      as: "td",
      css: {
        color: color ? "$onSurfaceTextSubdued" : "",
        paddingTop: "$one",
        paddingBottom: "$one",
        paddingInlineStart: "$half",
        paddingInlineEnd: "$half",
        fontWeight: `${fontWeight}`,
        textAlign: `${textAlign}`
      }
    },
    children
  );
};
var LeagueCredit = () => {
  const {
    balance,
    redeemedCodes,
    lifemarketUrl,
    learnMoreUrl,
    onSubmit: handleSubmit
  } = useLeagueCredit();
  const handleLinkCallback = useConfigProperty6("core.customMethods.handleLink");
  const { formatMessage, formatMoney, formatDate } = useIntl34();
  const [promoCodeValue, setPromoCodeValue] = useState7("");
  return /* @__PURE__ */ React52.createElement(Box32, null, /* @__PURE__ */ React52.createElement(
    Flex17,
    {
      backgroundColor: "surface.background.secondary",
      borderRadius: "medium",
      paddingY: "one",
      paddingX: "oneAndHalf",
      marginBottom: "two",
      maxWidth: 756
    },
    /* @__PURE__ */ React52.createElement(
      HeadingText16,
      {
        level: "1",
        size: "xxl",
        as: "p",
        css: { fontFamily: "$bodyOne" }
      },
      /* @__PURE__ */ React52.createElement(
        UtilityText3,
        {
          as: "span",
          emphasis: "emphasized",
          size: "eyebrow",
          css: {
            width: "80px",
            marginInlineEnd: "$two",
            display: "inline-block"
          }
        },
        formatMessage({ id: "TOTAL_BALANCE" }),
        " "
      ),
      formatMoney(balance)
    )
  ), /* @__PURE__ */ React52.createElement(HeadingText16, { level: "2", size: "xl", css: { marginBottom: "$one" } }, formatMessage({ id: "ABOUT" })), lifemarketUrl && /* @__PURE__ */ React52.createElement(ParagraphText16, { emphasis: "subtle", css: { marginBottom: "$one" } }, formatMessage(
    { id: "LEAGUE_CREDIT_DESCRIPTION_1" },
    {
      lifemarketLink: /* @__PURE__ */ React52.createElement(
        SubtleLink,
        {
          fontWeight: "regular",
          href: lifemarketUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: (e) => {
            e.preventDefault();
            handleLinkCallback(lifemarketUrl);
          }
        },
        formatMessage({ id: "LIFEMARKET" })
      )
    }
  )), /* @__PURE__ */ React52.createElement(ParagraphText16, { emphasis: "subtle", css: { marginBottom: "$three" } }, formatMessage(
    { id: "LEAGUE_CREDIT_DESCRIPTION_2" },
    {
      learnMoreLink: /* @__PURE__ */ React52.createElement(
        SubtleLink,
        {
          fontWeight: "regular",
          target: "_blank",
          rel: "noopener noreferrer",
          href: learnMoreUrl
        },
        formatMessage({ id: "LEARN_MORE" }),
        /* @__PURE__ */ React52.createElement(VisuallyHidden4, null, formatMessage({ id: "ABOUT" }), formatMessage({ id: "LEAGUE_CREDIT" }))
      )
    }
  )), /* @__PURE__ */ React52.createElement(HeadingText16, { size: "xl", level: "2", css: { marginBottom: "$one" } }, formatMessage({ id: "DID_YOU_GET_A_PROMO_CODE" })), /* @__PURE__ */ React52.createElement(ParagraphText16, { emphasis: "subtle", css: { marginBottom: "$two" } }, formatMessage({ id: "DID_YOU_GET_A_PROMO_CODE_DESCRIPTION" })), /* @__PURE__ */ React52.createElement(Flex17, null, /* @__PURE__ */ React52.createElement(
    Flex17,
    {
      as: "form",
      className: "add-code-form",
      onSubmit: (evt) => {
        evt.preventDefault();
        handleSubmit(promoCodeValue);
      }
    },
    /* @__PURE__ */ React52.createElement(
      TextInput3,
      {
        "aria-label": formatMessage({ id: "PROMO_CODE" }),
        className: "promo-code-input",
        name: "promocode",
        onChange: (event) => {
          setPromoCodeValue(event.currentTarget.value);
        },
        placeholder: formatMessage({ id: "ENTER_CODE" })
      }
    ),
    /* @__PURE__ */ React52.createElement(
      PrimaryButton4,
      {
        height: "100%",
        disabled: promoCodeValue.length === 0,
        type: "submit",
        className: "submit-promo-code",
        display: "flex",
        "aria-label": formatMessage({ id: "SUBMIT" })
      },
      /* @__PURE__ */ React52.createElement(FontAwesomeIcon, { icon: "tag" })
    )
  )), /* @__PURE__ */ React52.createElement(Box32, { marginTop: "three" }, /* @__PURE__ */ React52.createElement(Box32, { width: "100%", as: "table" }, /* @__PURE__ */ React52.createElement(Box32, { as: "caption" }, /* @__PURE__ */ React52.createElement(HeadingText16, { size: "xl", level: "2", css: { textAlign: "start" } }, formatMessage({ id: "CREDIT_INFORMATION" }))), (redeemedCodes == null ? void 0 : redeemedCodes.length) > 0 ? /* @__PURE__ */ React52.createElement(
    Box32,
    {
      as: "thead",
      fontSize: "subtitle2",
      borderBottomWidth: "thin",
      borderBottomColor: "onSurface.border.subdued",
      borderBottomStyle: "solid"
    },
    /* @__PURE__ */ React52.createElement(Box32, { as: "tr" }, /* @__PURE__ */ React52.createElement(
      Box32,
      {
        as: "th",
        paddingX: "half",
        paddingY: "one",
        textAlign: "start",
        width: 1 / 2
      },
      /* @__PURE__ */ React52.createElement(
        UtilityText3,
        {
          size: "eyebrow",
          css: { color: "$onSurfaceTextPrimary" },
          as: "span"
        },
        formatMessage({ id: "EXPIRY_DATE" })
      )
    ), /* @__PURE__ */ React52.createElement(
      Box32,
      {
        as: "th",
        paddingX: "half",
        paddingY: "one",
        textAlign: "end",
        width: 1 / 2
      },
      /* @__PURE__ */ React52.createElement(
        UtilityText3,
        {
          size: "eyebrow",
          css: { color: "$onSurfaceTextPrimary" },
          as: "span"
        },
        formatMessage({ id: "AMOUNT" })
      )
    ))
  ) : null, /* @__PURE__ */ React52.createElement(
    Box32,
    {
      as: "tbody",
      borderBottomWidth: "thin",
      borderBottomColor: "onSurface.border.subdued",
      borderBottomStyle: "solid"
    },
    redeemedCodes == null ? void 0 : redeemedCodes.map((code) => /* @__PURE__ */ React52.createElement(
      Box32,
      {
        as: "tr",
        className: "redeemed-promo-code",
        key: code.promo_code_id,
        width: "100%"
      },
      /* @__PURE__ */ React52.createElement(
        TableCell,
        {
          as: "td",
          color: "onSurface.text.subdued",
          textAlign: "start"
        },
        code.expires ? formatDate(code.expires, {
          year: "numeric",
          month: "short",
          day: "numeric"
        }) : formatMessage({ id: "NO_EXPIRY_DATE" })
      ),
      /* @__PURE__ */ React52.createElement(TableCell, { textAlign: "end" }, formatMoney({
        F: code.balance,
        C: code.currency
      }))
    ))
  ), /* @__PURE__ */ React52.createElement(Box32, { as: "tfoot", width: "100%" }, /* @__PURE__ */ React52.createElement(Box32, { as: "tr" }, /* @__PURE__ */ React52.createElement(
    TableCell,
    {
      color: "onSurface.text.subdued",
      fontWeight: "bold",
      textAlign: "start"
    },
    formatMessage({ id: "TOTAL_CREDIT" })
  ), /* @__PURE__ */ React52.createElement(TableCell, { as: "td", fontWeight: "bold", textAlign: "end" }, formatMoney(balance)))))));
};

// src/pages/wallet-detail/components/medical-coverage/medical-coverage.component.tsx
import * as React56 from "react";
import { Box as Box35, StackLayout as StackLayout24 } from "@leagueplatform/genesis-core";
import { SectionHeader as SectionHeader7 } from "@leagueplatform/genesis-core-alpha";
import {
  LoadingIndicator as LoadingIndicator6,
  ErrorState as ErrorState2
} from "@leagueplatform/web-common-components";

// src/hooks/queries/use-provider-services-query.hook.ts
import { useQuery as useQuery11 } from "@tanstack/react-query";
import {
  getProviderServices,
  GET_PROVIDER_SERVICES_MESSAGE_TYPE
} from "@leagueplatform/wallet-api";
function useProviderServices(userId, benefitId, options) {
  return useQuery11(
    [GET_PROVIDER_SERVICES_MESSAGE_TYPE, userId, benefitId],
    () => getProviderServices(userId, benefitId),
    options
  );
}

// src/pages/wallet-detail/components/medical-coverage/utils/select-coverage-networks.util.ts
var NO_NETWORK_LABEL = "No-Network";
var IN_NETWORK_LABEL = "In-Network";
var OUT_OF_NETWORK_LABEL = "Out-of-Network";
var handleNetworkFormat = (networksArray) => {
  const { enableNoNetworkLiveBalances } = getWalletConfig();
  if (!enableNoNetworkLiveBalances) {
    return networksArray.map((network) => {
      var _a;
      return __spreadProps(__spreadValues({}, network), {
        services: (_a = network.services) != null ? _a : []
      });
    });
  }
  return networksArray.filter((network) => network.services !== null).map((network) => {
    var _a;
    return __spreadProps(__spreadValues({}, network), { services: (_a = network.services) != null ? _a : [] });
  });
};
function selectCoverageNetworks({
  metadata,
  provider_services: providerServices
}) {
  var _a;
  const networks = handleNetworkFormat([
    {
      analyticsId: "in network" /* IN_NETWORK */,
      label: IN_NETWORK_LABEL,
      services: providerServices == null ? void 0 : providerServices.in_network
    },
    {
      analyticsId: "out of network" /* OUT_OF_NETWORK */,
      label: OUT_OF_NETWORK_LABEL,
      services: providerServices == null ? void 0 : providerServices.out_of_network
    }
  ]);
  const noNetwork = [
    {
      analyticsId: "no network" /* NO_NETWORK */,
      label: NO_NETWORK_LABEL,
      services: (_a = providerServices == null ? void 0 : providerServices.no_network) != null ? _a : []
    }
  ];
  const isNoNetworkUser = !!providerServices.no_network;
  return {
    metadata,
    networks: isNoNetworkUser ? noNetwork : networks,
    isNoNetworkUser
  };
}

// src/pages/wallet-detail/components/medical-coverage/components/network-coverage.component.tsx
import * as React55 from "react";
import {
  PillTabs,
  PillTabList,
  PillTab
} from "@leagueplatform/web-common-components";
import { Tabs as Tabs2, Box as Box34, StackLayout as StackLayout23 } from "@leagueplatform/genesis-core";
import { EVENT_NAME as EVENT_NAME12 } from "@leagueplatform/analytics";

// src/pages/wallet-detail/components/medical-coverage/components/network-panel.component.tsx
import * as React54 from "react";
import {
  Box as Box33,
  StackLayout as StackLayout22,
  ParagraphText as ParagraphText18,
  HeadingText as HeadingText18
} from "@leagueplatform/genesis-core";
import { Accordion } from "@leagueplatform/web-common-components";
import { useIntl as useIntl35 } from "@leagueplatform/locales";
import {
  EVENT_NAME as EVENT_NAME11,
  PRODUCT_AREA as PRODUCT_AREA6,
  SCREEN_NAMES as SCREEN_NAMES5
} from "@leagueplatform/analytics";

// src/components/definition-popover/definition-popover.component.tsx
import * as React53 from "react";
import {
  HeadingText as HeadingText17,
  ParagraphText as ParagraphText17,
  Popover as Popover2
} from "@leagueplatform/genesis-core";
import { HtmlToReact as HtmlToReact3 } from "@leagueplatform/web-common";
import { StackLayout as StackLayout21 } from "@leagueplatform/web-common-components";
var DefinitionPopover = ({
  description: definition,
  title,
  triggerLabel,
  onClick
}) => /* @__PURE__ */ React53.createElement(Popover2.Root, null, /* @__PURE__ */ React53.createElement(
  Popover2.Trigger,
  {
    icon: "interfaceQuestionCircle",
    label: triggerLabel,
    size: "small",
    quiet: true,
    hideLabel: true,
    priority: "secondary",
    css: { padding: "0", border: "none", borderRadius: "$circle" },
    onClick
  }
), /* @__PURE__ */ React53.createElement(
  Popover2.Content,
  {
    side: { "@initial": "inlineEnd", "@mobile": "bottom" },
    css: { maxWidth: "320px", "&:focus": { outline: "$interactiveFocus" } },
    showCloseButton: false
  },
  /* @__PURE__ */ React53.createElement(StackLayout21, { space: "$one" }, title && /* @__PURE__ */ React53.createElement(HeadingText17, { size: "md", level: "4" }, title), /* @__PURE__ */ React53.createElement(
    HtmlToReact3,
    {
      htmlString: definition,
      options: { p: { component: ParagraphText17, props: { size: "sm" } } }
    }
  ))
));

// src/pages/wallet-detail/components/medical-coverage/components/network-panel.component.tsx
function NetworkPanel({
  services = [],
  networkName,
  onToggle
}) {
  var _a, _b;
  const { formatMessage } = useIntl35();
  const firstService = (_b = (_a = services == null ? void 0 : services[0]) == null ? void 0 : _a.service_name) == null ? void 0 : _b.replaceAll(" ", "+");
  const defaultValue = firstService ? [firstService] : [];
  const [activePanels, setActivePanels] = React54.useState(defaultValue);
  const trackAnalyticsEvent6 = useWalletDetailAnalytics();
  const handleOnToggle = React54.useCallback(
    (currentPanels) => {
      if (currentPanels.length > activePanels.length) {
        const clickedPanel2 = currentPanels[currentPanels.length - 1];
        if (onToggle) {
          onToggle(clickedPanel2.replaceAll("+", " "), "expand");
        }
        setActivePanels(currentPanels);
        return;
      }
      const [clickedPanel] = activePanels.filter(
        (x) => !currentPanels.includes(x)
      );
      if (onToggle) {
        onToggle(clickedPanel.replaceAll("+", " "), "collapse");
      }
      setActivePanels(currentPanels);
    },
    [activePanels, onToggle]
  );
  if (services === null || services.length === 0) {
    return /* @__PURE__ */ React54.createElement(ParagraphText18, { css: { typography: "$bodyOne" } }, formatMessage(
      { id: "NETWORK_MISSING_COVERAGE" },
      { network: networkName }
    ));
  }
  return /* @__PURE__ */ React54.createElement(
    Accordion.Root,
    {
      type: "multiple",
      defaultValue,
      onValueChange: handleOnToggle
    },
    services.map(({ service_name: serviceName = "", providers = [] }) => /* @__PURE__ */ React54.createElement(
      Accordion.Item,
      {
        value: serviceName.replaceAll(" ", "+"),
        key: serviceName
      },
      /* @__PURE__ */ React54.createElement(Accordion.Header, { size: "md", level: "3" }, /* @__PURE__ */ React54.createElement(Accordion.Trigger, null, serviceName)),
      /* @__PURE__ */ React54.createElement(Accordion.Content, null, /* @__PURE__ */ React54.createElement(
        StackLayout22,
        {
          spacing: "$half",
          css: {
            width: "100%"
          }
        },
        providers.map(({ title, description, definition }) => /* @__PURE__ */ React54.createElement(
          Box33,
          {
            as: "section",
            key: title,
            css: {
              backgroundColor: "$surfaceBackgroundSecondary",
              padding: "$one",
              marginInlineStart: "$oneAndHalf",
              width: "calc(100% - $oneAndHalf)"
            }
          },
          /* @__PURE__ */ React54.createElement(
            Box33,
            {
              css: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }
            },
            /* @__PURE__ */ React54.createElement("div", null, /* @__PURE__ */ React54.createElement(
              HeadingText18,
              {
                level: "4",
                size: "md",
                css: { typography: "$subtitleTwo" }
              },
              title
            ), /* @__PURE__ */ React54.createElement(ParagraphText18, { css: { typography: "$bodyTwo" } }, description)),
            (definition == null ? void 0 : definition.description) && /* @__PURE__ */ React54.createElement(
              DefinitionPopover,
              {
                description: definition.description,
                triggerLabel: formatMessage({
                  id: "PROVIDER_SERVICE_POPOVER_BUTTON_NAME"
                }),
                onClick: () => {
                  trackAnalyticsEvent6(EVENT_NAME11.BUTTON_CLICKED, {
                    screen_name: SCREEN_NAMES5.BENEFIT_PAGE,
                    product_area: PRODUCT_AREA6.WALLET,
                    detail: "clicked on tooltip for more info",
                    sub_detail: `Tooltip for ${serviceName} - ${title}`
                  });
                }
              }
            )
          )
        ))
      ))
    ))
  );
}

// src/pages/wallet-detail/components/medical-coverage/components/network-coverage.component.tsx
var NetworksCoverage = ({ networks }) => {
  const sendBenefitAnalyticsEvent = useWalletDetailAnalytics({
    screen_name: "coverage summary" /* COVERAGE_SUMMARY */
  });
  const { enableNoNetworkLiveBalances } = useWalletConfig();
  const onTabClickEvent = React55.useCallback(
    (index) => {
      const tabName = networks[index].analyticsId;
      sendBenefitAnalyticsEvent(EVENT_NAME12.NAVIGATION_TAB_CLICKED, {
        detail: tabName
      });
    },
    [sendBenefitAnalyticsEvent, networks]
  );
  const onAccordionToggleEvent = React55.useCallback(
    (serviceName, state2) => {
      sendBenefitAnalyticsEvent(EVENT_NAME12.BUTTON_CLICKED, {
        detail: `toggle ${serviceName} accordion`,
        sub_detail: state2
      });
    },
    [sendBenefitAnalyticsEvent]
  );
  if (!networks.length) {
    return null;
  }
  if (networks.length === 1 && enableNoNetworkLiveBalances) {
    return /* @__PURE__ */ React55.createElement(
      StackLayout23,
      {
        spacing: "$oneAndHalf",
        horizontalAlignment: "stretch",
        css: { width: "100%" }
      },
      networks.map((network) => /* @__PURE__ */ React55.createElement(
        NetworkPanel,
        {
          key: `network-panel-${network.analyticsId}`,
          services: network.services,
          networkName: network.label,
          onToggle: onAccordionToggleEvent
        }
      ))
    );
  }
  return /* @__PURE__ */ React55.createElement(
    PillTabs,
    {
      onValueChange: (value) => onTabClickEvent(
        networks.findIndex((network) => network.label === value)
      ),
      defaultValue: networks[0].label
    },
    /* @__PURE__ */ React55.createElement(StackLayout23, { spacing: "$oneAndHalf" }, /* @__PURE__ */ React55.createElement(Box34, { css: { width: "fit-content" } }, /* @__PURE__ */ React55.createElement(PillTabList, null, networks.map((network) => /* @__PURE__ */ React55.createElement(PillTab, { key: `pill-tab-${network.label}`, value: network.label }, network.label)))), networks.map((network) => /* @__PURE__ */ React55.createElement(
      Tabs2.TabPanel,
      {
        key: `tab-panel-${network.label}`,
        value: network.label,
        css: { width: "100%", padding: "$none" }
      },
      /* @__PURE__ */ React55.createElement(
        NetworkPanel,
        {
          services: network.services,
          networkName: network.label,
          onToggle: onAccordionToggleEvent
        }
      )
    )))
  );
};
var NoNetworkCoverage = ({
  services: { services }
}) => {
  const sendBenefitAnalyticsEvent = useWalletDetailAnalytics({
    screen_name: "coverage summary" /* COVERAGE_SUMMARY */
  });
  const onAccordionToggleEvent = React55.useCallback(
    (serviceName, state2) => {
      sendBenefitAnalyticsEvent(EVENT_NAME12.BUTTON_CLICKED, {
        detail: `toggle ${serviceName} accordion`,
        sub_detail: state2
      });
    },
    [sendBenefitAnalyticsEvent]
  );
  return /* @__PURE__ */ React55.createElement(Box34, { css: { width: "100%" } }, /* @__PURE__ */ React55.createElement(NetworkPanel, { services, onToggle: onAccordionToggleEvent }));
};

// src/pages/wallet-detail/components/medical-coverage/medical-coverage.component.tsx
function MedicalCoverage() {
  const { userId, benefitId } = useWalletParams();
  const { data, isLoading, isError, refetch, error } = useProviderServices(
    userId,
    benefitId,
    {
      select: selectCoverageNetworks
    }
  );
  useWalletDetailScreenLoaded("coverage summary" /* COVERAGE_SUMMARY */);
  if (isLoading) {
    return /* @__PURE__ */ React56.createElement(LoadingIndicator6, { inline: true });
  }
  if (isError || !data) {
    return /* @__PURE__ */ React56.createElement(
      Box35,
      {
        as: "section",
        css: {
          backgroundColor: "$surfaceBackgroundTertiary",
          padding: "$one",
          minHeight: "286px",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%"
        }
      },
      /* @__PURE__ */ React56.createElement(ErrorState2, { error, hideImage: true, onButtonClick: refetch })
    );
  }
  const { metadata, networks, isNoNetworkUser } = data;
  const hasNetworks = networks.length > 0;
  return /* @__PURE__ */ React56.createElement(StackLayout24, { as: "section", spacing: "$oneAndHalf", css: { width: "100%" } }, /* @__PURE__ */ React56.createElement(StackLayout24, { spacing: "$one", css: { width: "100%" } }, metadata.title && /* @__PURE__ */ React56.createElement(
    SectionHeader7,
    {
      headingLevel: "2",
      title: metadata.title,
      subtitle: metadata.description
    }
  )), !isNoNetworkUser && hasNetworks && /* @__PURE__ */ React56.createElement(NetworksCoverage, { networks }), isNoNetworkUser && hasNetworks && /* @__PURE__ */ React56.createElement(NoNetworkCoverage, { services: networks[0] }), !hasNetworks && /* @__PURE__ */ React56.createElement(Box35, { css: { width: "100%" } }, /* @__PURE__ */ React56.createElement(ErrorState2, { error, hideImage: true, onButtonClick: refetch })));
}

// src/pages/wallet-detail/components/content-panel/components/overview/overview.component.tsx
import React58 from "react";
import { SectionHeader as SectionHeader8 } from "@leagueplatform/genesis-core-alpha";
import { Box as Box36 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl37 } from "@leagueplatform/locales";

// src/pages/wallet-detail/components/content-panel/components/overview/components/spending-balance.component.tsx
import React57 from "react";
import { useIntl as useIntl36 } from "@leagueplatform/locales";
import {
  HeadingText as HeadingText19,
  ParagraphText as ParagraphText19,
  UtilityText as UtilityText4
} from "@leagueplatform/genesis-core";
import { Flex as Flex18, genesisStyled as genesisStyled15, css as css14 } from "@leagueplatform/genesis-commons";
import {
  GenesisRouterLink as GenesisRouterLink2,
  StackLayout as StackLayout25
} from "@leagueplatform/web-common-components";

// src/common/spending-accounts.ts
var HSA = "league_spending_hsa";
var LSA = "league_spending_lsa";

// src/pages/wallet-detail/components/content-panel/components/overview/utils/is-type-hsa-or-lsa.util.ts
var isTypeHsaOrLsa = (cardType) => cardType === LSA || cardType === HSA;

// src/pages/wallet-detail/components/content-panel/components/overview/components/spending-balance.component.tsx
var splitAfterCommaRegEx = /\s/;
var ShowDependentsContainer = genesisStyled15(Flex18)(
  css14({
    justifyContent: "space-between",
    alignItems: "center",
    flexGrow: 1
  })
);
var StyledUtilityText = genesisStyled15(UtilityText4)(
  css14({
    whiteSpace: "nowrap",
    color: "onSurface.text.subdued"
  })
);
var DEPENDENTS_HEADING_ID = "dependent-list-heading";
var EDIT_DEPENDENTS_LINK_ID = "dependent-edit-id";
var SpendingAccountBalance = ({
  spendingAccount,
  cardType,
  dependents,
  canEditDependents
}) => {
  const { formatMoney, formatMessage } = useIntl36();
  const isLsaOrHsa = isTypeHsaOrLsa(cardType);
  const showDependents = isLsaOrHsa && dependents;
  const showSpendingAccount = !!spendingAccount;
  const dependentsList = dependents == null ? void 0 : dependents.map((d) => d.first_name).join(", ").split(splitAfterCommaRegEx);
  return /* @__PURE__ */ React57.createElement(
    Flex18,
    {
      backgroundColor: "surface.background.secondary",
      borderRadius: "medium",
      paddingY: "one",
      paddingX: { tablet: "none", _: "two" },
      marginBottom: "two",
      alignContent: "center",
      flexDirection: { tablet: "row", _: "column" },
      justifyContent: "center"
    },
    showDependents && /* @__PURE__ */ React57.createElement(
      ShowDependentsContainer,
      {
        paddingX: { tablet: "two", _: "none" },
        paddingY: { tablet: "none", _: "one" },
        borderStyle: !showSpendingAccount && "none",
        borderColor: "onSurface.border.subdued",
        borderWidth: "thin",
        borderInlineEndStyle: {
          tablet: showSpendingAccount ? "solid" : "none"
        },
        borderBottomStyle: {
          tablet: "none",
          _: "solid"
        }
      },
      /* @__PURE__ */ React57.createElement(StackLayout25, { space: "$half" }, /* @__PURE__ */ React57.createElement(
        StyledUtilityText,
        {
          as: "h3",
          emphasis: "emphasized",
          size: "eyebrow",
          id: DEPENDENTS_HEADING_ID
        },
        formatMessage({ id: "DEPENDENTS" })
      ), /* @__PURE__ */ React57.createElement(Flex18, { as: "ul", flexWrap: "wrap", role: "list" }, dependentsList == null ? void 0 : dependentsList.map((dependentFirstName) => /* @__PURE__ */ React57.createElement(ParagraphText19, { as: "li" }, dependentFirstName, "\xA0")))),
      canEditDependents && /* @__PURE__ */ React57.createElement(
        Flex18,
        {
          alignItems: "center",
          "aria-labelledby": `${EDIT_DEPENDENTS_LINK_ID} ${DEPENDENTS_HEADING_ID}`,
          as: GenesisRouterLink2,
          display: "flex",
          fontSize: "subtitle2",
          gap: "half",
          id: EDIT_DEPENDENTS_LINK_ID,
          padding: "threeQuarters",
          to: "/member/wallet/dependents"
        },
        formatMessage({ id: "EDIT" })
      )
    ),
    showSpendingAccount && /* @__PURE__ */ React57.createElement(
      Flex18,
      {
        justifyContent: {
          tablet: "center",
          _: showDependents ? "start" : "center"
        },
        alignItems: "center",
        paddingX: { tablet: "oneAndHalf", _: "none" },
        paddingTop: { tablet: "half" },
        paddingY: { tablet: "none", _: "one" }
      },
      /* @__PURE__ */ React57.createElement(
        StackLayout25,
        {
          space: "$half",
          css: { textAlign: showDependents ? "start" : "center" }
        },
        /* @__PURE__ */ React57.createElement(StyledUtilityText, { emphasis: "emphasized", size: "eyebrow" }, formatMessage({ id: "REMAINING_BALANCE" })),
        /* @__PURE__ */ React57.createElement(
          HeadingText19,
          {
            size: "lg",
            level: "3",
            as: "span",
            css: { marginTop: "$none !important" }
          },
          formatMoney(spendingAccount.balance)
        )
      )
    )
  );
};

// src/pages/wallet-detail/components/content-panel/components/overview/hooks/use-overview.hook.ts
import { useFeatureFlagQuery as useFeatureFlagQuery6 } from "@leagueplatform/user-profile-api";
import { SYSTEM_TYPES as SYSTEM_TYPES4 } from "@leagueplatform/wallet-api";
var useOverview = () => {
  var _a, _b, _c, _d, _e, _f;
  const { userId, benefitId } = useWalletParams();
  const showDependentsMenuItemQuery = useUserSettingsQuery(
    (data) => data.show_dependents_menu_item
  );
  const { data: hideSpendingAccountBalanceBanner } = useFeatureFlagQuery6(
    WALLET_API_FEATURE_FLAGS.IS_SPENDING_ACCOUNT_BALANCE_BANNER_HIDDEN
  );
  const canEditDependents = !!showDependentsMenuItemQuery.data;
  const benefitQuery = useWalletDetailQuery(userId, benefitId);
  const dependents = (_a = benefitQuery.data) == null ? void 0 : _a.dependents;
  const spendingAccount = (_b = benefitQuery.data) == null ? void 0 : _b.spending_account;
  const cardType = (_c = benefitQuery.data) == null ? void 0 : _c.type;
  const overviewBody = (_f = (_e = (_d = benefitQuery.data) == null ? void 0 : _d.content_actions) == null ? void 0 : _e.find(
    (action) => action.system_type === SYSTEM_TYPES4.CoverageOverview
  )) == null ? void 0 : _f.body;
  const showSpendingAccountBalanceBanner = spendingAccount && !hideSpendingAccountBalanceBanner;
  return {
    canEditDependents,
    cardType,
    dependents,
    spendingAccount,
    showSpendingAccountBalanceBanner,
    body: overviewBody
  };
};

// src/pages/wallet-detail/components/content-panel/components/overview/overview.component.tsx
var Overview = () => {
  const { formatMessage } = useIntl37();
  const {
    canEditDependents,
    cardType,
    dependents,
    spendingAccount,
    showSpendingAccountBalanceBanner,
    body
  } = useOverview();
  if (!body) {
    return /* @__PURE__ */ React58.createElement(
      SectionHeader8,
      {
        title: formatMessage({ id: "ABOUT_THIS_BENEFIT" }),
        headingLevel: "2",
        css: { marginBlockEnd: "$one" },
        subtitle: formatMessage({ id: "ABOUT_THIS_BENEFIT_DESCRIPTION" })
      }
    );
  }
  return /* @__PURE__ */ React58.createElement(Box36, null, showSpendingAccountBalanceBanner && /* @__PURE__ */ React58.createElement(
    SpendingAccountBalance,
    {
      spendingAccount,
      cardType,
      dependents,
      canEditDependents
    }
  ), /* @__PURE__ */ React58.createElement(CardBody, { body }));
};

// src/pages/wallet-detail/components/content-panel/components/transactions/transactions.component.tsx
import React60 from "react";
import { useIntl as useIntl39 } from "@leagueplatform/locales";
import { LoadingIndicator as LoadingIndicator7 } from "@leagueplatform/web-common-components";
import {
  BodyTwoSecondary,
  Box as Box38,
  genesisStyled as genesisStyled17,
  Overline,
  SecondaryButton as SecondaryButton2,
  VisuallyHidden as VisuallyHidden6,
  css as css15
} from "@leagueplatform/genesis-commons";

// src/pages/wallet-detail/components/content-panel/components/transactions/components/transaction.component.tsx
import React59 from "react";
import { useIntl as useIntl38 } from "@leagueplatform/locales";
import { useNavigateLegacy as useNavigate2 } from "@leagueplatform/routing";
import {
  Box as Box37,
  BodyTwo as BodyTwo2,
  Link as Link5,
  genesisStyled as genesisStyled16,
  VisuallyHidden as VisuallyHidden5
} from "@leagueplatform/genesis-commons";
import { Icon as Icon10 } from "@leagueplatform/genesis-core";
import { useConfigProperty as useConfigProperty7 } from "@leagueplatform/core";
var TableCell2 = (props) => /* @__PURE__ */ React59.createElement(
  BodyTwo2,
  __spreadValues({
    as: "td",
    paddingY: "one",
    paddingX: "quarter",
    verticalAlign: "middle",
    borderBottomColor: "onSurface.border.subdued",
    borderBottomStyle: "solid",
    borderBottomWidth: "thin"
  }, props)
);
var StyledTableCell = genesisStyled16(TableCell2)`
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
`;
var Transaction = ({
  transaction: {
    date,
    title,
    amount,
    amountType,
    currency,
    invoiceId,
    claimId,
    referenceId,
    paymentId,
    type,
    accountsList,
    isLifemarketTransaction
  },
  lifemarketUrl
}) => {
  const { formatMessage, $tmap, formatDate, formatNumber } = useIntl38();
  const navigate = useNavigate2();
  const typeMessage = $tmap({
    CLAIM: "CLAIM",
    LIFEMARKET: "LIFEMARKET",
    ALLOCATION: "ALLOCATION",
    TOP_UP: "TOP_UP",
    REFUND: "REFUND",
    ADJUSTMENT: "ADJUSTMENT",
    ROLLED_OVER: "ROLLED_OVER"
  });
  const accountMessageMap = $tmap({
    LSA: "LSA",
    HSA: "HSA",
    CREDIT_CARD: "CREDIT_CARD",
    LEAGUE_CREDIT: "LEAGUE_CREDIT",
    CGA: "CGA",
    HRA: "HRA"
  });
  const getLinkDescriptionText = () => {
    if (isLifemarketTransaction) {
      return formatMessage({ id: "GO_TO_LIFEMARKET" }, { invoiceId });
    }
    if (claimId) {
      return formatMessage({ id: "GO_TO_CLAIM" }, { title });
    }
    if (paymentId) {
      return formatMessage({ id: "GO_TO_RECEIPT" }, { title });
    }
    return "";
  };
  const isCredit = amountType === "credit";
  const isLink = isLifemarketTransaction || claimId || paymentId;
  const handleLinkCallback = useConfigProperty7("core.customMethods.handleLink");
  const handleLinkClick = () => {
    if (isLifemarketTransaction) {
      handleLinkCallback(`${lifemarketUrl}account/orders`);
    } else if (claimId) {
      navigate(`/member/claims/${claimId}?source=wallet`);
    } else if (paymentId) {
      navigate(`/member/receipt/${paymentId}`);
    }
  };
  return /* @__PURE__ */ React59.createElement(Box37, { as: "tr" }, /* @__PURE__ */ React59.createElement(TableCell2, { minWidth: 100 }, formatDate(date, {
    year: "numeric",
    month: "short",
    day: "numeric"
  })), /* @__PURE__ */ React59.createElement(StyledTableCell, { maxWidth: 120, title: referenceId || invoiceId }, referenceId || invoiceId), /* @__PURE__ */ React59.createElement(TableCell2, { fontWeight: "bold" }, title), /* @__PURE__ */ React59.createElement(TableCell2, null, typeMessage(type), accountsList && /* @__PURE__ */ React59.createElement(BodyTwo2, null, "(", accountsList.map((account) => accountMessageMap(account)).join(", "), ")")), /* @__PURE__ */ React59.createElement(
    TableCell2,
    {
      minWidth: 100,
      textAlign: "end",
      fontWeight: "bold",
      color: isCredit ? "decorative.brand.primary.dark" : "onSurface.text.primary"
    },
    amount && /* @__PURE__ */ React59.createElement(React59.Fragment, null, formatNumber(isCredit ? amount : -amount, {
      style: "currency",
      currencyDisplay: "symbol",
      currency,
      minimumFractionDigits: 2
    }))
  ), /* @__PURE__ */ React59.createElement(TableCell2, { minWidth: 30 }, isLink && // eslint-disable-next-line jsx-a11y/anchor-is-valid -- TODO: use button instead?
  /* @__PURE__ */ React59.createElement(
    Link5,
    {
      href: "#",
      display: "block",
      textAlign: "end",
      onClick: handleLinkClick
    },
    /* @__PURE__ */ React59.createElement(VisuallyHidden5, null, getLinkDescriptionText()),
    /* @__PURE__ */ React59.createElement(Icon10, { icon: "interfaceChevronForward", size: "$one" })
  )));
};

// src/pages/wallet-detail/components/content-panel/components/transactions/hooks/queries/use-transactions-query.hook.ts
import { useLeagueInfiniteWSQuery } from "@leagueplatform/api";
import { normalizePolicyKind } from "@leagueplatform/web-common";
import { useEffect as useEffect5 } from "react";

// src/pages/wallet-detail/components/content-panel/components/transactions/utils/get-payment-data-from-pricing-details.util.js
var paymentTypeMap = {
  psa_total: "LSA",
  hsa_total: "HSA",
  amount_owing: "CREDIT_CARD",
  personal_promo_code_total: "LEAGUE_CREDIT",
  charity: "CGA",
  psa: "LSA",
  lsa: "LSA",
  hsa: "HSA",
  hra: "HRA"
};
var accountTotalTypes = [
  "psa_total",
  "hsa_total",
  "charity",
  "psa",
  "hsa",
  "personal_promo_code_total",
  "amount_owing"
];
var getPaymentDataFromPricingDetails = (details, accountType) => {
  const typesUsed = Object.keys(details).filter(
    (type) => accountTotalTypes.includes(type) && details[type] > 0
  );
  const benefitsUsed = (details.benefits || []).filter((benefit) => accountTotalTypes.includes(benefit.payment_type)).map((benefit) => benefit.payment_type);
  const accountsUsed = new Set(
    [...typesUsed, ...benefitsUsed].map((account) => paymentTypeMap[account])
  );
  const isBenefitAccount = accountType !== "promo_code" && accountType !== "credit_card";
  let amount;
  if (Array.isArray(details.benefits) && details.benefits.length > 0 && isBenefitAccount) {
    const benefitAccount = details.benefits.find(
      (benefit) => benefit.payment_type === accountType
    );
    amount = benefitAccount ? benefitAccount.amount : null;
  } else {
    switch (accountType) {
      case "psa":
        amount = details.psa_total;
        break;
      case "hsa":
        amount = details.hsa_total;
        break;
      case "league_credit":
      case "promo_code":
        amount = details.personal_promo_code_total;
        break;
      case "credit_card":
        amount = details.amount_owing;
        break;
      default:
        break;
    }
  }
  return {
    amount,
    accountsUsed: accountsUsed.size > 1 ? [...accountsUsed] : null
  };
};

// src/pages/wallet-detail/components/content-panel/components/transactions/utils/map-history-to-transactions.util.ts
var mapHistoryToTransactions = (items = [], type) => items.map((item) => {
  var _a, _b, _c;
  const {
    claim,
    payment,
    credit,
    marketplace_transaction: lifemarketTransaction
  } = item;
  if (payment) {
    const paymentData = getPaymentDataFromPricingDetails(
      payment.pricing_details,
      type
    );
    return {
      type: "LIFEMARKET",
      date: payment.created_timestamp,
      paymentId: payment.service_id,
      invoiceId: payment.invoice_id,
      key: payment.payment_id,
      amount: paymentData.amount,
      amountType: "debit",
      currency: payment.pricing_details.currency,
      status: payment.payment_status,
      service: payment.service_details,
      title: (_a = payment.service_details) == null ? void 0 : _a.title,
      accountsList: paymentData.accountsUsed
    };
  }
  if (claim) {
    const { policy_allocations, amount_approved } = claim;
    const accountsList = (_b = policy_allocations == null ? void 0 : policy_allocations.map((allocation) => {
      if (allocation.type === "psa")
        return "LSA";
      return allocation.type.toUpperCase();
    })) != null ? _b : null;
    const policyAllocation = policy_allocations == null ? void 0 : policy_allocations.find(
      (allocation) => allocation.type === type
    );
    const getAmount = () => {
      if (policyAllocation)
        return policyAllocation.amount_approved.value;
      if (amount_approved)
        return amount_approved.value;
      return null;
    };
    return {
      type: "CLAIM",
      claimId: claim.claim_id,
      key: claim.claim_id,
      referenceId: claim.reference_id,
      status: claim.status,
      date: claim.date_created,
      title: claim.vendor,
      amount: getAmount(),
      amountType: "debit",
      currency: (_c = amount_approved == null ? void 0 : amount_approved.currency) != null ? _c : null,
      accountsList: (accountsList == null ? void 0 : accountsList.length) > 1 ? accountsList : null
    };
  }
  if (credit) {
    let creditType = credit.type;
    if (!creditType && creditType === "") {
      creditType = "credit";
    }
    return {
      type: creditType.toUpperCase(),
      date: credit.timestamp,
      description: credit.description,
      currency: credit.currency,
      amount: credit.amount,
      key: credit.timestamp,
      amountType: "credit"
    };
  }
  if (lifemarketTransaction) {
    const isCredit = lifemarketTransaction.amount > 0;
    return {
      type: lifemarketTransaction.type.toUpperCase(),
      date: lifemarketTransaction.timestamp,
      title: lifemarketTransaction.description,
      invoiceId: lifemarketTransaction.id,
      key: lifemarketTransaction.id,
      amount: isCredit ? lifemarketTransaction.amount : lifemarketTransaction.amount * -1,
      amountType: isCredit ? "credit" : "debit",
      currency: lifemarketTransaction.currency,
      isLifemarketTransaction: true
    };
  }
  return null;
});

// src/pages/wallet-detail/components/content-panel/components/transactions/hooks/queries/use-transactions-query.hook.ts
function useTransactionsQuery({
  productType,
  limit = 50
}) {
  var _a, _b;
  const { userId } = useWalletParams();
  const message_type = "get_purchase_and_claim_history";
  const normalizedProductType = normalizePolicyKind(productType);
  const info = {
    user_id: userId,
    payment_types: [normalizedProductType],
    limit,
    also_include: ["free_purchase", "credits"],
    version: 2
  };
  const query = useLeagueInfiniteWSQuery(
    [message_type, userId, normalizedProductType],
    {
      message_type,
      info,
      responseKey: "history",
      offsetParam: "skip"
    },
    {
      enabled: !!productType
    }
  );
  useEffect5(
    () => (
      // remove query data from cache on unmount
      query.remove
    ),
    [query.remove]
  );
  const flattenedData = (_b = (_a = query.data) == null ? void 0 : _a.pages) == null ? void 0 : _b.flat();
  const data = flattenedData ? mapHistoryToTransactions(flattenedData, normalizedProductType) : null;
  return __spreadProps(__spreadValues({}, query), { data });
}

// src/pages/wallet-detail/components/content-panel/components/transactions/hooks/use-transactions.hook.ts
var useTransactions = () => {
  const { userId, benefitId } = useWalletParams();
  const productTypeQuery = useWalletDetailQuery(userId, benefitId, void 0, {
    select: (data2) => data2.product_type
  });
  const productType = productTypeQuery.data;
  const { data: lifemarketUrl = "" } = useUserSettingsQuery(
    (data2) => data2.marketplace_url
  );
  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } = useTransactionsQuery({
    productType
  });
  return {
    isLoading,
    isFetchingNextPage,
    lifemarketUrl,
    fetchNextPage,
    hasNextPage,
    // TODO: fix these types
    transactions: data
  };
};

// src/pages/wallet-detail/components/content-panel/components/transactions/transactions.component.tsx
var TRANSACTION_CAPTION_ID = "transaction-table-caption-id";
var TransactionsBox = genesisStyled17(Box38)(
  css15({
    overflowX: "auto",
    marginBottom: "four",
    "&:focus": {
      boxShadow: "rgba(0, 0, 0, 0.5)",
      outline: "interactive.focus.outer"
    }
  })
);
var TableHeadingCell = (props) => /* @__PURE__ */ React60.createElement(
  Overline,
  __spreadValues({
    as: "th",
    paddingY: "one",
    paddingX: "quarter",
    verticalAlign: "middle",
    borderBottomColor: "onSurface.border.subdued",
    borderBottomStyle: "solid",
    borderBottomWidth: "thin",
    textAlign: "start"
  }, props)
);
var Transactions = () => {
  const {
    hasNextPage,
    isLoading,
    isFetchingNextPage,
    lifemarketUrl,
    fetchNextPage,
    transactions
  } = useTransactions();
  const { formatMessage } = useIntl39();
  if (isLoading) {
    return /* @__PURE__ */ React60.createElement(LoadingIndicator7, { inline: true });
  }
  if ((transactions == null ? void 0 : transactions.length) === 0 && !hasNextPage) {
    return /* @__PURE__ */ React60.createElement(
      BodyTwoSecondary,
      {
        marginTop: "one",
        marginBottom: "four",
        marginInlineStart: "quarter",
        fontStyle: "italic"
      },
      formatMessage({ id: "NO_TRANSACTIONS_YET" })
    );
  }
  return /* @__PURE__ */ React60.createElement(
    TransactionsBox,
    {
      tabIndex: 0,
      role: "region",
      "aria-labelledby": TRANSACTION_CAPTION_ID
    },
    /* @__PURE__ */ React60.createElement(Box38, { as: "table", width: 1, "aria-live": "polite" }, /* @__PURE__ */ React60.createElement(VisuallyHidden6, { as: "caption", id: TRANSACTION_CAPTION_ID }, formatMessage({ id: "TRANSACTION_TABLE_CAPTION" })), /* @__PURE__ */ React60.createElement("thead", null, /* @__PURE__ */ React60.createElement(Box38, { as: "tr" }, /* @__PURE__ */ React60.createElement(TableHeadingCell, { minWidth: 100 }, formatMessage({ id: "DATE" })), /* @__PURE__ */ React60.createElement(TableHeadingCell, { maxWidth: 120 }, formatMessage({ id: "ID" })), /* @__PURE__ */ React60.createElement(TableHeadingCell, null, formatMessage({ id: "DESCRIPTION" })), /* @__PURE__ */ React60.createElement(TableHeadingCell, null, formatMessage({ id: "TYPE" })), /* @__PURE__ */ React60.createElement(TableHeadingCell, { textAlign: "end", minWidth: 100 }, formatMessage({ id: "AMOUNT" })), /* @__PURE__ */ React60.createElement(TableHeadingCell, { minWidth: 30 }, /* @__PURE__ */ React60.createElement(VisuallyHidden6, null, formatMessage({ id: "LINK_TO_TRANSACTION_DETAILS" }))))), /* @__PURE__ */ React60.createElement("tbody", null, transactions.map((transaction, i) => /* @__PURE__ */ React60.createElement(
      Transaction,
      {
        transaction,
        lifemarketUrl,
        key: `${transaction.key}-${i}`
      }
    )))),
    hasNextPage ? /* @__PURE__ */ React60.createElement(
      SecondaryButton2,
      {
        isLoading: isFetchingNextPage,
        onClick: fetchNextPage,
        marginTop: "one"
      },
      formatMessage({ id: "LOAD_MORE" })
    ) : /* @__PURE__ */ React60.createElement(
      BodyTwoSecondary,
      {
        marginTop: "one",
        marginInlineStart: "quarter",
        fontStyle: "italic"
      },
      formatMessage({ id: "NO_MORE_TRANSACTIONS" })
    )
  );
};

// src/pages/wallet-detail/components/dependents/dependents.component.tsx
import {
  BodyOneSecondary as BodyOneSecondary3,
  Box as Box41,
  SecondaryButton as SecondaryButton4,
  VisuallyHidden as VisuallyHidden8
} from "@leagueplatform/genesis-commons";
import React63 from "react";
import { useIntl as useIntl42 } from "@leagueplatform/locales";
import { LeagueFamilyPendingInviteBanner } from "@leagueplatform/dependents";
import { GenesisRouterLink as GenesisRouterLink3 } from "@leagueplatform/web-common-components";

// src/pages/wallet-detail/components/dependents/components/dependent/dependent.component.tsx
import { ParagraphText as ParagraphText20, HeadingText as HeadingText20 } from "@leagueplatform/genesis-core";
import { Box as Box39, Flex as Flex19, SecondaryButton as SecondaryButton3 } from "@leagueplatform/genesis-commons";
import React61 from "react";
import { useIntl as useIntl40 } from "@leagueplatform/locales";
import { FontAwesomeIcon as FontAwesomeIcon2 } from "@leagueplatform/ui-kit";
import { DEPENDENT_RELATIONSHIP_MAP } from "@leagueplatform/web-common";
var Dependent = ({ viewDependentCard, dependent }) => {
  const { email, first_name, last_name, relationship_type } = dependent;
  const { formatMessage, $tmap } = useIntl40();
  const relationshipTypeMessageMap = $tmap({
    spouse: "SPOUSE",
    common_law: "COMMON_LAW",
    child: "CHILD",
    parent: "PARENT",
    grandparent: "GRANDPARENT",
    grandchild: "GRANDCHILD",
    uncle_aunt: "UNCLE_AUNT",
    nephew_niece: "NEPHEW_NIECE",
    sibling: "SIBLING",
    other: "OTHER",
    domestic_partnership: "DOMESTIC_PARTNERSHIP",
    ineligible_child: "INELIGIBLE_CHILD"
  });
  const relationshipTypeMessage = DEPENDENT_RELATIONSHIP_MAP[relationship_type] && relationshipTypeMessageMap(relationship_type);
  return /* @__PURE__ */ React61.createElement(
    Box39,
    {
      as: "li",
      borderColor: "onSurface.border.default",
      borderWidth: "thin",
      borderStyle: "solid",
      borderRadius: "small",
      display: "inline-block",
      width: 1
    },
    /* @__PURE__ */ React61.createElement(
      Flex19,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "one",
        minHeight: "100%"
      },
      /* @__PURE__ */ React61.createElement(Box39, null, /* @__PURE__ */ React61.createElement(
        HeadingText20,
        {
          size: "lg",
          level: "3",
          css: { marginBottom: "$half" },
          className: "dependent-name"
        },
        first_name,
        " ",
        last_name
      ), email && /* @__PURE__ */ React61.createElement(
        ParagraphText20,
        {
          css: { marginTop: "$none" },
          className: "dependent-email",
          "data-testid": "dependent-email"
        },
        email
      ), relationshipTypeMessage && /* @__PURE__ */ React61.createElement(
        ParagraphText20,
        {
          css: { marginTop: "$none" },
          className: "dependent-relationship"
        },
        relationshipTypeMessage
      )),
      /* @__PURE__ */ React61.createElement(
        SecondaryButton3,
        {
          "aria-label": formatMessage(
            { id: "VIEW_CARD_FOR_DEPENDENT" },
            { dependentName: `${first_name} ${last_name}` }
          ),
          onClick: () => viewDependentCard(dependent),
          paddingX: "one",
          paddingY: "one",
          textAlign: "center",
          width: 1,
          marginTop: "one"
        },
        formatMessage({ id: "VIEW_CARD" }),
        /* @__PURE__ */ React61.createElement(Box39, { as: "span", marginInlineStart: "half" }, /* @__PURE__ */ React61.createElement(FontAwesomeIcon2, { icon: "angle-right" }))
      )
    )
  );
};

// src/pages/wallet-detail/components/dependents/hooks/use-dependents.hook.ts
import { useState as useState9 } from "react";
import {
  SYSTEM_TYPES as SYSTEM_TYPES5
} from "@leagueplatform/wallet-api";

// src/utils/flatten-actions-list.util.ts
var flattenActionList = (categorizedActions = [], actions = []) => {
  const flattenedActions = (categorizedActions == null ? void 0 : categorizedActions.reduce(
    (actionsList, currentCategory) => [
      ...actionsList,
      ...currentCategory.actions
    ],
    []
  )) || [];
  if (actions == null ? void 0 : actions.length) {
    return [...flattenedActions, ...actions];
  }
  return flattenedActions;
};

// src/pages/wallet-detail/components/dependents/hooks/use-dependents.hook.ts
var useDependents = () => {
  const { userId, benefitId = "" } = useWalletParams();
  const { data: dependents } = useWalletDetailQuery(
    userId,
    benefitId,
    void 0,
    {
      select: (data) => data.dependents
    }
  );
  const { data: banners } = useWalletDetailQuery(userId, benefitId, void 0, {
    select: (data) => {
      var _a;
      const actions = flattenActionList(data.categorized_actions, data.actions);
      return (_a = actions.find(
        (a) => a.system_type === SYSTEM_TYPES5.ViewDependent
      )) == null ? void 0 : _a.banners;
    }
  });
  const [currentDependent, setCurrentDependent] = useState9(
    null
  );
  const { data: showDependentsMenuItem = false } = useUserSettingsQuery(
    (data) => data.show_dependents_menu_item
  );
  const onViewDependentCardClick = (dependent) => {
    setCurrentDependent(dependent);
  };
  const onViewDependentCardClose = () => {
    setCurrentDependent(null);
  };
  return {
    showDependentsMenuItem,
    onViewDependentCardClick,
    benefitId,
    currentDependent,
    onViewDependentCardClose,
    dependents,
    banners
  };
};

// src/pages/wallet-detail/components/dependents/components/dependent-card-viewer-modal/dependent-card-viewer-modal.component.tsx
import React62 from "react";
import { ParagraphText as ParagraphText21, HeadingText as HeadingText21 } from "@leagueplatform/genesis-core";
import {
  Box as Box40,
  Flex as Flex20,
  Image as Image14,
  QuietButton as QuietButton3,
  VisuallyHidden as VisuallyHidden7
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl41 } from "@leagueplatform/locales";
import { Modal as Modal4 } from "@leagueplatform/ui-kit";
import { LoadingIndicator as LoadingIndicator8 } from "@leagueplatform/web-common-components";
import { handleStaticAsset as handleStaticAsset10 } from "@leagueplatform/asset-config";

// src/pages/wallet-detail/components/dependents/components/dependent-card-viewer-modal/hooks/use-get-wallet-dependent-cards-query.hook.ts
import { useQuery as useQuery12 } from "@tanstack/react-query";
import {
  GET_WALLET_DEPENDENT_CARDS_MESSAGE_TYPE,
  getWalletDependentCards
} from "@leagueplatform/wallet-api";
var useGetWalletDependentCardsQuery = (options) => {
  const { userId } = useWalletParams();
  return useQuery12(
    [GET_WALLET_DEPENDENT_CARDS_MESSAGE_TYPE, userId],
    () => getWalletDependentCards(userId),
    // This query response is large, we are stopping it from re-fetching automatically
    __spreadValues({ staleTime: Infinity }, options)
  );
};

// src/pages/wallet-detail/components/dependents/components/dependent-card-viewer-modal/utils/get-dependent-card.util.ts
var getDependentCard = (dependentId, benefitId, benefitCards) => {
  if (benefitCards && dependentId) {
    const currentBenefitCard = benefitCards.find(
      (benefitCard) => benefitCard.dependent_id === dependentId && benefitCard.id === benefitId
    );
    return currentBenefitCard;
  }
  return null;
};

// src/pages/wallet-detail/components/dependents/components/dependent-card-viewer-modal/hooks/use-dependent-card-viewer-modal.hook.ts
var useDependentCardViewerModal = ({
  benefitId,
  dependent
}) => {
  const { data, isLoading } = useGetWalletDependentCardsQuery();
  const dependentCard = getDependentCard(
    dependent == null ? void 0 : dependent.dependent_id,
    benefitId,
    data == null ? void 0 : data.benefit_cards
  );
  let cardImage;
  if (dependentCard) {
    const cardHtml = selectCardHtml(dependentCard);
    cardImage = cardHtml == null ? void 0 : cardHtml.front.src;
  }
  return {
    cardName: (dependentCard == null ? void 0 : dependentCard.full_name) || "",
    cardImage,
    cardType: (dependentCard == null ? void 0 : dependentCard.type) || "",
    isLoading
  };
};

// src/pages/wallet-detail/components/dependents/components/dependent-card-viewer-modal/dependent-card-viewer-modal.component.tsx
var DependentCardViewerModal = ({
  benefitId,
  dependent,
  onClose: handleClose
}) => {
  const { cardImage, cardName, isLoading } = useDependentCardViewerModal({
    benefitId,
    dependent
  });
  const { formatMessage } = useIntl41();
  const title = formatMessage(
    { id: "DEPENDENT_CARD_HOLDER" },
    {
      dependentName: `${dependent == null ? void 0 : dependent.first_name} ${dependent == null ? void 0 : dependent.last_name}`
    }
  );
  return /* @__PURE__ */ React62.createElement(Modal4.Wrapper, { onClose: handleClose, options: {} }, /* @__PURE__ */ React62.createElement(
    Flex20,
    {
      borderRadius: "medium",
      backgroundColor: "surface.background.primary",
      flexDirection: ["column", "column", "row"],
      padding: "two",
      paddingTop: "three",
      position: "relative",
      role: "dialog",
      "aria-label": title
    },
    /* @__PURE__ */ React62.createElement(Box40, { position: "absolute", insetInlineEnd: "one", top: "one" }, /* @__PURE__ */ React62.createElement(
      QuietButton3,
      {
        borderColor: "transparent",
        borderRadius: "circle",
        borderStyle: "solid",
        borderWidth: "thin",
        onClick: handleClose,
        paddingX: "none",
        paddingY: "none",
        size: "two"
      },
      /* @__PURE__ */ React62.createElement(VisuallyHidden7, null, formatMessage({ id: "CLOSE" })),
      /* @__PURE__ */ React62.createElement(
        Image14,
        {
          src: handleStaticAsset10("CLOSE_ICON" /* CLOSE_ICON */),
          role: "presentation",
          size: "threeQuarters"
        }
      )
    )),
    isLoading ? (
      // Dimensions to match WalletCard
      /* @__PURE__ */ React62.createElement(
        Box40,
        {
          height: "164px",
          position: "relative",
          top: "-50%",
          width: ["280px", "280px", "450px"]
        },
        /* @__PURE__ */ React62.createElement(LoadingIndicator8, null)
      )
    ) : /* @__PURE__ */ React62.createElement(Flex20, { flexDirection: "column" }, /* @__PURE__ */ React62.createElement(
      HeadingText21,
      {
        id: "modalTitle",
        level: "1",
        size: "xxl",
        css: { fontWeight: "$bodyOne" }
      },
      /* @__PURE__ */ React62.createElement(ParagraphText21, { emphasis: "subtle", as: "span" }, title),
      " ",
      /* @__PURE__ */ React62.createElement(Box40, { as: "span", display: "block" }, cardName)
    ), /* @__PURE__ */ React62.createElement(Box40, { marginTop: "two" }, /* @__PURE__ */ React62.createElement(WalletCard, { card: cardImage })))
  ));
};

// src/pages/wallet-detail/components/dependents/dependents.component.tsx
var GRID_COLUMN_COUNT2 = 3;
var MIN_GRID_ITEM_WIDTH2 = "200px";
var Dependents = () => {
  var _a, _b;
  const {
    onViewDependentCardClick,
    showDependentsMenuItem,
    currentDependent,
    benefitId,
    onViewDependentCardClose,
    dependents = [],
    banners
  } = useDependents();
  const { formatMessage, $tifelse } = useIntl42();
  const hasDependents = dependents && dependents.length > 0;
  const statusBanner = banners == null ? void 0 : banners.status;
  return /* @__PURE__ */ React63.createElement(React63.Fragment, null, statusBanner && /* @__PURE__ */ React63.createElement(
    LeagueFamilyPendingInviteBanner,
    {
      title: statusBanner.title,
      description: statusBanner.description,
      linkText: (_a = statusBanner.link) == null ? void 0 : _a.text,
      linkUrl: (_b = statusBanner.link) == null ? void 0 : _b.url
    }
  ), /* @__PURE__ */ React63.createElement(Box41, { as: "section" }, /* @__PURE__ */ React63.createElement(VisuallyHidden8, { as: "h2" }, formatMessage({ id: "DEPENDENTS" })), /* @__PURE__ */ React63.createElement(BodyOneSecondary3, { marginBottom: "two" }, $tifelse(
    hasDependents,
    "HAS_DEPENDENTS_DESCRIPTION",
    "HAS_NO_DEPENDENTS_DESCRIPTION"
  )), showDependentsMenuItem && /* @__PURE__ */ React63.createElement(
    SecondaryButton4,
    {
      as: GenesisRouterLink3,
      textDecoration: "none",
      to: "/member/wallet/dependents"
    },
    $tifelse(
      hasDependents,
      "MANAGE_DEPENDENTS",
      "ADD_A_DEPENDENT_CAPITAL"
    )
  ), hasDependents ? /* @__PURE__ */ React63.createElement(
    GridContainer,
    {
      marginTop: "two",
      gridColumnCount: GRID_COLUMN_COUNT2,
      minGridItemWidth: MIN_GRID_ITEM_WIDTH2,
      as: "ul"
    },
    dependents.map((dependent) => /* @__PURE__ */ React63.createElement(
      Dependent,
      {
        key: dependent.dependent_id,
        viewDependentCard: onViewDependentCardClick,
        dependent
      }
    ))
  ) : null, currentDependent && /* @__PURE__ */ React63.createElement(
    DependentCardViewerModal,
    {
      benefitId,
      dependent: currentDependent,
      onClose: onViewDependentCardClose
    }
  )));
};

// src/pages/wallet-detail/components/plan-progress-and-coverage/plan-progress-and-coverage.component.tsx
import * as React73 from "react";
import { StackLayout as StackLayout32 } from "@leagueplatform/genesis-core";

// src/pages/wallet-detail/components/plan-progress/plan-progress-switcher.component.tsx
import * as React72 from "react";
import { useFeatureFlagQuery as useFeatureFlagQuery7 } from "@leagueplatform/user-profile-api";
import { LoadingIndicator as LoadingIndicator11 } from "@leagueplatform/web-common-components";

// src/pages/wallet-detail/components/plan-progress/plan-progress-v1.component.tsx
import React67 from "react";
import { ParagraphText as ParagraphText24, Tabs as Tabs3 } from "@leagueplatform/genesis-core";
import { Box as Box45, Flex as Flex22 } from "@leagueplatform/genesis-commons";
import { SectionHeader as SectionHeader9 } from "@leagueplatform/genesis-core-alpha";
import { useIntl as useIntl45 } from "@leagueplatform/locales";
import {
  PillTab as PillTab2,
  PillTabList as PillTabList2,
  PillTabs as PillTabs2,
  LoadingIndicator as LoadingIndicator9,
  ErrorState as ErrorState3
} from "@leagueplatform/web-common-components";
import {
  SHORT_DATE_AND_TIME_FORMAT,
  SHORT_DATE_FORMAT
} from "@leagueplatform/web-common";

// src/pages/wallet-detail/components/plan-progress/components/network-plan/network-plan.component.tsx
import React66 from "react";
import { HeadingText as HeadingText23, ParagraphText as ParagraphText23 } from "@leagueplatform/genesis-core";
import { Caption as Caption2, Flex as Flex21, Box as Box44 } from "@leagueplatform/genesis-commons";
import { HtmlToReact as HtmlToReact4 } from "@leagueplatform/web-common";
import { useIntl as useIntl44 } from "@leagueplatform/locales";
import { StackLayout as StackLayout28 } from "@leagueplatform/web-common-components";

// src/pages/wallet-detail/components/plan-progress/components/network-accordion/network-accordion.component.tsx
import React65 from "react";
import { StackLayout as StackLayout27, Accordion as Accordion2 } from "@leagueplatform/web-common-components";
import { Caption } from "@leagueplatform/genesis-commons";
import { Box as Box43 } from "@leagueplatform/genesis-core";

// src/pages/wallet-detail/components/plan-progress/components/live-balance-item/live-balance-item.component.tsx
import React64 from "react";
import { uniqueId } from "lodash";
import { useIntl as useIntl43 } from "@leagueplatform/locales";
import { StackLayout as StackLayout26 } from "@leagueplatform/web-common-components";
import {
  Box as Box42,
  HeadingText as HeadingText22,
  ParagraphText as ParagraphText22,
  UtilityText as UtilityText5,
  VisuallyHidden as VisuallyHidden9
} from "@leagueplatform/genesis-core";
function useCategoryName({
  balanceName,
  category,
  version
}) {
  const { formatMessage } = useIntl43();
  const [member] = useSelectedMember();
  if (!category) {
    return void 0;
  }
  if (version === 2) {
    return balanceName;
  }
  if (category === "individual" && version === 1) {
    return formatMessage(
      { id: "INDIVIDUAL_BALANCE" },
      {
        membersFullName: (member == null ? void 0 : member.name) || formatMessage({ id: "INDIVIDUAL" }),
        balance: balanceName
      }
    );
  }
  return formatMessage(
    { id: "FAMILY_BALANCE" },
    {
      balance: balanceName
    }
  );
}
var LiveBalanceItem = ({
  networkName,
  balanceName,
  paid_amount: paidAmount,
  remaining_amount: remainingAmount,
  limit,
  headingLevel = "4",
  category,
  version = 1,
  eyebrow
}) => {
  const { formatMoney, formatMessage } = useIntl43();
  const percentage = +(paidAmount.M / limit.M * 100).toFixed(2);
  const progressId = uniqueId("progress-");
  const title = useCategoryName({ balanceName, category, version });
  return /* @__PURE__ */ React64.createElement(
    StackLayout26,
    {
      css: {
        backgroundColor: "$surfaceBackgroundPrimary",
        borderColor: "$onSurfaceBorderDefault",
        borderRadius: "$small",
        borderStyle: "solid",
        borderWidth: "$thin",
        padding: "$one"
      }
    },
    /* @__PURE__ */ React64.createElement(Box42, null, (eyebrow || networkName) && /* @__PURE__ */ React64.createElement(
      UtilityText5,
      {
        emphasis: "emphasized",
        size: "eyebrow",
        css: { marginBottom: "$quarter", display: "block" }
      },
      eyebrow || networkName
    ), title && /* @__PURE__ */ React64.createElement(
      HeadingText22,
      {
        size: headingLevel === "4" ? "md" : "lg",
        level: headingLevel
      },
      title
    )),
    /* @__PURE__ */ React64.createElement(ParagraphText22, null, formatMessage(
      { id: "LIVE_BALANCE_SPEND" },
      {
        spentAmount: /* @__PURE__ */ React64.createElement(
          HeadingText22,
          {
            as: "span",
            size: "lg",
            level: "3",
            css: { display: "inline-block" }
          },
          formatMoney(paidAmount)
        ),
        totalAmount: formatMoney(limit, {
          minimumFractionDigits: 0
        })
      }
    )),
    /* @__PURE__ */ React64.createElement(
      Box42,
      {
        css: {
          backgroundColor: "$successBackgroundSubdued",
          borderRadius: "$pill",
          height: "$half",
          maxWidth: "400px",
          overflow: "hidden",
          width: "100%"
        }
      },
      /* @__PURE__ */ React64.createElement(VisuallyHidden9, { "aria-hidden": true, id: progressId }, formatMessage({ id: "PERCENTAGE_USED" })),
      /* @__PURE__ */ React64.createElement(
        Box42,
        {
          "aria-labelledby": progressId,
          role: "progressbar",
          "aria-valuemin": 0,
          "aria-valuemax": 100,
          "aria-valuenow": percentage,
          css: {
            backgroundColor: "$successBorderDefault",
            borderRadius: "$pill",
            height: "100%",
            minWidth: "$half",
            width: `${percentage}%`
          }
        }
      )
    ),
    /* @__PURE__ */ React64.createElement(UtilityText5, { as: "p", emphasis: "emphasized" }, formatMessage(
      { id: "LIVE_BALANCE_REMAINING" },
      { amount: formatMoney(remainingAmount) }
    ))
  );
};

// src/pages/wallet-detail/components/plan-progress/components/network-accordion/network-accordion.component.tsx
var formatAccordionStringName = (name = "") => name.replaceAll(" ", "-").toLocaleLowerCase();
var NetworkAccordion = ({
  providerService: _providerService,
  networkName,
  lastUpdated,
  onToggle
}) => {
  const providerService = React65.useMemo(
    () => _providerService.map((service) => __spreadValues({
      accordionId: service.provider ? `accordion-${formatAccordionStringName(
        service.provider_id
      )}-${formatAccordionStringName(service.provider)}` : void 0
    }, service)),
    [_providerService]
  );
  const defaultPanel = React65.useMemo(() => {
    const panel = providerService.find((service) => service.accordionId);
    return (panel == null ? void 0 : panel.accordionId) ? [panel.accordionId] : [];
  }, [providerService]);
  const [activePanels, setActivePanels] = React65.useState(defaultPanel);
  const toggleItem = React65.useCallback(
    (currentPanels) => {
      var _a, _b;
      if (currentPanels.length > activePanels.length) {
        const clickedPanel = providerService.find(
          (service) => service.accordionId === currentPanels[0]
        );
        const provider = clickedPanel == null ? void 0 : clickedPanel.provider;
        const balanceType = (_a = clickedPanel == null ? void 0 : clickedPanel.balances[0]) == null ? void 0 : _a.balance_type;
        if (onToggle) {
          onToggle(provider, "expand", balanceType);
        }
      } else {
        const [clickedActivePanel] = activePanels.filter(
          (x) => !currentPanels.includes(x)
        );
        const clickedPanel = providerService.find(
          (service) => service.accordionId === clickedActivePanel
        );
        const provider = clickedPanel == null ? void 0 : clickedPanel.provider;
        const balanceType = (_b = clickedPanel == null ? void 0 : clickedPanel.balances[0]) == null ? void 0 : _b.balance_type;
        if (onToggle) {
          onToggle(provider, "collapse", balanceType);
        }
      }
      setActivePanels(currentPanels);
    },
    [activePanels, onToggle, providerService]
  );
  return /* @__PURE__ */ React65.createElement(Box43, null, providerService.map(({ accordionId, balances, provider }) => {
    if (!provider) {
      return /* @__PURE__ */ React65.createElement(StackLayout27, { space: "$oneAndHalf" }, balances.map(
        ({ title, limit, paid_amount, remaining_amount, category }) => /* @__PURE__ */ React65.createElement(
          LiveBalanceItem,
          {
            category,
            key: `balance-item-${category}-${title}`,
            balanceName: title,
            networkName,
            limit,
            paid_amount,
            remaining_amount
          }
        )
      ), /* @__PURE__ */ React65.createElement(Caption, null, lastUpdated));
    }
    return /* @__PURE__ */ React65.createElement(
      Accordion2.Root,
      {
        type: "multiple",
        value: activePanels,
        onValueChange: toggleItem
      },
      /* @__PURE__ */ React65.createElement(
        Accordion2.Item,
        {
          value: accordionId || "accordion-item",
          key: accordionId
        },
        /* @__PURE__ */ React65.createElement(Accordion2.Header, { level: "4", size: "md" }, /* @__PURE__ */ React65.createElement(Accordion2.Trigger, null, provider)),
        /* @__PURE__ */ React65.createElement(StackLayout27, { space: "$oneAndHalf", as: Accordion2.Content }, balances.map(
          ({
            title,
            limit,
            paid_amount,
            remaining_amount,
            category
          }) => /* @__PURE__ */ React65.createElement(
            LiveBalanceItem,
            {
              category,
              key: `accordion-balance-item-${category}-${title}`,
              balanceName: title,
              networkName,
              limit,
              paid_amount,
              remaining_amount,
              headingLevel: "5"
            }
          )
        ), /* @__PURE__ */ React65.createElement(Caption, null, lastUpdated))
      )
    );
  }));
};

// src/pages/wallet-detail/components/plan-progress/components/network-plan/utils/network-has-tiers.util.ts
var networkHasTiers = (providerServices) => providerServices.some((service) => service.provider);

// src/pages/wallet-detail/components/plan-progress/components/network-plan/network-plan.component.tsx
var getBalanceType = (providerServices) => {
  var _a, _b;
  return (_b = (_a = providerServices.find(
    (provider) => {
      var _a2;
      return (_a2 = provider.balances.find((balance) => balance.balance_type)) == null ? void 0 : _a2.balance_type;
    }
  )) == null ? void 0 : _a.balances.find((balance) => balance.balance_type)) == null ? void 0 : _b.balance_type;
};
var getDefinition = (providerServices) => {
  var _a;
  return (_a = providerServices.find((provider) => provider.definition)) == null ? void 0 : _a.definition;
};
var BalanceGroup = ({
  providerServices,
  lastUpdated,
  networkName,
  onProviderToggle
}) => {
  const hasTiers = networkHasTiers(providerServices);
  const balanceType = getBalanceType(providerServices);
  const definition = getDefinition(providerServices);
  return /* @__PURE__ */ React66.createElement(StackLayout28, { as: "section", space: "$oneAndHalf" }, definition && /* @__PURE__ */ React66.createElement(Box44, null, definition.title && /* @__PURE__ */ React66.createElement(
    HeadingText23,
    {
      level: "2",
      size: "xl",
      as: "h3",
      css: { marginBottom: "$one" }
    },
    definition.title
  ), /* @__PURE__ */ React66.createElement(StackLayout28, { as: "section", space: "$half" }, /* @__PURE__ */ React66.createElement(HtmlToReact4, { htmlString: definition == null ? void 0 : definition.description }))), hasTiers && /* @__PURE__ */ React66.createElement(
    NetworkAccordion,
    {
      networkName,
      providerService: providerServices,
      lastUpdated,
      onToggle: onProviderToggle
    }
  ), !hasTiers && /* @__PURE__ */ React66.createElement(React66.Fragment, null, providerServices.map(
    ({ balances }) => balances.map(
      ({ title, limit, paid_amount, remaining_amount, category }) => /* @__PURE__ */ React66.createElement(
        LiveBalanceItem,
        {
          headingLevel: "4",
          key: `balance-group-item-${title}-${balanceType}`,
          balanceName: title,
          networkName,
          limit,
          paid_amount,
          remaining_amount,
          category
        }
      )
    )
  ), /* @__PURE__ */ React66.createElement(Caption2, null, lastUpdated)));
};
var NetworkPlan = ({
  networkProviders,
  networkName,
  lastUpdated,
  onProviderToggle
}) => {
  const { formatMessage } = useIntl44();
  if (networkProviders.length === 0) {
    return /* @__PURE__ */ React66.createElement(
      Flex21,
      {
        as: "section",
        backgroundColor: "surface.background.tertiary",
        padding: "one",
        minHeight: 286,
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center"
      },
      /* @__PURE__ */ React66.createElement(ParagraphText23, null, formatMessage(
        { id: "NETWORK_MISSING_COVERAGE" },
        { network: networkName }
      ))
    );
  }
  return /* @__PURE__ */ React66.createElement(StackLayout28, { space: "$two" }, networkProviders.map((providers, i) => /* @__PURE__ */ React66.createElement(
    BalanceGroup,
    {
      key: `balance-group-${networkName}-${i}`,
      providerServices: providers,
      lastUpdated,
      networkName,
      onProviderToggle
    }
  )));
};

// src/pages/wallet-detail/components/plan-progress/hooks/use-plan-progress-v1.hook.ts
import { useCallback as useCallback13, useMemo as useMemo14 } from "react";
import { EVENT_NAME as EVENT_NAME14 } from "@leagueplatform/analytics";

// src/pages/wallet-detail/components/plan-progress/utils/get-network-with-balance-type.util.ts
var getBalanceTypes = (networkType) => {
  const benefitTypeArray = [];
  networkType.forEach((network) => {
    network.balances.forEach((balance) => {
      if (!benefitTypeArray.includes(balance.balance_type)) {
        benefitTypeArray.push(balance.balance_type);
      }
    });
  });
  return benefitTypeArray.sort();
};
var getNetworkWithBalanceType = (networkType, definitions) => {
  const balanceTypes = getBalanceTypes(networkType);
  return balanceTypes.map((balanceType) => {
    const networksInBalance = networkType.reduce(
      (prev, current) => {
        const balances = current.balances.filter(
          (b) => b.balance_type === balanceType
        );
        const definition = definitions.find(
          (_definition) => _definition.balance_type === balanceType
        );
        return [...prev, __spreadProps(__spreadValues({}, current), { balances, definition })].filter(
          (network) => network.balances.length > 0
        );
      },
      []
    );
    return networksInBalance;
  });
};

// src/pages/wallet-detail/components/plan-progress/hooks/queries/use-get-user-benefit-live-balances-query-v1.hook.ts
import { useQuery as useQuery13 } from "@tanstack/react-query";
import { EVENT_NAME as EVENT_NAME13 } from "@leagueplatform/analytics";
import {
  getUserBenefitLiveBalances,
  GET_USER_BENEFIT_LIVE_BALANCES_MESSAGE_TYPE
} from "@leagueplatform/wallet-api";

// src/pages/wallet-detail/components/plan-progress/constants/analytics.constants.ts
var SUCCESS = "Success";
var FAILURE = "Failure";
var CATEGORY = "Wallet";
var ACTION_NAME = "Live Balance Requested - ";

// src/pages/wallet-detail/components/plan-progress/hooks/queries/use-get-user-benefit-live-balances-query-v1.hook.ts
function useGetUserBenefitLiveBalancesQueryV1(userId, benefitId, benefitName, dependentId, options) {
  const sendBenefitAnalyticsEvent = useWalletDetailAnalytics();
  const analyticsInfo = { category: CATEGORY, label: benefitName };
  return useQuery13(
    [
      GET_USER_BENEFIT_LIVE_BALANCES_MESSAGE_TYPE,
      userId,
      benefitId,
      dependentId
    ],
    () => getUserBenefitLiveBalances(userId, benefitId, dependentId),
    __spreadProps(__spreadValues({}, options), {
      onSuccess: (data) => {
        var _a;
        sendBenefitAnalyticsEvent(EVENT_NAME13.QUERY_RETURNED, __spreadProps(__spreadValues({}, analyticsInfo), {
          action: ACTION_NAME + SUCCESS
        }));
        (_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options, data);
      },
      onError: (data) => {
        var _a;
        sendBenefitAnalyticsEvent(EVENT_NAME13.QUERY_RETURNED, __spreadProps(__spreadValues({}, analyticsInfo), {
          action: ACTION_NAME + FAILURE
        }));
        (_a = options == null ? void 0 : options.onError) == null ? void 0 : _a.call(options, data);
      }
    })
  );
}

// src/pages/wallet-detail/components/plan-progress/hooks/use-plan-progress-v1.hook.ts
var usePlanProgressV1 = (userId, benefitId) => {
  const { data: benefitName = "" } = useWalletDetailQuery(
    userId,
    benefitId,
    void 0,
    {
      select: (data2) => data2.full_name
    }
  );
  const sendBenefitAnalyticsEvent = useWalletDetailAnalytics();
  const [member] = useSelectedMember();
  const { data, isError, isLoading, refetch, error } = useGetUserBenefitLiveBalancesQueryV1(
    userId,
    benefitId,
    benefitName,
    member == null ? void 0 : member.id
  );
  const {
    in_network: inNetwork = [],
    out_of_network: outOfNetwork = [],
    accumulation_period: accumulationPeriod,
    last_updated: lastUpdated,
    carrier_name: carrierName,
    definitions = []
  } = data || {};
  const inNetworkProviders = useMemo14(
    () => getNetworkWithBalanceType(inNetwork != null ? inNetwork : [], definitions),
    [inNetwork, definitions]
  );
  const outOfNetworkProviders = useMemo14(
    () => getNetworkWithBalanceType(outOfNetwork != null ? outOfNetwork : [], definitions),
    [outOfNetwork, definitions]
  );
  const plans = [
    {
      id: "IN_NETWORK" /* IN_NETWORK */,
      analyticsId: "in network" /* IN_NETWORK */,
      network: inNetworkProviders
    },
    {
      id: "OUT_OF_NETWORK" /* OUT_OF_NETWORK */,
      analyticsId: "out of network" /* OUT_OF_NETWORK */,
      network: outOfNetworkProviders
    }
  ];
  const onTabClickEvent = useCallback13(
    (tabName) => {
      sendBenefitAnalyticsEvent(EVENT_NAME14.NAVIGATION_TAB_CLICKED, {
        detail: tabName
      });
    },
    [sendBenefitAnalyticsEvent]
  );
  const onAccordionToggleEvent = useCallback13(
    (accordionName, state2, balanceType) => {
      sendBenefitAnalyticsEvent(EVENT_NAME14.BUTTON_CLICKED, {
        detail: `toggle ${accordionName} accordion`,
        sub_detail: state2,
        text_detail: balanceType
      });
    },
    [sendBenefitAnalyticsEvent]
  );
  return {
    plans,
    accumulationPeriod,
    lastUpdated,
    carrierName,
    onTabClickEvent,
    onAccordionToggleEvent,
    isLoading,
    isError,
    refetch,
    error
  };
};

// src/pages/wallet-detail/components/plan-progress/plan-progress-v1.component.tsx
var ACCUMULATION_PERIOD_DATE_FORMAT = __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT), {
  timeZone: "UTC"
});
var PlanProgressV1 = () => {
  const { formatDate, formatMessage, $tmap } = useIntl45();
  const { userId, benefitId } = useWalletParams();
  const {
    plans,
    accumulationPeriod,
    lastUpdated,
    carrierName,
    onTabClickEvent: handleTabClickEvent,
    onAccordionToggleEvent: handleAccordionToggleEvent,
    isLoading,
    isError,
    refetch,
    error
  } = usePlanProgressV1(userId, benefitId);
  const { showMemberSelect } = useMemberDropdown();
  const getPlanIDMessage = $tmap({
    ["IN_NETWORK" /* IN_NETWORK */]: "IN_NETWORK",
    ["OUT_OF_NETWORK" /* OUT_OF_NETWORK */]: "OUT_OF_NETWORK",
    ["NO_NETWORK" /* NO_NETWORK */]: "NETWORK_PLAN_ID"
  });
  const strong = (msg) => /* @__PURE__ */ React67.createElement(Box45, { as: "strong" }, msg);
  return /* @__PURE__ */ React67.createElement(Box45, { as: "section" }, /* @__PURE__ */ React67.createElement(React67.Fragment, null, showMemberSelect && /* @__PURE__ */ React67.createElement(MemberDropDown, null), /* @__PURE__ */ React67.createElement(
    SectionHeader9,
    {
      title: formatMessage({ id: "PLAN_PROGRESS" }),
      headingLevel: "2",
      css: {
        marginBottom: "$oneAndHalf",
        marginTop: showMemberSelect ? "$oneAndHalf" : "$none"
      }
    }
  )), isLoading && /* @__PURE__ */ React67.createElement(LoadingIndicator9, { inline: true }), isError && !isLoading && /* @__PURE__ */ React67.createElement(
    Flex22,
    {
      as: "section",
      backgroundColor: "surface.background.tertiary",
      padding: "one",
      minHeight: 286,
      textAlign: "center",
      alignItems: "center",
      justifyContent: "center"
    },
    /* @__PURE__ */ React67.createElement(ErrorState3, { hideImage: true, onButtonClick: refetch, error })
  ), !isLoading && !isError && /* @__PURE__ */ React67.createElement(React67.Fragment, null, accumulationPeriod && /* @__PURE__ */ React67.createElement(ParagraphText24, { size: "sm" }, formatMessage(
    { id: "ACCUMULATION_PERIOD" },
    {
      start: formatDate(
        accumulationPeriod.start,
        ACCUMULATION_PERIOD_DATE_FORMAT
      ),
      end: formatDate(
        accumulationPeriod.end,
        ACCUMULATION_PERIOD_DATE_FORMAT
      ),
      strong
    }
  )), /* @__PURE__ */ React67.createElement(
    PillTabs2,
    {
      onValueChange: (value) => {
        handleTabClickEvent(
          plans[plans.findIndex((plan) => plan.id === value)].analyticsId
        );
      },
      defaultValue: plans[0].id
    },
    /* @__PURE__ */ React67.createElement(Box45, { width: "fit-content", marginY: "twoAndHalf" }, /* @__PURE__ */ React67.createElement(PillTabList2, null, plans.map((tab) => /* @__PURE__ */ React67.createElement(PillTab2, { key: tab.id, value: tab.id }, getPlanIDMessage(tab.id))))),
    plans.map((plan) => /* @__PURE__ */ React67.createElement(Tabs3.TabPanel, { key: plan.id, value: plan.id }, /* @__PURE__ */ React67.createElement(
      NetworkPlan,
      {
        networkProviders: plan.network,
        networkName: getPlanIDMessage(plan.id),
        lastUpdated: formatMessage(
          { id: "LAST_UPDATED_CARRIER_DATE" },
          {
            date: formatDate(lastUpdated, SHORT_DATE_AND_TIME_FORMAT),
            carrier: carrierName
          }
        ),
        onProviderToggle: handleAccordionToggleEvent
      }
    )))
  )));
};

// src/pages/wallet-detail/components/plan-progress/plan-progress.component.tsx
import React71 from "react";
import {
  Box as Box47,
  ParagraphText as ParagraphText25,
  Tabs as Tabs4,
  StackLayout as StackLayout31
} from "@leagueplatform/genesis-core";
import { SectionHeader as SectionHeader10 } from "@leagueplatform/genesis-core-alpha";
import { useIntl as useIntl48 } from "@leagueplatform/locales";
import {
  PillTab as PillTab3,
  PillTabList as PillTabList3,
  PillTabs as PillTabs3,
  LoadingIndicator as LoadingIndicator10,
  ErrorState as ErrorState4
} from "@leagueplatform/web-common-components";
import {
  SHORT_DATE_AND_TIME_FORMAT as SHORT_DATE_AND_TIME_FORMAT2,
  SHORT_DATE_FORMAT as SHORT_DATE_FORMAT2
} from "@leagueplatform/web-common";

// src/pages/wallet-detail/components/plan-progress/hooks/use-plan-progress.hook.ts
import * as React68 from "react";
import { EVENT_NAME as EVENT_NAME16 } from "@leagueplatform/analytics";
import { useIntl as useIntl46 } from "@leagueplatform/locales";

// src/pages/wallet-detail/components/plan-progress/hooks/queries/use-get-user-benefit-live-balances-query.hook.ts
import { useQuery as useQuery14 } from "@tanstack/react-query";
import { EVENT_NAME as EVENT_NAME15 } from "@leagueplatform/analytics";
import {
  getUserBenefitLiveBalances as getUserBenefitLiveBalances2,
  GET_USER_BENEFIT_LIVE_BALANCES_MESSAGE_TYPE as GET_USER_BENEFIT_LIVE_BALANCES_MESSAGE_TYPE2
} from "@leagueplatform/wallet-api";
function useGetUserBenefitLiveBalancesQuery(userId, benefitId, benefitName, dependentId, version, options) {
  const sendBenefitAnalyticsEvent = useWalletDetailAnalytics();
  const analyticsInfo = { category: CATEGORY, label: benefitName };
  return useQuery14(
    [
      GET_USER_BENEFIT_LIVE_BALANCES_MESSAGE_TYPE2,
      userId,
      benefitId,
      dependentId
    ],
    () => getUserBenefitLiveBalances2(userId, benefitId, dependentId, version),
    __spreadProps(__spreadValues({}, options), {
      onSuccess: (data) => {
        var _a;
        sendBenefitAnalyticsEvent(EVENT_NAME15.QUERY_RETURNED, __spreadProps(__spreadValues({}, analyticsInfo), {
          action: ACTION_NAME + SUCCESS
        }));
        (_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options, data);
      },
      onError: (data) => {
        var _a;
        sendBenefitAnalyticsEvent(EVENT_NAME15.QUERY_RETURNED, __spreadProps(__spreadValues({}, analyticsInfo), {
          action: ACTION_NAME + FAILURE
        }));
        (_a = options == null ? void 0 : options.onError) == null ? void 0 : _a.call(options, data);
      }
    })
  );
}

// src/pages/wallet-detail/components/plan-progress/utils/format-plans-array.util.ts
var formatPlansArray = (plans) => {
  const { enableNoNetworkLiveBalances } = getWalletConfig();
  if (!enableNoNetworkLiveBalances) {
    return plans.map((plan) => {
      var _a;
      return __spreadProps(__spreadValues({}, plan), { network: (_a = plan.network) != null ? _a : [] });
    });
  }
  return plans.filter((plan) => plan.network !== null).map((plan) => {
    var _a;
    return __spreadProps(__spreadValues({}, plan), { network: (_a = plan.network) != null ? _a : [] });
  });
};

// src/pages/wallet-detail/components/plan-progress/hooks/use-plan-progress.hook.ts
var usePlanProgress = (userId, benefitId, version) => {
  const { data: benefitName = "" } = useWalletDetailQuery(
    userId,
    benefitId,
    void 0,
    {
      select: (data) => data.full_name
    }
  );
  const sendBenefitAnalyticsEvent = useWalletDetailAnalytics();
  const { formatMessage } = useIntl46();
  const [member] = useSelectedMember();
  const {
    data: {
      accumulation_period: accumulationPeriod,
      carrier_name: carrierName,
      in_network: inNetwork,
      last_updated: lastUpdated,
      no_network: noNetwork,
      out_of_network: outOfNetwork
    } = {},
    isError,
    isLoading,
    refetch,
    error
  } = useGetUserBenefitLiveBalancesQuery(
    userId,
    benefitId,
    benefitName,
    member == null ? void 0 : member.id,
    version
  );
  const isNoNetworkUser = !!noNetwork;
  const noNetworkPlan = React68.useMemo(
    () => formatPlansArray([
      {
        id: "NO_NETWORK" /* NO_NETWORK */,
        analyticsId: "no network" /* NO_NETWORK */,
        network: noNetwork
      }
    ]),
    [noNetwork]
  );
  const networkPlans = React68.useMemo(
    () => formatPlansArray([
      {
        id: "IN_NETWORK" /* IN_NETWORK */,
        analyticsId: "in network" /* IN_NETWORK */,
        network: inNetwork,
        networkName: formatMessage({ id: "IN_NETWORK" })
      },
      {
        analyticsId: "out of network" /* OUT_OF_NETWORK */,
        id: "OUT_OF_NETWORK" /* OUT_OF_NETWORK */,
        network: outOfNetwork,
        networkName: formatMessage({ id: "OUT_OF_NETWORK" })
      }
    ]),
    [formatMessage, inNetwork, outOfNetwork]
  );
  const onTabClickEvent = React68.useCallback(
    (tabName) => {
      sendBenefitAnalyticsEvent(EVENT_NAME16.NAVIGATION_TAB_CLICKED, {
        detail: tabName
      });
    },
    [sendBenefitAnalyticsEvent]
  );
  const onAccordionToggleEvent = React68.useCallback(
    (accordionName, state2, category) => {
      sendBenefitAnalyticsEvent(EVENT_NAME16.BUTTON_CLICKED, {
        detail: `toggle ${accordionName} accordion`,
        sub_detail: state2,
        text_detail: category
      });
    },
    [sendBenefitAnalyticsEvent]
  );
  return {
    accumulationPeriod,
    carrierName,
    isError,
    isLoading,
    isNoNetworkUser,
    lastUpdated,
    onAccordionToggleEvent,
    onTabClickEvent,
    plans: isNoNetworkUser ? noNetworkPlan : networkPlans,
    refetch,
    error
  };
};

// src/pages/wallet-detail/components/plan-progress/components/balance-categories/balance-categories.component.tsx
import * as React70 from "react";
import { Caption as Caption3 } from "@leagueplatform/genesis-commons";
import { StackLayout as StackLayout30, Accordion as Accordion3 } from "@leagueplatform/web-common-components";

// src/pages/wallet-detail/components/plan-progress/components/balance-group/balance-group.component.tsx
import * as React69 from "react";
import { Box as Box46, HeadingText as HeadingText24 } from "@leagueplatform/genesis-core";
import { StackLayout as StackLayout29 } from "@leagueplatform/web-common-components";
import { useIntl as useIntl47 } from "@leagueplatform/locales";
import {
  EVENT_NAME as EVENT_NAME17,
  PRODUCT_AREA as PRODUCT_AREA7,
  SCREEN_NAMES as SCREEN_NAMES6
} from "@leagueplatform/analytics";
var BalanceGroup2 = ({
  title: defaultTitle,
  type,
  balances,
  networkName,
  definition
}) => {
  const { formatMessage } = useIntl47();
  const [member] = useSelectedMember();
  const trackAnalyticsEvent6 = useWalletDetailAnalytics();
  const parseBalanceTitle = () => {
    if (type === "individual") {
      return (member == null ? void 0 : member.name) || formatMessage({ id: "INDIVIDUAL" });
    }
    return defaultTitle;
  };
  const title = parseBalanceTitle();
  const handleTooltipClick = () => {
    trackAnalyticsEvent6(EVENT_NAME17.BUTTON_CLICKED, {
      screen_name: SCREEN_NAMES6.BENEFIT_PAGE,
      product_area: PRODUCT_AREA7.WALLET,
      detail: "clicked on tooltip for more info",
      sub_detail: definition.title
    });
  };
  return /* @__PURE__ */ React69.createElement(StackLayout29, null, /* @__PURE__ */ React69.createElement(Box46, { css: { display: "flex", gap: "$half", alignItems: "center" } }, /* @__PURE__ */ React69.createElement(HeadingText24, { size: "md", level: "4", css: { textTransform: "capitalize" } }, title), (definition == null ? void 0 : definition.description) && /* @__PURE__ */ React69.createElement(
    DefinitionPopover,
    {
      description: definition.description,
      title: definition.title,
      triggerLabel: formatMessage(
        { id: "PLAN_PROGRESS_POP_UP_LABEL" },
        { title: definition.title }
      ),
      onClick: handleTooltipClick
    }
  )), /* @__PURE__ */ React69.createElement(StackLayout29, { as: "ul" }, balances.map(
    ({
      title: balanceName,
      limit,
      remaining_amount,
      paid_amount,
      eyebrow
    }, i) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ React69.createElement(Box46, { as: "li", key: `accordion-balance-item-${type}-${title}-${i}` }, /* @__PURE__ */ React69.createElement(
        LiveBalanceItem,
        {
          version: 2,
          balanceName,
          networkName,
          limit,
          paid_amount,
          remaining_amount,
          category: type,
          headingLevel: "5",
          eyebrow
        }
      ))
    )
  )));
};

// src/pages/wallet-detail/components/plan-progress/components/balance-categories/balance-categories.component.tsx
var BalanceCategories = ({
  title,
  categories,
  networkName,
  lastUpdated,
  onProviderToggle
}) => {
  const ACCORDION_NAME = React70.useMemo(
    () => `accordion-${title.replaceAll(" ", "-").toLocaleLowerCase()}`,
    [title]
  );
  const handleOnValueChange = (toggledItems) => {
    if (!onProviderToggle) {
      return;
    }
    const isCollapsed = toggledItems.includes(ACCORDION_NAME);
    if (isCollapsed) {
      onProviderToggle(title, "expand", ACCORDION_NAME);
    } else {
      onProviderToggle(title, "collapse", ACCORDION_NAME);
    }
  };
  return /* @__PURE__ */ React70.createElement(
    Accordion3.Root,
    {
      type: "multiple",
      defaultValue: [ACCORDION_NAME],
      onValueChange: handleOnValueChange,
      css: { width: "100%" }
    },
    /* @__PURE__ */ React70.createElement(Accordion3.Item, { value: ACCORDION_NAME }, /* @__PURE__ */ React70.createElement(Accordion3.Header, { level: "3", size: "md" }, /* @__PURE__ */ React70.createElement(Accordion3.Trigger, null, title)), /* @__PURE__ */ React70.createElement(
      StackLayout30,
      {
        space: "$oneAndHalf",
        as: Accordion3.Content,
        key: `accordion-${title}-panel`
      },
      categories.map(
        ({
          title: categoryTitle,
          type,
          definition,
          balances
        }) => /* @__PURE__ */ React70.createElement(
          BalanceGroup2,
          {
            key: `${networkName}-balance-group-${type}`,
            title: categoryTitle,
            type,
            definition,
            balances,
            networkName
          }
        )
      ),
      /* @__PURE__ */ React70.createElement(Caption3, null, lastUpdated)
    ))
  );
};

// src/pages/wallet-detail/components/plan-progress/plan-progress.component.tsx
var ACCUMULATION_PERIOD_DATE_FORMAT2 = __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT2), {
  timeZone: "UTC"
});
var PlanProgress = () => {
  var _a;
  const { formatDate, $tmap, formatMessage } = useIntl48();
  const { userId, benefitId } = useWalletParams();
  const {
    plans,
    accumulationPeriod,
    lastUpdated,
    carrierName,
    onTabClickEvent: handleTabClickEvent,
    onAccordionToggleEvent: handleAccordionToggleEvent,
    isLoading,
    isError,
    refetch,
    isNoNetworkUser,
    error
  } = usePlanProgress(userId, benefitId, 2);
  const { showMemberSelect } = useMemberDropdown();
  const { enableNoNetworkLiveBalances } = useWalletConfig();
  const isNoTabPlan = enableNoNetworkLiveBalances && plans.length === 1 || isNoNetworkUser;
  const isAccumulationPeriodVisible = !isLoading && !isError && accumulationPeriod;
  const getPlanIDMessage = $tmap({
    ["IN_NETWORK" /* IN_NETWORK */]: "IN_NETWORK",
    ["OUT_OF_NETWORK" /* OUT_OF_NETWORK */]: "OUT_OF_NETWORK",
    ["NO_NETWORK" /* NO_NETWORK */]: "NETWORK_PLAN_ID"
  });
  const strong = (msg) => /* @__PURE__ */ React71.createElement(Box47, { as: "strong" }, msg);
  return /* @__PURE__ */ React71.createElement(StackLayout31, { spacing: "$oneAndHalf", as: "section" }, showMemberSelect && /* @__PURE__ */ React71.createElement(MemberDropDown, null), /* @__PURE__ */ React71.createElement(StackLayout31, { spacing: "$one" }, /* @__PURE__ */ React71.createElement(
    SectionHeader10,
    {
      headingLevel: "2",
      title: formatMessage({ id: "PLAN_PROGRESS" })
    }
  ), isAccumulationPeriodVisible && /* @__PURE__ */ React71.createElement(ParagraphText25, { size: "sm" }, formatMessage(
    { id: "ACCUMULATION_PERIOD" },
    {
      start: formatDate(
        accumulationPeriod.start,
        ACCUMULATION_PERIOD_DATE_FORMAT2
      ),
      end: formatDate(
        accumulationPeriod.end,
        ACCUMULATION_PERIOD_DATE_FORMAT2
      ),
      strong
    }
  ))), isLoading && /* @__PURE__ */ React71.createElement(Box47, { css: { width: "100%" } }, /* @__PURE__ */ React71.createElement(LoadingIndicator10, { inline: true })), isError && !isLoading && /* @__PURE__ */ React71.createElement(
    Box47,
    {
      as: "section",
      css: {
        backgroundColor: "$surfaceBackgroundTertiary",
        padding: "$one",
        minHeight: "286px",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%"
      }
    },
    /* @__PURE__ */ React71.createElement(ErrorState4, { hideImage: true, onButtonClick: refetch, error })
  ), !isLoading && !isError && /* @__PURE__ */ React71.createElement(StackLayout31, { css: { width: "100%" }, spacing: "$oneAndHalf" }, !isNoTabPlan && /* @__PURE__ */ React71.createElement(
    PillTabs3,
    {
      css: { width: "100%" },
      onValueChange: (value) => {
        handleTabClickEvent(
          plans[plans.findIndex((plan) => plan.id === value)].analyticsId
        );
      },
      defaultValue: (_a = plans[0]) == null ? void 0 : _a.id
    },
    /* @__PURE__ */ React71.createElement(StackLayout31, { css: { width: "100%" }, spacing: "$oneAndHalf" }, /* @__PURE__ */ React71.createElement(Box47, { css: { width: "fit-content" } }, /* @__PURE__ */ React71.createElement(PillTabList3, null, plans.map((tab) => /* @__PURE__ */ React71.createElement(PillTab3, { key: tab.id, value: tab.id }, getPlanIDMessage(tab.id))))), plans.map((plan) => {
      var _a2, _b;
      const LAST_UPDATED = formatMessage(
        { id: "LAST_UPDATED_CARRIER_DATE" },
        {
          date: formatDate(lastUpdated, SHORT_DATE_AND_TIME_FORMAT2),
          carrier: carrierName
        }
      );
      return /* @__PURE__ */ React71.createElement(
        Tabs4.TabPanel,
        {
          css: { padding: "$none", width: "100%" },
          key: plan.id,
          value: plan.id
        },
        ((_a2 = plan.network) == null ? void 0 : _a2.length) === 0 && /* @__PURE__ */ React71.createElement(Box47, { css: { display: "flex" }, as: "section" }, /* @__PURE__ */ React71.createElement(ParagraphText25, null, formatMessage(
          { id: "NETWORK_MISSING_COVERAGE" },
          { network: plan.networkName }
        ))),
        ((_b = plan == null ? void 0 : plan.network) == null ? void 0 : _b.length) > 0 && /* @__PURE__ */ React71.createElement(StackLayout31, { spacing: "$oneAndHalf" }, plan.network.map(
          (balanceGroup, i) => /* @__PURE__ */ React71.createElement(
            BalanceCategories,
            {
              key: `balance-group-${plan.networkName}-${i}`,
              title: balanceGroup.title,
              description: balanceGroup.description,
              categories: balanceGroup.categories,
              lastUpdated: LAST_UPDATED,
              networkName: plan.networkName,
              onProviderToggle: handleAccordionToggleEvent
            }
          )
        ))
      );
    }))
  ), isNoTabPlan && plans.map((plan) => {
    const LAST_UPDATED = formatMessage(
      { id: "LAST_UPDATED_CARRIER_DATE" },
      {
        date: formatDate(lastUpdated, SHORT_DATE_AND_TIME_FORMAT2),
        carrier: carrierName
      }
    );
    return plan.network.map(
      (balanceGroup, i) => /* @__PURE__ */ React71.createElement(
        BalanceCategories,
        {
          key: `balance-group-${plan}-${i}`,
          title: balanceGroup.title,
          description: balanceGroup.description,
          categories: balanceGroup.categories,
          lastUpdated: LAST_UPDATED,
          onProviderToggle: handleAccordionToggleEvent,
          networkName: plan.networkName
        }
      )
    );
  })));
};

// src/pages/wallet-detail/components/plan-progress/plan-progress-switcher.component.tsx
var PlanProgressSwitcher = () => {
  const { data: isV2BalanceFlag, isLoading } = useFeatureFlagQuery7(
    WALLET_API_FEATURE_FLAGS.WALLET_LIVE_BALANCE_V2
  );
  if (isLoading) {
    return /* @__PURE__ */ React72.createElement(LoadingIndicator11, { inline: true });
  }
  if (!isV2BalanceFlag) {
    return /* @__PURE__ */ React72.createElement(PlanProgressV1, null);
  }
  return /* @__PURE__ */ React72.createElement(PlanProgress, null);
};

// src/pages/wallet-detail/components/plan-progress-and-coverage/plan-progress-and-coverage.component.tsx
var PlanProgressAndCoverage = () => /* @__PURE__ */ React73.createElement(StackLayout32, { spacing: "$twoAndHalf", css: { alignItems: "stretch" } }, /* @__PURE__ */ React73.createElement(PlanProgressSwitcher, null), /* @__PURE__ */ React73.createElement(MedicalCoverage, null));

// src/pages/wallet-detail/utils/get-content-component.util.ts
function getContentComponent(action, status, isNonActivePolicyHiddenFlag) {
  switch (action.system_type) {
    case SYSTEM_TYPES6.CoverageOverview:
      return Overview;
    case SYSTEM_TYPES6.CoverageCategories:
      return Coverage;
    case SYSTEM_TYPES6.UsageOverview:
      return PlanProgressSwitcher;
    case SYSTEM_TYPES6.PlanProgressCoverageOverview:
      return PlanProgressAndCoverage;
    case SYSTEM_TYPES6.ViewDependent:
      return Dependents;
    case SYSTEM_TYPES6.TransactionHistory:
      return Transactions;
    case SYSTEM_TYPES6.LeagueCredit:
      return LeagueCredit;
    case SYSTEM_TYPES6.CardInfo:
      if (status !== CARD_STATUS6.ACTIVE && isNonActivePolicyHiddenFlag) {
        return CardBody;
      }
      return CardDetails;
    case SYSTEM_TYPES6.About:
      return AboutBenefit;
    case SYSTEM_TYPES6.ViewProviderServices: {
      return MedicalCoverage;
    }
    default:
      return CardBody;
  }
}

// src/pages/wallet-detail/hooks/queries/use-wallet-tabs-content-query.hook.ts
function useWalletTabsContentQuery(userId, benefitId) {
  const { data: benefitCard } = useWalletDetailQuery(userId, benefitId);
  const { data: tabs } = useWalletDetailTabsQuery(userId, benefitId);
  const { data: isNonActivePolicyInformationTabHidden } = useFeatureFlagQuery8(
    WALLET_API_FEATURE_FLAGS.IS_NON_ACTIVE_POLICY_INFORMATION_HIDDEN
  );
  const contentPanels = useMemo17(
    () => tabs.map(
      (data) => getContentComponent(
        data,
        benefitCard == null ? void 0 : benefitCard.status,
        isNonActivePolicyInformationTabHidden
      )
    ),
    [tabs, benefitCard == null ? void 0 : benefitCard.status, isNonActivePolicyInformationTabHidden]
  );
  return contentPanels;
}

// src/pages/wallet-detail/components/navigation-tabs/hooks/use-benefit-card-action-tabs.hook.ts
import * as React74 from "react";
function useBenefitCardActionTabs(cardActions) {
  var _a, _b, _c;
  const tabs = cardActions.map((tab, index) => __spreadProps(__spreadValues({}, tab), {
    tabValue: `${tab.name.replaceAll(" ", "-")}-${index}`
  }));
  const defaultTabValue = (_c = (_a = tabs.find((tab) => tab.isDefaultSelected)) == null ? void 0 : _a.tabValue) != null ? _c : (_b = tabs[0]) == null ? void 0 : _b.tabValue;
  const [activeTab, setActiveTab] = React74.useState(defaultTabValue);
  return {
    activeTab: activeTab != null ? activeTab : defaultTabValue,
    setActiveTab,
    tabs
  };
}

// src/pages/wallet-detail/components/navigation-tabs/navigation-tabs.component.tsx
function NavigationTabs() {
  const { userId, benefitId } = useWalletParams();
  const { formatMessage } = useIntl49();
  const { data: tabsData, isLoading } = useWalletDetailTabsQuery(
    userId,
    benefitId
  );
  const contentPanels = useWalletTabsContentQuery(userId, benefitId);
  const sendBenefitAnalyticsEvent = useWalletDetailAnalytics();
  const { tabs, activeTab, setActiveTab } = useBenefitCardActionTabs(tabsData);
  const handleClick = React75.useCallback(
    (value) => {
      const clickedTab = tabs.find((tab) => tab.tabValue === value);
      sendBenefitAnalyticsEvent(EVENT_NAME18.NAVIGATION_TAB_CLICKED, {
        detail: clickedTab == null ? void 0 : clickedTab.name,
        is_notification_dot: clickedTab == null ? void 0 : clickedTab.indicator
      });
      setActiveTab(value);
    },
    [tabs, sendBenefitAnalyticsEvent, setActiveTab]
  );
  if (isLoading || tabs.length === 0) {
    return null;
  }
  if (tabs.length === 1) {
    const TabComponent = contentPanels[0];
    const { body } = tabs[0];
    return /* @__PURE__ */ React75.createElement(TabComponent, { body });
  }
  return /* @__PURE__ */ React75.createElement(Tabs5.Root, { onValueChange: handleClick, value: activeTab }, /* @__PURE__ */ React75.createElement(Tabs5.TabList, { divider: true, tabDistribution: "hugContents" }, tabs.map((tab) => {
    var _a;
    return /* @__PURE__ */ React75.createElement(Tabs5.Tab, { key: tab.tabValue, value: tab.tabValue }, /* @__PURE__ */ React75.createElement(Box48, { as: "span", css: { position: "relative" } }, tab.name, tab.indicator && /* @__PURE__ */ React75.createElement(
      Box48,
      {
        css: {
          display: "block",
          borderRadius: "$circle",
          position: "absolute",
          top: "0",
          insetInlineEnd: "0",
          backgroundColor: "$criticalIcon",
          width: "$half",
          height: "$half",
          transform: "translate(100%, -50%)"
        },
        as: "span",
        id: `${tab.tabValue}-indicator`,
        "aria-label": (_a = tab.indicator_description) != null ? _a : formatMessage({
          id: "DEPENDENT_NOTIFICATION_MESSAGE"
        }),
        "aria-hidden": true
      }
    )));
  })), tabs.map((tab, index) => {
    const TabComponent = contentPanels[index];
    return /* @__PURE__ */ React75.createElement(
      Tabs5.TabPanel,
      {
        css: { paddingBlock: "$oneAndHalf", paddingInline: "$none" },
        key: tab.tabValue,
        value: tab.tabValue
      },
      /* @__PURE__ */ React75.createElement(TabComponent, { body: tab.body })
    );
  }));
}

// src/pages/wallet-detail/components/feedback/feedback.component.tsx
import React76 from "react";
import { FeedbackCard } from "@leagueplatform/web-common-components";
import { EVENT_NAME as EVENT_NAME19 } from "@leagueplatform/analytics";
import { useIntl as useIntl51 } from "@leagueplatform/locales";
import { getTypeformUrl } from "@leagueplatform/web-common";

// src/pages/wallet-detail/components/feedback/utils/get-card-name-from-type.util.ts
var LEAGUE_CREDIT_NAME = "League Credit";
var getCardNameFromType = (cardType) => {
  if (cardType === LEAGUE_CREDIT_TYPE)
    return LEAGUE_CREDIT_NAME;
  return cardType;
};

// src/pages/wallet-detail/hooks/use-benefit-translation-map.util.ts
import { useIntl as useIntl50 } from "@leagueplatform/locales";
function useBenefitTranslationMap() {
  const { $tmap } = useIntl50();
  return $tmap({
    psa: "LIFESTYLE_SPENDING_ACCOUNT",
    hsa: "HEALTH_SPENDING_ACCOUNT",
    hra: "HEALTH_REIMBURSEMENT_ARRANGEMENT",
    healthPlan: "HEALTH_INSURANCE",
    travel: "TRAVEL",
    drugs: "DRUGS",
    promo_code: "LEAGUE_CREDIT",
    medical: "MEDICAL"
  });
}

// src/pages/wallet-detail/components/feedback/feedback.component.tsx
var Feedback = () => {
  const { typeformIds } = useWalletConfig();
  const typeformData = typeformIds ? getTypeformUrl(typeformIds) : null;
  const { userId: urlUserId, benefitId } = useWalletParams();
  const { formatMessage } = useIntl51();
  const { data: benefitCard } = useWalletDetailQuery(urlUserId, benefitId);
  const sendBenefitAnalyticsEvent = useWalletDetailAnalytics();
  const { data: userId } = useUserProfileQuery(urlUserId, {
    select: (data) => data.user_id,
    enabled: !!typeformData
  });
  const groupName = benefitCard == null ? void 0 : benefitCard.provider_name;
  const benefitName = benefitCard ? benefitCard.short_name || benefitCard.full_name || getCardNameFromType(benefitCard.type) : "";
  const benefitTranslationIdMap = useBenefitTranslationMap();
  if (!typeformData) {
    return null;
  }
  const feedbackUrl = `${typeformData.url}?member_id=${userId}&group_name=${groupName}&benefit_name=${benefitName}&platform=web&prefilled_answer=`;
  const nameTranslation = benefitCard ? benefitTranslationIdMap(benefitCard.product_type) : "";
  const subtitle = (benefitCard == null ? void 0 : benefitCard.full_name) ? formatMessage(
    { id: "WALLET_FEEDBACK_SUBTITLE_BENEFIT" },
    {
      benefitName: benefitCard.full_name
    }
  ) : formatMessage(
    { id: "WALLET_FEEDBACK_SUBTITLE_OTHER" },
    {
      cardName: nameTranslation
    }
  );
  return /* @__PURE__ */ React76.createElement(
    FeedbackCard,
    {
      title: formatMessage({ id: "WALLET_FEEDBACK_TITLE" }),
      subtitle,
      feedbackUrl,
      onClick: (number) => {
        sendBenefitAnalyticsEvent(EVENT_NAME19.BUTTON_CLICKED, {
          detail: "likert scale response",
          sub_detail: number,
          form_id: typeformData.id
        });
      }
    }
  );
};

// src/pages/wallet-detail/components/policy-date-range/policy-date-range.component.tsx
import * as React77 from "react";
import { useIntl as useIntl52 } from "@leagueplatform/locales";
import { SHORT_DATE_FORMAT as SHORT_DATE_FORMAT3 } from "@leagueplatform/web-common";
import {
  StackLayout as StackLayout33,
  UtilityText as UtilityText6,
  StackItem as StackItem4
} from "@leagueplatform/genesis-core";
var PolicyDateRange = ({
  endSubmitDate,
  endBalanceDate
}) => {
  const { formatMessage, formatDate } = useIntl52();
  return /* @__PURE__ */ React77.createElement(StackLayout33, { spacing: "$oneAndHalf" }, endBalanceDate && /* @__PURE__ */ React77.createElement(StackItem4, null, /* @__PURE__ */ React77.createElement(
    UtilityText6,
    {
      css: { typography: "$subtitleTwo", marginBottom: "$half" }
    },
    formatMessage({ id: "LAST_DAY_TO_USE_BALANCE" })
  ), /* @__PURE__ */ React77.createElement(UtilityText6, { css: { typography: "$bodyTwo" } }, formatDate(endBalanceDate, __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT3), {
    timeZone: "UTC"
  })))), endSubmitDate && /* @__PURE__ */ React77.createElement(StackItem4, null, /* @__PURE__ */ React77.createElement(
    UtilityText6,
    {
      css: { typography: "$subtitleTwo", marginBottom: "$half" }
    },
    formatMessage({ id: "LAST_DAY_TO_SUBMIT_CLAIMS" })
  ), /* @__PURE__ */ React77.createElement(UtilityText6, { css: { typography: "$bodyTwo" } }, formatDate(endSubmitDate, __spreadProps(__spreadValues({}, SHORT_DATE_FORMAT3), {
    timeZone: "UTC"
  })))));
};

// src/pages/wallet-detail/components/primary-action-link/primary-action-link.component.tsx
import React78 from "react";
import { formatPhoneNumber as formatPhoneNumber2 } from "@leagueplatform/web-common";
import { StackLayout as StackLayout34 } from "@leagueplatform/web-common-components";
import { Button as Button8, TextAction as TextAction3 } from "@leagueplatform/genesis-core";
import { SectionHeader as SectionHeader11 } from "@leagueplatform/genesis-core-alpha";

// src/pages/wallet-detail/hooks/queries/use-wallet-primary-action-query.hook.ts
function useWalletPrimaryActionQuery(userId, benefitId, dependentId) {
  return useWalletDetailQuery(
    userId,
    benefitId,
    dependentId,
    {
      select: (data) => data.primary_action
    }
  );
}

// src/pages/wallet-detail/components/primary-action-link/primary-action-link.component.tsx
var PrimaryActionLink = () => {
  var _a;
  const { userId, benefitId } = useWalletParams();
  const { data: primaryAction } = useWalletPrimaryActionQuery(
    userId,
    benefitId
  );
  const { LinkComponent, handleActionClick } = useActionLink(primaryAction);
  if (!primaryAction) {
    return null;
  }
  const phoneNumber = formatPhoneNumber2((_a = primaryAction.url) == null ? void 0 : _a.replace(/\D/g, ""));
  const isPhoneActionLink = isPhoneNumberAction(primaryAction);
  const { icon_url: icon, nav_icon: secondaryIcon } = primaryAction;
  if (!isPhoneActionLink) {
    return (
      // We are ignoring TS here because genesis-core button makes children required,
      // however for this component children is added in the LinkComponent + action
      // @ts-ignore-next-line
      /* @__PURE__ */ React78.createElement(
        Button8,
        {
          priority: "primary",
          css: {
            textAlign: "center",
            display: "block",
            margin: "0 auto",
            maxWidth: "280px",
            width: "100%",
            borderRadius: "$button",
            color: "$primaryTextDefault",
            "&:hover, &:focus": {
              textDecoration: "none"
            },
            "&&": {
              justifyContent: "center",
              textAlign: "center"
            },
            "> span": {
              flex: "none"
            }
          },
          action: primaryAction,
          as: LinkComponent,
          onClickCallback: handleActionClick,
          primaryIcon: icon,
          secondaryIcon
        }
      )
    );
  }
  return /* @__PURE__ */ React78.createElement(
    StackLayout34,
    {
      css: {
        border: "solid",
        borderColor: "$onSurfaceBorderSubdued",
        padding: "$one",
        borderRadius: "$medium",
        borderWidth: "$thin",
        backgroundColor: "$surfaceBackgroundPrimary"
      }
    },
    /* @__PURE__ */ React78.createElement(
      SectionHeader11,
      {
        headingLevel: "2",
        title: (primaryAction == null ? void 0 : primaryAction.title) || primaryAction.name,
        subtitle: primaryAction == null ? void 0 : primaryAction.description
      }
    ),
    /* @__PURE__ */ React78.createElement(TextAction3, { onClick: handleActionClick, href: primaryAction.url }, (primaryAction == null ? void 0 : primaryAction.title) ? primaryAction.name : phoneNumber)
  );
};

// src/pages/wallet-detail/wallet-detail.component.tsx
var MAX_WIDTH = 1132;
var AnalyticsCallWrapper = ({
  analyticsInfo,
  children
}) => {
  const { userId, benefitId } = useWalletParams();
  const { data: benefitCard } = useWalletDetailQuery(userId, benefitId);
  usePageViewAnalytics3(analyticsInfo, [benefitCard]);
  return /* @__PURE__ */ React79.createElement(React79.Fragment, null, children);
};
var WalletDetail = ({
  currentDate = /* @__PURE__ */ new Date()
}) => {
  var _a;
  const {
    isLoading,
    benefitCard,
    cardStartDate,
    cardEndDate,
    cardInactiveDate,
    formattedStartDate,
    formattedEndDate,
    showBenefitDetailFeedbackComponent,
    useBalanceEndDate,
    submitClaimsEndDate,
    isError,
    error
  } = useWalletDetail();
  const analyticsInfo = {
    title: SCREEN_NAMES7.BENEFIT_PAGE,
    product_area: PRODUCT_AREA8.WALLET,
    benefit_name: (benefitCard == null ? void 0 : benefitCard.title) || (benefitCard == null ? void 0 : benefitCard.full_name),
    benefit_id: benefitCard == null ? void 0 : benefitCard.id,
    vendor_id: benefitCard == null ? void 0 : benefitCard.vendor_id,
    benefit_product_type: benefitCard == null ? void 0 : benefitCard.product_type,
    benefit_source: benefitCard == null ? void 0 : benefitCard.benefit_source
  };
  const goBack = useGoBack(getModulePath4(LEAGUE_MODULE_NAMES4.wallet));
  const {
    isMedicalCardEnabled,
    isError: isErrorMedicalCard,
    error: errorMedicalCard
  } = useMedicalCard();
  const { formatMessage } = useIntl53();
  let title = React79.useMemo(
    () => (benefitCard == null ? void 0 : benefitCard.title) || (benefitCard == null ? void 0 : benefitCard.full_name),
    [benefitCard == null ? void 0 : benefitCard.full_name, benefitCard == null ? void 0 : benefitCard.title]
  );
  const benefitTranslationIdMap = useBenefitTranslationMap();
  if (benefitCard && !title) {
    title = benefitTranslationIdMap(benefitCard.product_type);
  }
  const WALLET_TITLE = formatMessage({ id: "WALLET" });
  const pageTitle = React79.useMemo(
    () => title ? `${WALLET_TITLE} - ${title}` : WALLET_TITLE,
    [title, WALLET_TITLE]
  );
  useDocumentTitle2(pageTitle);
  if (isLoading) {
    return /* @__PURE__ */ React79.createElement(LoadingIndicator12, null);
  }
  const errors = [error, errorMedicalCard];
  if (isError || isErrorMedicalCard) {
    return /* @__PURE__ */ React79.createElement(ErrorState5, { error: errors });
  }
  if (!benefitCard) {
    return /* @__PURE__ */ React79.createElement(
      PageNotFound,
      {
        buttonText: formatMessage(
          { id: "RETURN_TO" },
          { location: WALLET_TITLE }
        ),
        redirectLink: getModulePath4(LEAGUE_MODULE_NAMES4.wallet)
      }
    );
  }
  return /* @__PURE__ */ React79.createElement(MemberSelectorProvider, null, /* @__PURE__ */ React79.createElement(AnalyticsCallWrapper, { analyticsInfo }, /* @__PURE__ */ React79.createElement(WalletPageHeaderBackground, null, /* @__PURE__ */ React79.createElement(Box49, { marginX: "auto", width: "100%", maxWidth: MAX_WIDTH, paddingX: "two" }, /* @__PURE__ */ React79.createElement(
    Flex23,
    {
      position: "relative",
      flexDirection: { _: "column", tablet: "row", laptop: "row" }
    },
    /* @__PURE__ */ React79.createElement(
      BackButtonArrow,
      {
        onClick: (e) => {
          e.preventDefault();
          trackAnalyticsEvent5(EVENT_NAME20.BUTTON_CLICKED, __spreadProps(__spreadValues({}, analyticsInfo), {
            detail: "go back"
          }));
          goBack();
        },
        as: "a",
        href: "#",
        position: "absolute",
        insetInlineStart: {
          _: "none",
          tablet: "minusOneAndHalf",
          desktop: "minusThree"
        },
        top: 0,
        id: "go-back"
      }
    ),
    /* @__PURE__ */ React79.createElement(
      CardDetailSummary,
      {
        title,
        subtitle: benefitCard == null ? void 0 : benefitCard.subtitle,
        planName: benefitCard.plan_name,
        productType: benefitCard.product_type,
        icon: ((_a = benefitCard.benefit_logo) == null ? void 0 : _a.src) || benefitCard.icon_url,
        startDate: formattedStartDate,
        endDate: formattedEndDate
      }
    )
  ))), /* @__PURE__ */ React79.createElement(
    Box49,
    {
      paddingX: "two",
      paddingBottom: "two",
      maxWidth: MAX_WIDTH,
      marginX: "auto",
      width: "100%"
    },
    /* @__PURE__ */ React79.createElement(
      SidebarLayout2,
      {
        sidebarWidth: "280px",
        isSideBarOnRight: true,
        marginTop: "twoAndHalf"
      },
      /* @__PURE__ */ React79.createElement(Box49, null, /* @__PURE__ */ React79.createElement(
        CardStatus,
        {
          status: benefitCard.status,
          currentDate,
          startDate: cardStartDate,
          endDate: cardEndDate,
          inactiveDate: cardInactiveDate
        }
      ), /* @__PURE__ */ React79.createElement(StackLayout35, { space: "$oneAndHalf" }, /* @__PURE__ */ React79.createElement(DetailHeaderBanner, { banners: benefitCard == null ? void 0 : benefitCard.banners }), /* @__PURE__ */ React79.createElement(NavigationTabs, null), /* @__PURE__ */ React79.createElement(
        PolicyDateRange,
        {
          endSubmitDate: submitClaimsEndDate,
          endBalanceDate: useBalanceEndDate
        }
      ))),
      /* @__PURE__ */ React79.createElement(StackLayout35, null, !isMedicalCardEnabled && /* @__PURE__ */ React79.createElement(WalletCard, null), /* @__PURE__ */ React79.createElement(PrimaryActionLink, null), /* @__PURE__ */ React79.createElement(CardDetailQuickActionLinks, null), /* @__PURE__ */ React79.createElement(FaqLinks, { benefitProductType: benefitCard.product_type }))
    ),
    showBenefitDetailFeedbackComponent && /* @__PURE__ */ React79.createElement(Box49, { marginTop: "two" }, /* @__PURE__ */ React79.createElement(Feedback, null))
  )));
};

// src/components/deep-link-wrapper/deep-link-wrapper.component.tsx
import React80 from "react";
import { NavigateLegacy as Navigate } from "@leagueplatform/routing";
import { toastActions as toastActions3, TOAST_STATUS as TOAST_STATUS3 } from "@leagueplatform/toast-messages";
import { LoadingIndicator as LoadingIndicator13 } from "@leagueplatform/web-common-components";

// src/pages/wallet-detail/utils/is-valid-deep-link-id.util.ts
var mongoRegex = /^[a-f0-9]{32}(?:-.*)?$/;
var isMongoId = (id) => mongoRegex.test(id);
function isValidDeepLinkId(benefitId) {
  if (benefitId === "league-credit") {
    return false;
  }
  return !isMongoId(benefitId);
}

// src/pages/wallet-detail/hooks/queries/use-get-wallet-item-id.query.hook.ts
import { useQuery as useQuery15 } from "@tanstack/react-query";
import {
  getWalletItemId,
  GET_WALLET_ITEM_ID_MESSAGE_TYPE
} from "@leagueplatform/wallet-api";
import { captureError as captureError3 } from "@leagueplatform/observability";
function useGetWalletItemIdQuery(userId, deepLinkUrl, options) {
  return useQuery15(
    [GET_WALLET_ITEM_ID_MESSAGE_TYPE, userId, deepLinkUrl],
    () => getWalletItemId(userId, deepLinkUrl),
    __spreadProps(__spreadValues({}, options), {
      onError: (err) => {
        captureError3(err, {
          context: {
            params: {
              deepLinkUrl
            }
          }
        });
        if (options == null ? void 0 : options.onError) {
          options.onError(err);
        }
      }
    })
  );
}

// src/components/deep-link-wrapper/deep-link-wrapper.component.tsx
var DeepLinkWrapper = ({ children }) => {
  const { userId, benefitId = "" } = useWalletParams();
  const isValidDeepLinkId2 = isValidDeepLinkId(benefitId);
  const {
    data: deepLinkId,
    isInitialLoading,
    isError
  } = useGetWalletItemIdQuery(userId, benefitId, {
    select: (deepLinkResponse) => deepLinkResponse.wallet_item_id,
    enabled: isValidDeepLinkId2
  });
  if (isInitialLoading) {
    return /* @__PURE__ */ React80.createElement(LoadingIndicator13, null);
  }
  if (isError) {
    toastActions3.add({
      type: TOAST_STATUS3.ERROR,
      shouldAutoClose: true,
      contentId: "UH_OH_LOOKS_LIKE_SOMETHING_WENT_WRONG"
    });
    return /* @__PURE__ */ React80.createElement(Navigate, { to: "./", replace: true });
  }
  if (deepLinkId && isValidDeepLinkId2) {
    return /* @__PURE__ */ React80.createElement(Navigate, { to: `./${deepLinkId}`, replace: true });
  }
  return children;
};

// src/hooks/use-wallet-mock-data.hook.ts
import { useEffect as useEffect6 } from "react";
import { useQueryClient as useQueryClient2 } from "@tanstack/react-query";
import {
  GET_WALLET_ITEMS_SECTIONED_MESSAGE_TYPE as GET_WALLET_ITEMS_SECTIONED_MESSAGE_TYPE2,
  GET_WALLET_MESSAGE_TYPE as GET_WALLET_MESSAGE_TYPE4,
  walletItemNavigationSectionsMock
} from "@leagueplatform/wallet-api";

// src/pages/wallet-detail/__mocks__/mock-actions.ts
import {
  BENEFIT_CARD_ACTION as BENEFIT_CARD_ACTION3
} from "@leagueplatform/wallet-api";
var overviewActionMock = {
  body: "Overview HTML example",
  font_awesome_icon: {
    icon_path: "",
    name: "info-circle",
    unicode: "f05a"
  },
  name: "Overview",
  system_type: "coverage_overview",
  tag_type: "coverage_overview",
  id: "overview-id",
  type: BENEFIT_CARD_ACTION3.CONTENT,
  banners: {},
  indicator: false
};
var contentActionMock = {
  body: "Instructions HTML example",
  font_awesome_icon: {
    icon_path: "",
    name: "info-circle",
    unicode: "f05a"
  },
  name: "Usage Instructions",
  system_type: "usage_instructions",
  tag_type: "usage_instructions",
  id: "useage-id",
  type: BENEFIT_CARD_ACTION3.CONTENT,
  banners: {},
  indicator: false
};
var primaryExternalActionMock = {
  font_awesome_icon: {
    icon_path: "",
    name: "external-link-alt",
    unicode: "f35d"
  },
  name: "Submit a Claim to Sun Life",
  url: "https://sunlife.ca/member",
  primary: true,
  system_type: "visit_url",
  tag_type: "visit_url",
  id: "primary-action-id",
  type: BENEFIT_CARD_ACTION3.OPEN_URL,
  banners: {},
  indicator: false,
  icon_url: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
};
var phoneActionMock = {
  font_awesome_icon: {
    icon_path: "https://storage.googleapis.com/league_staging_public_static_content/wallet/icons/phone.png",
    name: "phone",
    unicode: "f095"
  },
  name: "Call Sun Life for Support",
  type: BENEFIT_CARD_ACTION3.OPEN_URL,
  title: "Call Primary Title",
  description: "Description for Title",
  url: "tel:1-800-361-6212",
  system_type: "call_phone",
  id: "cell-phone-id",
  banners: {},
  indicator: false,
  icon_url: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
};
var internalActionMock = {
  font_awesome_icon: {
    icon_path: "https://storage.googleapis.com/league_staging_public_static_content/wallet/icons/circle_right_arrow.png",
    name: "internal-link-alt",
    unicode: "f35d"
  },
  name: "Submit Claim",
  type: BENEFIT_CARD_ACTION3.OPEN_URL,
  url: CLAIM_URL,
  system_type: "visit_url",
  id: "external-link-id",
  banners: {},
  indicator: false,
  icon_url: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
};
var benefitDocumentActionMock = {
  font_awesome_icon: {
    icon_path: "https://storage.googleapis.com/league_staging_public_static_content/wallet/icons/book_search.png",
    name: "download",
    unicode: "f019"
  },
  name: "Download the KPMG Handbook",
  type: BENEFIT_CARD_ACTION3.OPEN_URL,
  url: "https://content.league.com/content/5a4fc52495ac1cae4bb630c6ab24a3a3",
  system_type: "benefit_document",
  tag_type: "benefit_document",
  id: "benefit-document-id",
  banners: {},
  indicator: false,
  icon_url: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
};
var externalLinkActionMock = {
  font_awesome_icon: {
    icon_path: "https://storage.googleapis.com/league_staging_public_static_content/wallet/icons/circle_right_arrow.png",
    name: "external-link-alt",
    unicode: "f35d"
  },
  name: "Download the Sun Life iOS App",
  type: BENEFIT_CARD_ACTION3.OPEN_URL,
  url: "https://itunes.apple.com/ca/app/my-sun-life-canada/id453274313?mt=8",
  system_type: "visit_url",
  id: "external-link-id",
  banners: {},
  indicator: false,
  icon_url: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
};
var externalLinkActionNoPassedIconMock = {
  font_awesome_icon: {
    icon_path: "https://storage.googleapis.com/league_staging_public_static_content/wallet/icons/circle_right_arrow.png",
    name: "external-link-alt",
    unicode: "f35d"
  },
  name: "Download the Sun Life iOS App",
  type: BENEFIT_CARD_ACTION3.OPEN_URL,
  url: "https://itunes.apple.com/ca/app/my-sun-life-canada/id453274313?mt=8",
  system_type: "visit_url",
  id: "external-link-id",
  banners: {},
  indicator: false
};
var saveCardActionMock = {
  font_awesome_icon: {
    icon_path: "https://storage.googleapis.com/league_staging_public_static_content/wallet/icons/card.png",
    name: "credit-card",
    unicode: "f09d"
  },
  name: "Save Card",
  type: BENEFIT_CARD_ACTION3.OPEN_URL,
  url: "/member/wallet/6d20e84f6667cad0c8c4366eeeaa72dd-sunlife_insurance_vision/save",
  system_type: "save_card",
  id: "save-card-id",
  banners: {},
  indicator: false,
  icon_url: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
};
var printCardActionMock = {
  id: "print",
  name: "Print Card",
  banners: {},
  indicator: false,
  type: BENEFIT_CARD_ACTION3.OPEN_URL,
  system_type: "print_card"
};
var unavailableActionMock = {
  name: "Coverage Booklet Summary",
  type: BENEFIT_CARD_ACTION3.OPEN_URL,
  url: "",
  font_awesome_icon: {
    name: "book",
    unicode: "f02d",
    icon_path: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
  },
  system_type: "benefit_document",
  tag_type: "benefit_document",
  indicator: false,
  indicator_description: "",
  banners: {},
  unavailable_action: {
    logo_url: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png",
    title: "There's no benefit booklet available",
    description: "<p style='text-align:center'>Please try again later or talk with a member advocate to get help.</p> <p>Don't worry, you're still covered. We're working on getting your plan information to you.</p>",
    phone_number: "123456789"
  },
  icon_url: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
};
var genericContentModalActionMock = {
  name: "Generic Modal",
  type: BENEFIT_CARD_ACTION3.CONTENT,
  system_type: "modal_content",
  url: "",
  body: `<h3>secondary title to show it can handle rich text</h3><p>Lorem ipsum dolor sit amet, <span style="color:hotpink">consectetur adipiscing elit</span>. Maecenas vitae ultricies tellus. Vivamus dapibus vehicula massa eu malesuada. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Praesent fermentum, nulla et dapibus condimentum, dolor dolor tincidunt sem, et semper purus sem in justo. Quisque laoreet non nunc a iaculis. Nunc in dolor fringilla lectus tristique posuere. Etiam accumsan lobortis justo eu pellentesque. Nulla posuere justo tristique turpis ullamcorper lobortis. Sed risus libero, aliquet in ligula vel, dictum placerat <a href="#" target="_blank">dolor</a>.</p>`,
  title: `Modal Title`,
  banners: {},
  indicator: false,
  font_awesome_icon: {
    name: "book",
    unicode: "f02d",
    icon_path: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
  },
  icon_url: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
};
var longGenericContentModalActionMock = {
  name: "Generic Modal With Long Content",
  type: BENEFIT_CARD_ACTION3.CONTENT,
  system_type: "modal_content",
  url: "",
  body: `<h3>secondary title to show it can handle rich text</h3><p>Lorem ipsum dolor sit amet, <span style="color:hotpink">consectetur adipiscing elit</span>. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris non neque nec nibh dignissim commodo. Nulla volutpat accumsan leo, non condimentum purus ornare cursus. Maecenas facilisis sagittis augue vitae volutpat. Donec at eleifend diam. Nullam et ex sollicitudin, dignissim ligula eu, commodo ipsum. Suspendisse vitae purus vel nisi ultrices pulvinar. Vestibulum maximus sapien eu justo tincidunt, a laoreet tellus mollis. Nam hendrerit magna sed lacus porttitor sagittis. Ut sit amet mollis dui, pellentesque euismod massa. Nulla turpis felis, volutpat ac lectus sed, finibus egestas odio.

  Vivamus dapibus lorem a sapien malesuada varius. Nulla facilisi. Sed nec tincidunt lacus. Aliquam pharetra quam tortor, sit amet egestas magna laoreet et. Aenean eu molestie nisi. Maecenas dapibus dolor lorem, luctus fermentum lorem vulputate volutpat. Suspendisse euismod cursus dapibus. Vivamus porttitor ullamcorper massa sit amet dignissim. Fusce quam dui, finibus at gravida sed, imperdiet quis augue. Vestibulum ac ligula eu mauris scelerisque tincidunt non at mauris. Aliquam tempor neque at accumsan tristique. Nullam ac nisi eu ipsum mollis fermentum nec eget magna. Pellentesque cursus tellus at leo vulputate, non lacinia mauris gravida. Sed tincidunt fermentum mollis. Nulla vestibulum nunc lectus, ut molestie diam gravida placerat.

  Nulla et ante congue, gravida orci et, mattis erat. Aliquam aliquet in enim sit amet pretium. Aliquam erat volutpat. Aliquam convallis sollicitudin tincidunt. Vestibulum egestas laoreet interdum. Etiam tincidunt, sapien a cursus tincidunt, lorem felis bibendum diam, vitae auctor odio enim quis mi. Nam metus nisl, rutrum sed aliquam vel, ultrices sit amet est. Vestibulum bibendum lacus vel velit condimentum, quis gravida sem molestie. Donec ac malesuada nulla, at accumsan diam. Nunc at ante non neque fermentum egestas. Fusce ornare, lorem vel mollis dapibus, est enim bibendum diam, at dictum eros ante at risus. Nulla erat lorem, tincidunt in ligula nec, mollis tempus massa. Sed arcu sem, elementum at vulputate ac, vehicula non tellus. Morbi at erat laoreet, aliquam risus a, eleifend odio.

  <a href="#" target="_blank">dolor</a>.</p>`,
  title: `Modal Title`,
  banners: {},
  indicator: false,
  font_awesome_icon: {
    name: "book",
    unicode: "f02d",
    icon_path: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
  },
  icon_url: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
};
var emailLinkActionMock = {
  font_awesome_icon: {
    icon_path: "https://storage.googleapis.com/league_staging_public_static_content/wallet/icons/circle_right_arrow.png",
    name: "external-link-alt",
    unicode: "f35d"
  },
  name: "Download the Sun Life iOS App",
  type: BENEFIT_CARD_ACTION3.OPEN_URL,
  url: "mailto:webmaster@example.com",
  system_type: "visit_url",
  id: "email-link-id",
  banners: {},
  indicator: false,
  icon_url: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
};
var reportCardLostOrStolenActionMock = {
  name: "Report Card Lost or Stolen",
  type: BENEFIT_CARD_ACTION3.CONTENT,
  system_type: "modal_content",
  url: "",
  banners: {},
  indicator: false,
  nav_icon: {
    url: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png",
    alt: "test"
  },
  font_awesome_icon: {
    name: "book",
    unicode: "f02d",
    icon_path: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
  },
  unavailable_action: {
    title: `Report Card Lost or Stolen`,
    description: `<p>If card is lost or stolen, content member services immediately.</p>`,
    phone_number: "123456789"
  }
};
var orderNewCardActionMock = {
  name: "Order New Card",
  type: BENEFIT_CARD_ACTION3.ORDER_CARD,
  system_type: "order_card",
  url: "",
  banners: {},
  indicator: false,
  nav_icon: {
    url: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png",
    alt: "test"
  },
  font_awesome_icon: {
    name: "book",
    unicode: "f02d",
    icon_path: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
  },
  icon_url: "https://storage.googleapis.com/league_testprod_public_static_content/wallet/icons/book_search.png"
};

// src/hooks/use-wallet-mock-data.hook.ts
var futureDate = /* @__PURE__ */ new Date();
futureDate.setHours(futureDate.getHours() + 24);
var queryOptions = { updatedAt: futureDate.getTime() };

// src/wallet.routes.tsx
var WalletRoutes = () => /* @__PURE__ */ React81.createElement(Routes, null, /* @__PURE__ */ React81.createElement(Route, { index: true, element: /* @__PURE__ */ React81.createElement(WalletLandingPage, null) }), /* @__PURE__ */ React81.createElement(
  Route,
  {
    path: ":benefitId/:sectionId/*",
    element: /* @__PURE__ */ React81.createElement(DeepLinkWrapper, null, /* @__PURE__ */ React81.createElement(WalletDetail, null))
  }
), /* @__PURE__ */ React81.createElement(
  Route,
  {
    path: ":benefitId/*",
    element: /* @__PURE__ */ React81.createElement(DeepLinkWrapper, null, /* @__PURE__ */ React81.createElement(WalletDetail, null))
  }
));

// src/index.ts
initModule();
export {
  CLAIM_URL,
  Coverage,
  WalletCard,
  WalletRoutes,
  useWalletQuery
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/wallet'] = window.leagueSDKsPresent['@leagueplatform/wallet'] || [];
    window.leagueSDKsPresent['@leagueplatform/wallet'].push('2.28.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/wallet'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/wallet module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map